var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
(function(global2, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory(require("react"), require("lodash"), require("steamer-browserutils"), require("axios"), require("@tencent/docs-scenario-components-meeting-helper"), require("classnames"), require("react-dom"), require("i18next"), require("@tencent/docs-qrcode")) : typeof define === "function" && define.amd ? define(["react", "lodash", "steamer-browserutils", "axios", "@tencent/docs-scenario-components-meeting-helper", "classnames", "react-dom", "i18next", "@tencent/docs-qrcode"], factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2["presentation-toolbar"] = factory(global2.React, global2.lodash, global2.steamerBrowserutils, global2.axios, global2.MeetingHelper, global2.classNames, global2.require$$3, global2.i18next, global2.QRCode));
})(this, function(React, lodash, steamerBrowserutils, axios, MeetingHelper, classNames, require$$3, i18next, QRCode) {
  "use strict";
  const _interopDefaultLegacy = (e) => e && typeof e === "object" && "default" in e ? e : { default: e };
  function _interopNamespace(e) {
    if (e && e.__esModule)
      return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
    if (e) {
      for (const k in e) {
        if (k !== "default") {
          const d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: () => e[k]
          });
        }
      }
    }
    n.default = e;
    return Object.freeze(n);
  }
  const React__default = /* @__PURE__ */ _interopDefaultLegacy(React);
  const React__namespace = /* @__PURE__ */ _interopNamespace(React);
  const axios__default = /* @__PURE__ */ _interopDefaultLegacy(axios);
  const MeetingHelper__default = /* @__PURE__ */ _interopDefaultLegacy(MeetingHelper);
  const classNames__default = /* @__PURE__ */ _interopDefaultLegacy(classNames);
  const require$$3__default = /* @__PURE__ */ _interopDefaultLegacy(require$$3);
  const i18next__default = /* @__PURE__ */ _interopDefaultLegacy(i18next);
  const QRCode__default = /* @__PURE__ */ _interopDefaultLegacy(QRCode);
  var IPlayerEvent = /* @__PURE__ */ ((IPlayerEvent2) => {
    IPlayerEvent2["Null"] = "Null";
    IPlayerEvent2["Prev"] = "Prev";
    IPlayerEvent2["Next"] = "Next";
    IPlayerEvent2["FullScreen"] = "FullScreen";
    IPlayerEvent2["Exit"] = "Exit";
    IPlayerEvent2["ShowLiveDialog"] = "ShowLiveDialog";
    IPlayerEvent2["ShowMemberList"] = "ShowMemberList";
    IPlayerEvent2["CreateMeeting"] = "CreateMeeting";
    IPlayerEvent2["DissloveMeeting"] = "DissloveMeeting";
    IPlayerEvent2["JoinMeeting"] = "JoinMeeting";
    IPlayerEvent2["QuitMeeting"] = "QuitMeeting";
    IPlayerEvent2["MicrophoneOn"] = "MicrophoneOn";
    IPlayerEvent2["MicrophoneOff"] = "MicrophoneOff";
    IPlayerEvent2["Laser"] = "Laser";
    IPlayerEvent2["NeedNewUserTip"] = "NeedNewUserTip";
    IPlayerEvent2["StartLiving"] = "StartLiving";
    IPlayerEvent2["ShowInvite"] = "ShowInvite";
    IPlayerEvent2["CopyLink"] = "CopyLink";
    IPlayerEvent2["AudienceFlip"] = "AudienceFlip";
    IPlayerEvent2["Mute"] = "Mute";
    IPlayerEvent2["AllMute"] = "AllMute";
    IPlayerEvent2["SyncWithMaster"] = "SyncWithMaster";
    IPlayerEvent2["ShowPopWindow"] = "ShowPopWindow";
    IPlayerEvent2["MeetingLogin"] = "MeetingLogin";
    IPlayerEvent2["ToggleNote"] = "ToggleNote";
    IPlayerEvent2["ZoomIn"] = "ZoomIn";
    IPlayerEvent2["ZoomOut"] = "ZoomOut";
    IPlayerEvent2["ToggleView"] = "ToggleView";
    IPlayerEvent2["OpenPresenterViewWindow"] = "OpenPresenterViewWindow";
    return IPlayerEvent2;
  })(IPlayerEvent || {});
  const ClientReady = "ClientReady";
  const LiveStateChanged = "LiveStateChanged";
  const MemberChanged = "UserChanged";
  const AllowFlipChanged = "AllowFlipChanged";
  var LiveRoleType = /* @__PURE__ */ ((LiveRoleType2) => {
    LiveRoleType2[LiveRoleType2["None"] = 0] = "None";
    LiveRoleType2[LiveRoleType2["Master"] = 1] = "Master";
    LiveRoleType2[LiveRoleType2["Audience"] = 2] = "Audience";
    return LiveRoleType2;
  })(LiveRoleType || {});
  var LiveState = /* @__PURE__ */ ((LiveState2) => {
    LiveState2[LiveState2["None"] = 0] = "None";
    LiveState2[LiveState2["OnAir"] = 1] = "OnAir";
    LiveState2[LiveState2["Pause"] = 2] = "Pause";
    LiveState2[LiveState2["Ended"] = 3] = "Ended";
    return LiveState2;
  })(LiveState || {});
  var DocType = /* @__PURE__ */ ((DocType2) => {
    DocType2[DocType2["unknown"] = -1] = "unknown";
    DocType2[DocType2["doc"] = 0] = "doc";
    DocType2[DocType2["slide"] = 4] = "slide";
    DocType2[DocType2["pdf"] = 6] = "pdf";
    return DocType2;
  })(DocType || {});
  const isDocPublic = (policy) => [2, 3].includes(policy);
  const setMeetingUsersDocAuth = (policy, padId, meetingId) => {
    const params = {
      obj: {
        id: padId,
        type: 2
      },
      message: "%7B%22seq%22%3A%227e91ac7c-311b-403c-ba51-520c75674fee%22%2C%22action%22%3A1%7D",
      policy: policy === 0 ? 1 : policy,
      prompt: 1,
      opt: 1,
      add: [
        {
          userID: meetingId,
          uidSource: 11,
          roleID: 1
        }
      ]
    };
    return axios__default.default.post(`/v2/privilege/set_user?xsrf=${steamerBrowserutils.getCookie("TOK")}`, params);
  };
  const getMeetingEnv = () => {
    const envName = steamerBrowserutils.getCookie("env_name");
    if (!envName || /^release/.test(envName)) {
      return "release";
    }
    if (/prerelease/.test(envName)) {
      return "prerelease";
    }
    return "test";
  };
  const getMeetingParams = () => {
    const meetingEnv = getMeetingEnv();
    const meetingParamsMap = {
      test: {
        sdkId: "16282553643",
        corpId: "200008554"
      },
      prerelease: {
        sdkId: "16310196082",
        corpId: "1400212767"
      },
      release: {
        sdkId: "16272901304",
        corpId: "1400115281"
      }
    };
    return meetingParamsMap[meetingEnv];
  };
  const getPolicyAndIsOwner = () => {
    const { policy, isOwner } = window.clientVars;
    return { policy, isOwner };
  };
  const handleEndPlayTencentMeeting = (docType, padId, docId) => __async(this, null, function* () {
    const { policy, isOwner } = getPolicyAndIsOwner();
    const { sdkId, corpId } = getMeetingParams();
    const meetingHelper = MeetingHelper__default.default.getInstance({ sdkId, corpId });
    const editUrl = `${location.origin}/${DocType[docType]}/${docId}`;
    const middleUrl = `${location.origin}/scenario/meeting-auth.html?redirect_uri=`;
    const presenterUrl = `${editUrl}?login=speaker`;
    const audienceUrl = editUrl;
    try {
      const isInited = yield meetingHelper.checkJsApiConfig();
      if (!isInited) {
        yield meetingHelper.init();
      }
      const { meetingId = "" } = (yield meetingHelper.getCurrMeetingInfo()) || {};
      if (isOwner) {
        yield setMeetingUsersDocAuth(policy, padId, meetingId);
      }
      yield meetingHelper.updateShareUrl({
        presenterUrl: middleUrl + encodeURIComponent(presenterUrl),
        audienceUrl: middleUrl + encodeURIComponent(audienceUrl)
      });
    } catch (err) {
      console.log("endplay error", err);
    }
  });
  const canEnterEditPage = () => {
    const { policy, isOwner } = getPolicyAndIsOwner();
    return isOwner || isDocPublic(policy);
  };
  var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
  function getAugmentedNamespace(n) {
    var f = n.default;
    if (typeof f == "function") {
      var a = function() {
        return f.apply(this, arguments);
      };
      a.prototype = f.prototype;
    } else
      a = {};
    Object.defineProperty(a, "__esModule", { value: true });
    Object.keys(n).forEach(function(k) {
      var d = Object.getOwnPropertyDescriptor(n, k);
      Object.defineProperty(a, k, d.get ? d : {
        enumerable: true,
        get: function() {
          return n[k];
        }
      });
    });
    return a;
  }
  var useMedia$1 = {};
  var util$1 = {};
  Object.defineProperty(util$1, "__esModule", { value: true });
  util$1.isNavigator = util$1.isBrowser = util$1.off = util$1.on = util$1.noop = void 0;
  var noop = function() {
  };
  util$1.noop = noop;
  function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
      obj.addEventListener.apply(obj, args);
    }
  }
  util$1.on = on;
  function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
      obj.removeEventListener.apply(obj, args);
    }
  }
  util$1.off = off;
  util$1.isBrowser = typeof window !== "undefined";
  util$1.isNavigator = typeof navigator !== "undefined";
  Object.defineProperty(useMedia$1, "__esModule", { value: true });
  var react_1 = React__default.default;
  var util_1 = util$1;
  var getInitialState = function(query, defaultState) {
    if (defaultState !== void 0) {
      return defaultState;
    }
    if (util_1.isBrowser) {
      return window.matchMedia(query).matches;
    }
    if (process.env.NODE_ENV !== "production") {
      console.warn("`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches.");
    }
    return false;
  };
  var useMedia = function(query, defaultState) {
    var _a = react_1.useState(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    react_1.useEffect(function() {
      var mounted = true;
      var mql = window.matchMedia(query);
      var onChange = function() {
        if (!mounted) {
          return;
        }
        setState(!!mql.matches);
      };
      mql.addListener(onChange);
      setState(mql.matches);
      return function() {
        mounted = false;
        mql.removeListener(onChange);
      };
    }, [query]);
    return state;
  };
  var _default$5 = useMedia$1.default = useMedia;
  var Divider$1 = {};
  var tslib = { exports: {} };
  (function(module2) {
    var __extends;
    var __assign;
    var __rest;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter;
    var __generator;
    var __exportStar;
    var __values;
    var __read;
    var __spread;
    var __spreadArrays;
    var __spreadArray;
    var __await;
    var __asyncGenerator;
    var __asyncDelegator;
    var __asyncValues;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __classPrivateFieldIn;
    var __createBinding;
    (function(factory) {
      var root2 = typeof commonjsGlobal === "object" ? commonjsGlobal : typeof self === "object" ? self : typeof this === "object" ? this : {};
      {
        factory(createExporter(root2, createExporter(module2.exports)));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root2) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v) {
          return exports2[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p))
            d[p] = b[p];
      };
      __extends = function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      __rest = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
          }
        return t;
      };
      __decorate = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t[0] & 1)
            throw t[1];
          return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n) {
          return function(v) {
            return step([n, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                return t;
              if (y = 0, t)
                op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar = function(m, o) {
        for (var p in m)
          if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
            __createBinding(o, m, p);
      };
      __createBinding = Object.create ? function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m[k];
          } };
        }
        Object.defineProperty(o, k2, desc);
      } : function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o[k2] = m[k];
      };
      __values = function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
          return m.call(o);
        if (o && typeof o.length === "number")
          return {
            next: function() {
              if (o && i >= o.length)
                o = void 0;
              return { value: o && o[i++], done: !o };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read = function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
          return o;
        var i = m.call(o), r, ar = [], e;
        try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r && !r.done && (m = i["return"]))
              m.call(i);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread = function() {
        for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read(arguments[i]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
          s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __spreadArray = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await = function(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
      };
      __asyncGenerator = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i;
        function verb(n) {
          if (g[n])
            i[n] = function(v) {
              return new Promise(function(a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
        }
        function resume(n, v) {
          try {
            step(g[n](v));
          } catch (e) {
            settle(q[0][3], e);
          }
        }
        function step(r) {
          r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator = function(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i[Symbol.iterator] = function() {
          return this;
        }, i;
        function verb(n, f) {
          i[n] = o[n] ? function(v) {
            return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues = function(o) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i);
        function verb(n) {
          i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
      } : function(o, v) {
        o["default"] = v;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, state, kind, f) {
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, state, value, kind, f) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      __classPrivateFieldIn = function(state, receiver) {
        if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
      };
      exporter("__extends", __extends);
      exporter("__assign", __assign);
      exporter("__rest", __rest);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter);
      exporter("__generator", __generator);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values);
      exporter("__read", __read);
      exporter("__spread", __spread);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__spreadArray", __spreadArray);
      exporter("__await", __await);
      exporter("__asyncGenerator", __asyncGenerator);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn);
    });
  })(tslib);
  var Divider = {};
  var createElement = {};
  var attribute = {};
  var version = {};
  var hasRequiredVersion;
  function requireVersion() {
    if (hasRequiredVersion)
      return version;
    hasRequiredVersion = 1;
    Object.defineProperty(version, "__esModule", { value: true });
    version.default = "0.122.1";
    return version;
  }
  var hasRequiredAttribute;
  function requireAttribute() {
    if (hasRequiredAttribute)
      return attribute;
    hasRequiredAttribute = 1;
    Object.defineProperty(attribute, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var version_1 = tslib_12.__importDefault(requireVersion());
    attribute.default = "data-dui-" + version_1.default.replace(/\./g, "-");
    return attribute;
  }
  var helper = {};
  var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
  };
  function isEqual(first, second) {
    if (first === second) {
      return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
      return true;
    }
    return false;
  }
  function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
      return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
      if (!isEqual(newInputs[i], lastInputs[i])) {
        return false;
      }
    }
    return true;
  }
  function memoizeOne(resultFn, isEqual2) {
    if (isEqual2 === void 0) {
      isEqual2 = areInputsEqual;
    }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
      var newArgs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        newArgs[_i] = arguments[_i];
      }
      if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
        return lastResult;
      }
      lastResult = resultFn.apply(this, newArgs);
      calledOnce = true;
      lastThis = this;
      lastArgs = newArgs;
      return lastResult;
    }
    return memoized;
  }
  const memoizeOne_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: memoizeOne
  }, Symbol.toStringTag, { value: "Module" }));
  const require$$6 = /* @__PURE__ */ getAugmentedNamespace(memoizeOne_esm);
  var hasRequiredHelper;
  function requireHelper() {
    if (hasRequiredHelper)
      return helper;
    hasRequiredHelper = 1;
    Object.defineProperty(helper, "__esModule", { value: true });
    helper.createContextValueGetter = helper.shallowEqual = helper.isBrowser = helper.isDom = helper.wrapWithConfigDefaults = helper.inject = helper.assert = helper.isIE = helper.createStringParamFunc = helper.canBeDivided = helper.roundByStep = helper.castInto = helper.nullFn = helper.trueFn = helper.falseFn = helper.emptyFn = void 0;
    var tslib_12 = tslib.exports;
    var memoize_one_1 = tslib_12.__importDefault(require$$6);
    function emptyFn() {
    }
    helper.emptyFn = emptyFn;
    function falseFn() {
      return false;
    }
    helper.falseFn = falseFn;
    function trueFn() {
      return true;
    }
    helper.trueFn = trueFn;
    function nullFn() {
      return null;
    }
    helper.nullFn = nullFn;
    function castInto(value, targetRange) {
      if (value > targetRange[1]) {
        return targetRange[1];
      }
      if (value < targetRange[0]) {
        return targetRange[0];
      }
      return value;
    }
    helper.castInto = castInto;
    function roundByStep(value, step) {
      if (value < 0) {
        return -roundByStep(-value, step);
      }
      var diff = value % step;
      if (diff < step / 2) {
        return value - diff;
      } else {
        return value - diff + step;
      }
    }
    helper.roundByStep = roundByStep;
    function canBeDivided(dividend, divisor) {
      var divideResult = dividend / divisor;
      return divideResult >> 0 === divideResult;
    }
    helper.canBeDivided = canBeDivided;
    function createStringParamFunc(numberParamFunc) {
      return function() {
        var stringValues = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          stringValues[_i] = arguments[_i];
        }
        var numberValues = stringValues.map(function(str) {
          return Number(str);
        });
        return numberParamFunc.apply(void 0, numberValues);
      };
    }
    helper.createStringParamFunc = createStringParamFunc;
    var isIEBrowser;
    function isIE() {
      if (typeof isIEBrowser === "boolean") {
        return isIEBrowser;
      }
      var ua = navigator.userAgent;
      if (/compatible/.test(ua) && /MSIE/.test(ua)) {
        isIEBrowser = true;
      } else if (/Trident/.test(ua) && /rv:11\.0/.test(ua)) {
        isIEBrowser = true;
      } else {
        isIEBrowser = false;
      }
      return isIEBrowser;
    }
    helper.isIE = isIE;
    function assert(condition, errorMessage) {
      if (!condition) {
        console.error(errorMessage);
      }
    }
    helper.assert = assert;
    function inject(originalFn, additionalFn) {
      return function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var result = originalFn.apply(null, args);
        if (result !== false) {
          additionalFn();
        }
        return result;
      };
    }
    helper.inject = inject;
    function wrapWithConfigDefaults(originalFn) {
      var defaultConfig = {};
      function configDefaults(defaults) {
        defaultConfig = defaults;
      }
      var wrappedFn = function(passedConfig) {
        var config = tslib_12.__assign(tslib_12.__assign({}, defaultConfig), passedConfig);
        return originalFn(config);
      };
      wrappedFn.configDefaults = configDefaults;
      return wrappedFn;
    }
    helper.wrapWithConfigDefaults = wrapWithConfigDefaults;
    function isDom(node) {
      return node && typeof node === "object" && node.nodeType === 1;
    }
    helper.isDom = isDom;
    helper.isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
    function shallowEqual(paramA, paramB) {
      if (paramA === paramB) {
        return true;
      }
      if (typeof paramA !== typeof paramB) {
        return false;
      }
      if (typeof paramA !== "object" || paramA === null || typeof paramB !== "object" || paramB === null) {
        return false;
      }
      var keysOfA = Object.keys(paramA);
      var keysOfB = Object.keys(paramB);
      if (keysOfA.length !== keysOfB.length) {
        return false;
      }
      return keysOfA.every(function(key) {
        return paramA[key] === paramB[key];
      });
    }
    helper.shallowEqual = shallowEqual;
    function createContextValueGetter() {
      return memoize_one_1.default(function(context2) {
        return context2;
      }, function(newArgs, lastArgs) {
        return shallowEqual(newArgs[0], lastArgs[0]);
      });
    }
    helper.createContextValueGetter = createContextValueGetter;
    return helper;
  }
  var hasRequiredCreateElement;
  function requireCreateElement() {
    if (hasRequiredCreateElement)
      return createElement;
    hasRequiredCreateElement = 1;
    (function(exports2) {
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.h = exports2.isScopedAttributeDisabled = void 0;
      var tslib_12 = tslib.exports;
      var react_12 = React__default.default;
      var attribute_1 = tslib_12.__importDefault(requireAttribute());
      var helper_1 = requireHelper();
      exports2.isScopedAttributeDisabled = shouldDisableScopedAttribute();
      if (helper_1.isBrowser) {
        window.__dui_disable_auto_focus_map__ = window.__dui_disable_auto_focus_map__ || {};
      }
      function h(type, props) {
        var children = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          children[_i - 2] = arguments[_i];
        }
        var mergedProps = props;
        if ((props === null || props === void 0 ? void 0 : props.className) && typeof type === "string" && !exports2.isScopedAttributeDisabled) {
          mergedProps[attribute_1.default] = props.className;
        }
        return react_12.createElement.apply(void 0, tslib_12.__spreadArray([type, mergedProps], children));
      }
      exports2.h = h;
      function shouldDisableScopedAttribute() {
        var windowDisable;
        if (typeof window === "object") {
          windowDisable = window.__dui_disable_scoped_attribute__;
        }
        var globalDisable;
        if (typeof commonjsGlobal === "object") {
          globalDisable = commonjsGlobal.__dui_disable_scoped_attribute__;
        }
        return Boolean(windowDisable || globalDisable);
      }
    })(createElement);
    return createElement;
  }
  var propTypes = { exports: {} };
  var reactIs = { exports: {} };
  var reactIs_production_min = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var hasRequiredReactIs_production_min;
  function requireReactIs_production_min() {
    if (hasRequiredReactIs_production_min)
      return reactIs_production_min;
    hasRequiredReactIs_production_min = 1;
    var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    reactIs_production_min.AsyncMode = l;
    reactIs_production_min.ConcurrentMode = m;
    reactIs_production_min.ContextConsumer = k;
    reactIs_production_min.ContextProvider = h;
    reactIs_production_min.Element = c;
    reactIs_production_min.ForwardRef = n;
    reactIs_production_min.Fragment = e;
    reactIs_production_min.Lazy = t;
    reactIs_production_min.Memo = r;
    reactIs_production_min.Portal = d;
    reactIs_production_min.Profiler = g;
    reactIs_production_min.StrictMode = f;
    reactIs_production_min.Suspense = p;
    reactIs_production_min.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    reactIs_production_min.isConcurrentMode = A;
    reactIs_production_min.isContextConsumer = function(a) {
      return z(a) === k;
    };
    reactIs_production_min.isContextProvider = function(a) {
      return z(a) === h;
    };
    reactIs_production_min.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    reactIs_production_min.isForwardRef = function(a) {
      return z(a) === n;
    };
    reactIs_production_min.isFragment = function(a) {
      return z(a) === e;
    };
    reactIs_production_min.isLazy = function(a) {
      return z(a) === t;
    };
    reactIs_production_min.isMemo = function(a) {
      return z(a) === r;
    };
    reactIs_production_min.isPortal = function(a) {
      return z(a) === d;
    };
    reactIs_production_min.isProfiler = function(a) {
      return z(a) === g;
    };
    reactIs_production_min.isStrictMode = function(a) {
      return z(a) === f;
    };
    reactIs_production_min.isSuspense = function(a) {
      return z(a) === p;
    };
    reactIs_production_min.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    reactIs_production_min.typeOf = z;
    return reactIs_production_min;
  }
  var reactIs_development = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var hasRequiredReactIs_development;
  function requireReactIs_development() {
    if (hasRequiredReactIs_development)
      return reactIs_development;
    hasRequiredReactIs_development = 1;
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        reactIs_development.AsyncMode = AsyncMode;
        reactIs_development.ConcurrentMode = ConcurrentMode;
        reactIs_development.ContextConsumer = ContextConsumer;
        reactIs_development.ContextProvider = ContextProvider;
        reactIs_development.Element = Element2;
        reactIs_development.ForwardRef = ForwardRef;
        reactIs_development.Fragment = Fragment;
        reactIs_development.Lazy = Lazy;
        reactIs_development.Memo = Memo;
        reactIs_development.Portal = Portal;
        reactIs_development.Profiler = Profiler;
        reactIs_development.StrictMode = StrictMode;
        reactIs_development.Suspense = Suspense;
        reactIs_development.isAsyncMode = isAsyncMode;
        reactIs_development.isConcurrentMode = isConcurrentMode;
        reactIs_development.isContextConsumer = isContextConsumer;
        reactIs_development.isContextProvider = isContextProvider;
        reactIs_development.isElement = isElement;
        reactIs_development.isForwardRef = isForwardRef;
        reactIs_development.isFragment = isFragment;
        reactIs_development.isLazy = isLazy;
        reactIs_development.isMemo = isMemo;
        reactIs_development.isPortal = isPortal;
        reactIs_development.isProfiler = isProfiler;
        reactIs_development.isStrictMode = isStrictMode;
        reactIs_development.isSuspense = isSuspense;
        reactIs_development.isValidElementType = isValidElementType;
        reactIs_development.typeOf = typeOf;
      })();
    }
    return reactIs_development;
  }
  var hasRequiredReactIs;
  function requireReactIs() {
    if (hasRequiredReactIs)
      return reactIs.exports;
    hasRequiredReactIs = 1;
    (function(module2) {
      if (process.env.NODE_ENV === "production") {
        module2.exports = requireReactIs_production_min();
      } else {
        module2.exports = requireReactIs_development();
      }
    })(reactIs);
    return reactIs.exports;
  }
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  var objectAssign;
  var hasRequiredObjectAssign;
  function requireObjectAssign() {
    if (hasRequiredObjectAssign)
      return objectAssign;
    hasRequiredObjectAssign = 1;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty2 = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty2.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
    return objectAssign;
  }
  var ReactPropTypesSecret_1;
  var hasRequiredReactPropTypesSecret;
  function requireReactPropTypesSecret() {
    if (hasRequiredReactPropTypesSecret)
      return ReactPropTypesSecret_1;
    hasRequiredReactPropTypesSecret = 1;
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    ReactPropTypesSecret_1 = ReactPropTypesSecret;
    return ReactPropTypesSecret_1;
  }
  var has;
  var hasRequiredHas;
  function requireHas() {
    if (hasRequiredHas)
      return has;
    hasRequiredHas = 1;
    has = Function.call.bind(Object.prototype.hasOwnProperty);
    return has;
  }
  var checkPropTypes_1;
  var hasRequiredCheckPropTypes;
  function requireCheckPropTypes() {
    if (hasRequiredCheckPropTypes)
      return checkPropTypes_1;
    hasRequiredCheckPropTypes = 1;
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      var ReactPropTypesSecret = requireReactPropTypesSecret();
      var loggedTypeFailures = {};
      var has2 = requireHas();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function checkPropTypes(typeSpecs, values, location2, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has2(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    checkPropTypes_1 = checkPropTypes;
    return checkPropTypes_1;
  }
  var factoryWithTypeCheckers;
  var hasRequiredFactoryWithTypeCheckers;
  function requireFactoryWithTypeCheckers() {
    if (hasRequiredFactoryWithTypeCheckers)
      return factoryWithTypeCheckers;
    hasRequiredFactoryWithTypeCheckers = 1;
    var ReactIs = requireReactIs();
    var assign = requireObjectAssign();
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var has2 = requireHas();
    var checkPropTypes = requireCheckPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS2 = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
          componentName = componentName || ANONYMOUS2;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location2, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location2, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS2;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location2, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has2(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location2, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location2, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location2, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location2, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has2(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol2(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol2(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS2;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    return factoryWithTypeCheckers;
  }
  var factoryWithThrowingShims;
  var hasRequiredFactoryWithThrowingShims;
  function requireFactoryWithThrowingShims() {
    if (hasRequiredFactoryWithThrowingShims)
      return factoryWithThrowingShims;
    hasRequiredFactoryWithThrowingShims = 1;
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    factoryWithThrowingShims = function() {
      function shim(props, propName, componentName, location2, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    return factoryWithThrowingShims;
  }
  var hasRequiredPropTypes;
  function requirePropTypes() {
    if (hasRequiredPropTypes)
      return propTypes.exports;
    hasRequiredPropTypes = 1;
    if (process.env.NODE_ENV !== "production") {
      var ReactIs = requireReactIs();
      var throwOnDirectAccess = true;
      propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      propTypes.exports = requireFactoryWithThrowingShims()();
    }
    return propTypes.exports;
  }
  var context$3 = {};
  var hasRequiredContext$3;
  function requireContext$3() {
    if (hasRequiredContext$3)
      return context$3;
    hasRequiredContext$3 = 1;
    Object.defineProperty(context$3, "__esModule", { value: true });
    context$3.getContextMenuContext = context$3.ContextMenuContext = context$3.getSubMenuContext = context$3.SubMenuContext = context$3.getMenuItemContext = context$3.MenuItemContext = void 0;
    var tslib_12 = tslib.exports;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    context$3.MenuItemContext = React2.createContext({
      itemStyle: void 0,
      clickHandler: helper_1.emptyFn,
      selectedIds: []
    });
    context$3.getMenuItemContext = helper_1.createContextValueGetter();
    context$3.SubMenuContext = React2.createContext({
      zIndex: 1e4,
      visible: true,
      type: "normal",
      horizontalPlacement: "right",
      viewportMargin: 2
    });
    context$3.getSubMenuContext = helper_1.createContextValueGetter();
    context$3.ContextMenuContext = React2.createContext({
      visible: true,
      onClick: helper_1.emptyFn
    });
    context$3.getContextMenuContext = helper_1.createContextValueGetter();
    return context$3;
  }
  var theme = {};
  var dist = { exports: {} };
  var hasRequiredDist;
  function requireDist() {
    if (hasRequiredDist)
      return dist.exports;
    hasRequiredDist = 1;
    (function(module2, exports2) {
      !function(t, n) {
        module2.exports = n();
      }("undefined" != typeof window ? window : commonjsGlobal, function() {
        return function(t) {
          var n = {};
          function e(r) {
            if (n[r])
              return n[r].exports;
            var i = n[r] = { i: r, l: false, exports: {} };
            return t[r].call(i.exports, i, i.exports, e), i.l = true, i.exports;
          }
          return e.m = t, e.c = n, e.d = function(t2, n2, r) {
            e.o(t2, n2) || Object.defineProperty(t2, n2, { enumerable: true, get: r });
          }, e.r = function(t2) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
          }, e.t = function(t2, n2) {
            if (1 & n2 && (t2 = e(t2)), 8 & n2)
              return t2;
            if (4 & n2 && "object" == typeof t2 && t2 && t2.__esModule)
              return t2;
            var r = /* @__PURE__ */ Object.create(null);
            if (e.r(r), Object.defineProperty(r, "default", { enumerable: true, value: t2 }), 2 & n2 && "string" != typeof t2)
              for (var i in t2)
                e.d(r, i, function(n3) {
                  return t2[n3];
                }.bind(null, i));
            return r;
          }, e.n = function(t2) {
            var n2 = t2 && t2.__esModule ? function() {
              return t2.default;
            } : function() {
              return t2;
            };
            return e.d(n2, "a", n2), n2;
          }, e.o = function(t2, n2) {
            return Object.prototype.hasOwnProperty.call(t2, n2);
          }, e.p = "", e(e.s = 73);
        }([function(t, n) {
          var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
          "number" == typeof __g && (__g = e);
        }, function(t, n, e) {
          t.exports = !e(3)(function() {
            return 7 != Object.defineProperty({}, "a", { get: function() {
              return 7;
            } }).a;
          });
        }, function(t, n, e) {
          var r = e(5);
          t.exports = function(t2) {
            if (!r(t2))
              throw TypeError(t2 + " is not an object!");
            return t2;
          };
        }, function(t, n) {
          t.exports = function(t2) {
            try {
              return !!t2();
            } catch (t3) {
              return true;
            }
          };
        }, function(t, n, e) {
          var r = e(18)("wks"), i = e(17), o = e(0).Symbol, u = "function" == typeof o;
          (t.exports = function(t2) {
            return r[t2] || (r[t2] = u && o[t2] || (u ? o : i)("Symbol." + t2));
          }).store = r;
        }, function(t, n) {
          t.exports = function(t2) {
            return "object" == typeof t2 ? null !== t2 : "function" == typeof t2;
          };
        }, function(t, n, e) {
          var r = e(0), i = e(15), o = e(11), u = e(12), c = e(19), s = function(t2, n2, e2) {
            var f, a, l, p, g = t2 & s.F, v = t2 & s.G, h = t2 & s.S, d = t2 & s.P, y = t2 & s.B, x = v ? r : h ? r[n2] || (r[n2] = {}) : (r[n2] || {}).prototype, A = v ? i : i[n2] || (i[n2] = {}), b = A.prototype || (A.prototype = {});
            for (f in v && (e2 = n2), e2)
              l = ((a = !g && x && void 0 !== x[f]) ? x : e2)[f], p = y && a ? c(l, r) : d && "function" == typeof l ? c(Function.call, l) : l, x && u(x, f, l, t2 & s.U), A[f] != l && o(A, f, p), d && b[f] != l && (b[f] = l);
          };
          r.core = i, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
        }, function(t, n, e) {
          var r = e(2), i = e(24), o = e(16), u = Object.defineProperty;
          n.f = e(1) ? Object.defineProperty : function(t2, n2, e2) {
            if (r(t2), n2 = o(n2, true), r(e2), i)
              try {
                return u(t2, n2, e2);
              } catch (t3) {
              }
            if ("get" in e2 || "set" in e2)
              throw TypeError("Accessors not supported!");
            return "value" in e2 && (t2[n2] = e2.value), t2;
          };
        }, function(t, n) {
          var e = {}.toString;
          t.exports = function(t2) {
            return e.call(t2).slice(8, -1);
          };
        }, function(t, n) {
          t.exports = function(t2) {
            if (null == t2)
              throw TypeError("Can't call method on  " + t2);
            return t2;
          };
        }, function(t, n, e) {
          var r = e(14), i = Math.min;
          t.exports = function(t2) {
            return t2 > 0 ? i(r(t2), 9007199254740991) : 0;
          };
        }, function(t, n, e) {
          var r = e(7), i = e(26);
          t.exports = e(1) ? function(t2, n2, e2) {
            return r.f(t2, n2, i(1, e2));
          } : function(t2, n2, e2) {
            return t2[n2] = e2, t2;
          };
        }, function(t, n, e) {
          var r = e(0), i = e(11), o = e(13), u = e(17)("src"), c = e(45), s = ("" + c).split("toString");
          e(15).inspectSource = function(t2) {
            return c.call(t2);
          }, (t.exports = function(t2, n2, e2, c2) {
            var f = "function" == typeof e2;
            f && (o(e2, "name") || i(e2, "name", n2)), t2[n2] !== e2 && (f && (o(e2, u) || i(e2, u, t2[n2] ? "" + t2[n2] : s.join(String(n2)))), t2 === r ? t2[n2] = e2 : c2 ? t2[n2] ? t2[n2] = e2 : i(t2, n2, e2) : (delete t2[n2], i(t2, n2, e2)));
          })(Function.prototype, "toString", function() {
            return "function" == typeof this && this[u] || c.call(this);
          });
        }, function(t, n) {
          var e = {}.hasOwnProperty;
          t.exports = function(t2, n2) {
            return e.call(t2, n2);
          };
        }, function(t, n) {
          var e = Math.ceil, r = Math.floor;
          t.exports = function(t2) {
            return isNaN(t2 = +t2) ? 0 : (t2 > 0 ? r : e)(t2);
          };
        }, function(t, n) {
          var e = t.exports = { version: "2.6.12" };
          "number" == typeof __e && (__e = e);
        }, function(t, n, e) {
          var r = e(5);
          t.exports = function(t2, n2) {
            if (!r(t2))
              return t2;
            var e2, i;
            if (n2 && "function" == typeof (e2 = t2.toString) && !r(i = e2.call(t2)))
              return i;
            if ("function" == typeof (e2 = t2.valueOf) && !r(i = e2.call(t2)))
              return i;
            if (!n2 && "function" == typeof (e2 = t2.toString) && !r(i = e2.call(t2)))
              return i;
            throw TypeError("Can't convert object to primitive value");
          };
        }, function(t, n) {
          var e = 0, r = Math.random();
          t.exports = function(t2) {
            return "Symbol(".concat(void 0 === t2 ? "" : t2, ")_", (++e + r).toString(36));
          };
        }, function(t, n, e) {
          var r = e(15), i = e(0), o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
          (t.exports = function(t2, n2) {
            return o[t2] || (o[t2] = void 0 !== n2 ? n2 : {});
          })("versions", []).push({ version: r.version, mode: e(46) ? "pure" : "global", copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)" });
        }, function(t, n, e) {
          var r = e(27);
          t.exports = function(t2, n2, e2) {
            if (r(t2), void 0 === n2)
              return t2;
            switch (e2) {
              case 1:
                return function(e3) {
                  return t2.call(n2, e3);
                };
              case 2:
                return function(e3, r2) {
                  return t2.call(n2, e3, r2);
                };
              case 3:
                return function(e3, r2, i) {
                  return t2.call(n2, e3, r2, i);
                };
            }
            return function() {
              return t2.apply(n2, arguments);
            };
          };
        }, function(t, n, e) {
          var r = e(30), i = e(9);
          t.exports = function(t2) {
            return r(i(t2));
          };
        }, function(t, n) {
          t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
        }, function(t, n, e) {
          var r = e(9);
          t.exports = function(t2) {
            return Object(r(t2));
          };
        }, function(t, n, e) {
          var r, i, o = e(36), u = RegExp.prototype.exec, c = String.prototype.replace, s = u, f = (r = /a/, i = /b*/g, u.call(r, "a"), u.call(i, "a"), 0 !== r.lastIndex || 0 !== i.lastIndex), a = void 0 !== /()??/.exec("")[1];
          (f || a) && (s = function(t2) {
            var n2, e2, r2, i2, s2 = this;
            return a && (e2 = new RegExp("^" + s2.source + "$(?!\\s)", o.call(s2))), f && (n2 = s2.lastIndex), r2 = u.call(s2, t2), f && r2 && (s2.lastIndex = s2.global ? r2.index + r2[0].length : n2), a && r2 && r2.length > 1 && c.call(r2[0], e2, function() {
              for (i2 = 1; i2 < arguments.length - 2; i2++)
                void 0 === arguments[i2] && (r2[i2] = void 0);
            }), r2;
          }), t.exports = s;
        }, function(t, n, e) {
          t.exports = !e(1) && !e(3)(function() {
            return 7 != Object.defineProperty(e(25)("div"), "a", { get: function() {
              return 7;
            } }).a;
          });
        }, function(t, n, e) {
          var r = e(5), i = e(0).document, o = r(i) && r(i.createElement);
          t.exports = function(t2) {
            return o ? i.createElement(t2) : {};
          };
        }, function(t, n) {
          t.exports = function(t2, n2) {
            return { enumerable: !(1 & t2), configurable: !(2 & t2), writable: !(4 & t2), value: n2 };
          };
        }, function(t, n) {
          t.exports = function(t2) {
            if ("function" != typeof t2)
              throw TypeError(t2 + " is not a function!");
            return t2;
          };
        }, function(t, n, e) {
          var r = e(5), i = e(48).set;
          t.exports = function(t2, n2, e2) {
            var o, u = n2.constructor;
            return u !== e2 && "function" == typeof u && (o = u.prototype) !== e2.prototype && r(o) && i && i(t2, o), t2;
          };
        }, function(t, n, e) {
          var r = e(49), i = e(26), o = e(20), u = e(16), c = e(13), s = e(24), f = Object.getOwnPropertyDescriptor;
          n.f = e(1) ? f : function(t2, n2) {
            if (t2 = o(t2), n2 = u(n2, true), s)
              try {
                return f(t2, n2);
              } catch (t3) {
              }
            if (c(t2, n2))
              return i(!r.f.call(t2, n2), t2[n2]);
          };
        }, function(t, n, e) {
          var r = e(8);
          t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t2) {
            return "String" == r(t2) ? t2.split("") : Object(t2);
          };
        }, function(t, n, e) {
          var r = e(32), i = e(21).concat("length", "prototype");
          n.f = Object.getOwnPropertyNames || function(t2) {
            return r(t2, i);
          };
        }, function(t, n, e) {
          var r = e(13), i = e(20), o = e(50)(false), u = e(34)("IE_PROTO");
          t.exports = function(t2, n2) {
            var e2, c = i(t2), s = 0, f = [];
            for (e2 in c)
              e2 != u && r(c, e2) && f.push(e2);
            for (; n2.length > s; )
              r(c, e2 = n2[s++]) && (~o(f, e2) || f.push(e2));
            return f;
          };
        }, function(t, n, e) {
          var r = e(14), i = Math.max, o = Math.min;
          t.exports = function(t2, n2) {
            return (t2 = r(t2)) < 0 ? i(t2 + n2, 0) : o(t2, n2);
          };
        }, function(t, n, e) {
          var r = e(18)("keys"), i = e(17);
          t.exports = function(t2) {
            return r[t2] || (r[t2] = i(t2));
          };
        }, function(t, n, e) {
          var r = e(5), i = e(8), o = e(4)("match");
          t.exports = function(t2) {
            var n2;
            return r(t2) && (void 0 !== (n2 = t2[o]) ? !!n2 : "RegExp" == i(t2));
          };
        }, function(t, n, e) {
          var r = e(2);
          t.exports = function() {
            var t2 = r(this), n2 = "";
            return t2.global && (n2 += "g"), t2.ignoreCase && (n2 += "i"), t2.multiline && (n2 += "m"), t2.unicode && (n2 += "u"), t2.sticky && (n2 += "y"), n2;
          };
        }, function(t, n, e) {
          var r = e(53)(true);
          t.exports = function(t2, n2, e2) {
            return n2 + (e2 ? r(t2, n2).length : 1);
          };
        }, function(t, n, e) {
          var r = e(54), i = RegExp.prototype.exec;
          t.exports = function(t2, n2) {
            var e2 = t2.exec;
            if ("function" == typeof e2) {
              var o = e2.call(t2, n2);
              if ("object" != typeof o)
                throw new TypeError("RegExp exec method returned something other than an Object or null");
              return o;
            }
            if ("RegExp" !== r(t2))
              throw new TypeError("RegExp#exec called on incompatible receiver");
            return i.call(t2, n2);
          };
        }, function(t, n, e) {
          e(55);
          var r = e(12), i = e(11), o = e(3), u = e(9), c = e(4), s = e(23), f = c("species"), a = !o(function() {
            var t2 = /./;
            return t2.exec = function() {
              var t3 = [];
              return t3.groups = { a: "7" }, t3;
            }, "7" !== "".replace(t2, "$<a>");
          }), l = function() {
            var t2 = /(?:)/, n2 = t2.exec;
            t2.exec = function() {
              return n2.apply(this, arguments);
            };
            var e2 = "ab".split(t2);
            return 2 === e2.length && "a" === e2[0] && "b" === e2[1];
          }();
          t.exports = function(t2, n2, e2) {
            var p = c(t2), g = !o(function() {
              var n3 = {};
              return n3[p] = function() {
                return 7;
              }, 7 != ""[t2](n3);
            }), v = g ? !o(function() {
              var n3 = false, e3 = /a/;
              return e3.exec = function() {
                return n3 = true, null;
              }, "split" === t2 && (e3.constructor = {}, e3.constructor[f] = function() {
                return e3;
              }), e3[p](""), !n3;
            }) : void 0;
            if (!g || !v || "replace" === t2 && !a || "split" === t2 && !l) {
              var h = /./[p], d = e2(u, p, ""[t2], function(t3, n3, e3, r2, i2) {
                return n3.exec === s ? g && !i2 ? { done: true, value: h.call(n3, e3, r2) } : { done: true, value: t3.call(e3, n3, r2) } : { done: false };
              }), y = d[0], x = d[1];
              r(String.prototype, t2, y), i(RegExp.prototype, p, 2 == n2 ? function(t3, n3) {
                return x.call(t3, this, n3);
              } : function(t3) {
                return x.call(t3, this);
              });
            }
          };
        }, function(t, n, e) {
          var r = e(19), i = e(30), o = e(22), u = e(10), c = e(57);
          t.exports = function(t2, n2) {
            var e2 = 1 == t2, s = 2 == t2, f = 3 == t2, a = 4 == t2, l = 6 == t2, p = 5 == t2 || l, g = n2 || c;
            return function(n3, c2, v) {
              for (var h, d, y = o(n3), x = i(y), A = r(c2, v, 3), b = u(x.length), m = 0, w = e2 ? g(n3, b) : s ? g(n3, 0) : void 0; b > m; m++)
                if ((p || m in x) && (d = A(h = x[m], m, y), t2)) {
                  if (e2)
                    w[m] = d;
                  else if (d)
                    switch (t2) {
                      case 3:
                        return true;
                      case 5:
                        return h;
                      case 6:
                        return m;
                      case 2:
                        w.push(h);
                    }
                  else if (a)
                    return false;
                }
              return l ? -1 : f || a ? a : w;
            };
          };
        }, function(t, n, e) {
          var r = e(4)("unscopables"), i = Array.prototype;
          null == i[r] && e(11)(i, r, {}), t.exports = function(t2) {
            i[r][t2] = true;
          };
        }, function(t, n) {
          t.exports = function(t2, n2) {
            if (!(t2 instanceof n2))
              throw new TypeError("Cannot call a class as a function");
          }, t.exports.__esModule = true, t.exports.default = t.exports;
        }, function(t, n) {
          function e(t2, n2) {
            for (var e2 = 0; e2 < n2.length; e2++) {
              var r = n2[e2];
              r.enumerable = r.enumerable || false, r.configurable = true, "value" in r && (r.writable = true), Object.defineProperty(t2, r.key, r);
            }
          }
          t.exports = function(t2, n2, r) {
            return n2 && e(t2.prototype, n2), r && e(t2, r), Object.defineProperty(t2, "prototype", { writable: false }), t2;
          }, t.exports.__esModule = true, t.exports.default = t.exports;
        }, function(t, n, e) {
          var r = e(6);
          r(r.S + r.F * !e(1), "Object", { defineProperty: e(7).f });
        }, function(t, n, e) {
          t.exports = e(18)("native-function-to-string", Function.toString);
        }, function(t, n) {
          t.exports = false;
        }, function(t, n, e) {
          var r = e(0), i = e(28), o = e(7).f, u = e(31).f, c = e(35), s = e(36), f = r.RegExp, a = f, l = f.prototype, p = /a/g, g = /a/g, v = new f(p) !== p;
          if (e(1) && (!v || e(3)(function() {
            return g[e(4)("match")] = false, f(p) != p || f(g) == g || "/a/i" != f(p, "i");
          }))) {
            f = function(t2, n2) {
              var e2 = this instanceof f, r2 = c(t2), o2 = void 0 === n2;
              return !e2 && r2 && t2.constructor === f && o2 ? t2 : i(v ? new a(r2 && !o2 ? t2.source : t2, n2) : a((r2 = t2 instanceof f) ? t2.source : t2, r2 && o2 ? s.call(t2) : n2), e2 ? this : l, f);
            };
            for (var h = function(t2) {
              t2 in f || o(f, t2, { configurable: true, get: function() {
                return a[t2];
              }, set: function(n2) {
                a[t2] = n2;
              } });
            }, d = u(a), y = 0; d.length > y; )
              h(d[y++]);
            l.constructor = f, f.prototype = l, e(12)(r, "RegExp", f);
          }
          e(51)("RegExp");
        }, function(t, n, e) {
          var r = e(5), i = e(2), o = function(t2, n2) {
            if (i(t2), !r(n2) && null !== n2)
              throw TypeError(n2 + ": can't set as prototype!");
          };
          t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(t2, n2, r2) {
            try {
              (r2 = e(19)(Function.call, e(29).f(Object.prototype, "__proto__").set, 2))(t2, []), n2 = !(t2 instanceof Array);
            } catch (t3) {
              n2 = true;
            }
            return function(t3, e2) {
              return o(t3, e2), n2 ? t3.__proto__ = e2 : r2(t3, e2), t3;
            };
          }({}, false) : void 0), check: o };
        }, function(t, n) {
          n.f = {}.propertyIsEnumerable;
        }, function(t, n, e) {
          var r = e(20), i = e(10), o = e(33);
          t.exports = function(t2) {
            return function(n2, e2, u) {
              var c, s = r(n2), f = i(s.length), a = o(u, f);
              if (t2 && e2 != e2) {
                for (; f > a; )
                  if ((c = s[a++]) != c)
                    return true;
              } else
                for (; f > a; a++)
                  if ((t2 || a in s) && s[a] === e2)
                    return t2 || a || 0;
              return !t2 && -1;
            };
          };
        }, function(t, n, e) {
          var r = e(0), i = e(7), o = e(1), u = e(4)("species");
          t.exports = function(t2) {
            var n2 = r[t2];
            o && n2 && !n2[u] && i.f(n2, u, { configurable: true, get: function() {
              return this;
            } });
          };
        }, function(t, n, e) {
          var r = e(2), i = e(22), o = e(10), u = e(14), c = e(37), s = e(38), f = Math.max, a = Math.min, l = Math.floor, p = /\$([$&`']|\d\d?|<[^>]*>)/g, g = /\$([$&`']|\d\d?)/g;
          e(39)("replace", 2, function(t2, n2, e2, v) {
            return [function(r2, i2) {
              var o2 = t2(this), u2 = null == r2 ? void 0 : r2[n2];
              return void 0 !== u2 ? u2.call(r2, o2, i2) : e2.call(String(o2), r2, i2);
            }, function(t3, n3) {
              var i2 = v(e2, t3, this, n3);
              if (i2.done)
                return i2.value;
              var l2 = r(t3), p2 = String(this), g2 = "function" == typeof n3;
              g2 || (n3 = String(n3));
              var d = l2.global;
              if (d) {
                var y = l2.unicode;
                l2.lastIndex = 0;
              }
              for (var x = []; ; ) {
                var A = s(l2, p2);
                if (null === A)
                  break;
                if (x.push(A), !d)
                  break;
                "" === String(A[0]) && (l2.lastIndex = c(p2, o(l2.lastIndex), y));
              }
              for (var b, m = "", w = 0, k = 0; k < x.length; k++) {
                A = x[k];
                for (var E = String(A[0]), O = f(a(u(A.index), p2.length), 0), S = [], _ = 1; _ < A.length; _++)
                  S.push(void 0 === (b = A[_]) ? b : String(b));
                var M = A.groups;
                if (g2) {
                  var P = [E].concat(S, O, p2);
                  void 0 !== M && P.push(M);
                  var T = String(n3.apply(void 0, P));
                } else
                  T = h(E, p2, O, S, M, n3);
                O >= w && (m += p2.slice(w, O) + T, w = O + E.length);
              }
              return m + p2.slice(w);
            }];
            function h(t3, n3, r2, o2, u2, c2) {
              var s2 = r2 + t3.length, f2 = o2.length, a2 = g;
              return void 0 !== u2 && (u2 = i(u2), a2 = p), e2.call(c2, a2, function(e3, i2) {
                var c3;
                switch (i2.charAt(0)) {
                  case "$":
                    return "$";
                  case "&":
                    return t3;
                  case "`":
                    return n3.slice(0, r2);
                  case "'":
                    return n3.slice(s2);
                  case "<":
                    c3 = u2[i2.slice(1, -1)];
                    break;
                  default:
                    var a3 = +i2;
                    if (0 === a3)
                      return e3;
                    if (a3 > f2) {
                      var p2 = l(a3 / 10);
                      return 0 === p2 ? e3 : p2 <= f2 ? void 0 === o2[p2 - 1] ? i2.charAt(1) : o2[p2 - 1] + i2.charAt(1) : e3;
                    }
                    c3 = o2[a3 - 1];
                }
                return void 0 === c3 ? "" : c3;
              });
            }
          });
        }, function(t, n, e) {
          var r = e(14), i = e(9);
          t.exports = function(t2) {
            return function(n2, e2) {
              var o, u, c = String(i(n2)), s = r(e2), f = c.length;
              return s < 0 || s >= f ? t2 ? "" : void 0 : (o = c.charCodeAt(s)) < 55296 || o > 56319 || s + 1 === f || (u = c.charCodeAt(s + 1)) < 56320 || u > 57343 ? t2 ? c.charAt(s) : o : t2 ? c.slice(s, s + 2) : u - 56320 + (o - 55296 << 10) + 65536;
            };
          };
        }, function(t, n, e) {
          var r = e(8), i = e(4)("toStringTag"), o = "Arguments" == r(function() {
            return arguments;
          }());
          t.exports = function(t2) {
            var n2, e2, u;
            return void 0 === t2 ? "Undefined" : null === t2 ? "Null" : "string" == typeof (e2 = function(t3, n3) {
              try {
                return t3[n3];
              } catch (t4) {
              }
            }(n2 = Object(t2), i)) ? e2 : o ? r(n2) : "Object" == (u = r(n2)) && "function" == typeof n2.callee ? "Arguments" : u;
          };
        }, function(t, n, e) {
          var r = e(23);
          e(6)({ target: "RegExp", proto: true, forced: r !== /./.exec }, { exec: r });
        }, function(t, n, e) {
          var r = e(6), i = e(40)(1);
          r(r.P + r.F * !e(60)([].map, true), "Array", { map: function(t2) {
            return i(this, t2, arguments[1]);
          } });
        }, function(t, n, e) {
          var r = e(58);
          t.exports = function(t2, n2) {
            return new (r(t2))(n2);
          };
        }, function(t, n, e) {
          var r = e(5), i = e(59), o = e(4)("species");
          t.exports = function(t2) {
            var n2;
            return i(t2) && ("function" != typeof (n2 = t2.constructor) || n2 !== Array && !i(n2.prototype) || (n2 = void 0), r(n2) && null === (n2 = n2[o]) && (n2 = void 0)), void 0 === n2 ? Array : n2;
          };
        }, function(t, n, e) {
          var r = e(8);
          t.exports = Array.isArray || function(t2) {
            return "Array" == r(t2);
          };
        }, function(t, n, e) {
          var r = e(3);
          t.exports = function(t2, n2) {
            return !!t2 && r(function() {
              n2 ? t2.call(null, function() {
              }, 1) : t2.call(null);
            });
          };
        }, function(t, n, e) {
          var r = e(35), i = e(2), o = e(62), u = e(37), c = e(10), s = e(38), f = e(23), a = e(3), l = Math.min, p = [].push, g = "length", v = !a(function() {
          });
          e(39)("split", 2, function(t2, n2, e2, a2) {
            var h;
            return h = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[g] || 2 != "ab".split(/(?:ab)*/)[g] || 4 != ".".split(/(.?)(.?)/)[g] || ".".split(/()()/)[g] > 1 || "".split(/.?/)[g] ? function(t3, n3) {
              var i2 = String(this);
              if (void 0 === t3 && 0 === n3)
                return [];
              if (!r(t3))
                return e2.call(i2, t3, n3);
              for (var o2, u2, c2, s2 = [], a3 = (t3.ignoreCase ? "i" : "") + (t3.multiline ? "m" : "") + (t3.unicode ? "u" : "") + (t3.sticky ? "y" : ""), l2 = 0, v2 = void 0 === n3 ? 4294967295 : n3 >>> 0, h2 = new RegExp(t3.source, a3 + "g"); (o2 = f.call(h2, i2)) && !((u2 = h2.lastIndex) > l2 && (s2.push(i2.slice(l2, o2.index)), o2[g] > 1 && o2.index < i2[g] && p.apply(s2, o2.slice(1)), c2 = o2[0][g], l2 = u2, s2[g] >= v2)); )
                h2.lastIndex === o2.index && h2.lastIndex++;
              return l2 === i2[g] ? !c2 && h2.test("") || s2.push("") : s2.push(i2.slice(l2)), s2[g] > v2 ? s2.slice(0, v2) : s2;
            } : "0".split(void 0, 0)[g] ? function(t3, n3) {
              return void 0 === t3 && 0 === n3 ? [] : e2.call(this, t3, n3);
            } : e2, [function(e3, r2) {
              var i2 = t2(this), o2 = null == e3 ? void 0 : e3[n2];
              return void 0 !== o2 ? o2.call(e3, i2, r2) : h.call(String(i2), e3, r2);
            }, function(t3, n3) {
              var r2 = a2(h, t3, this, n3, h !== e2);
              if (r2.done)
                return r2.value;
              var f2 = i(t3), p2 = String(this), g2 = o(f2, RegExp), d = f2.unicode, y = (f2.ignoreCase ? "i" : "") + (f2.multiline ? "m" : "") + (f2.unicode ? "u" : "") + (v ? "y" : "g"), x = new g2(v ? f2 : "^(?:" + f2.source + ")", y), A = void 0 === n3 ? 4294967295 : n3 >>> 0;
              if (0 === A)
                return [];
              if (0 === p2.length)
                return null === s(x, p2) ? [p2] : [];
              for (var b = 0, m = 0, w = []; m < p2.length; ) {
                x.lastIndex = v ? m : 0;
                var k, E = s(x, v ? p2 : p2.slice(m));
                if (null === E || (k = l(c(x.lastIndex + (v ? 0 : m)), p2.length)) === b)
                  m = u(p2, m, d);
                else {
                  if (w.push(p2.slice(b, m)), w.length === A)
                    return w;
                  for (var O = 1; O <= E.length - 1; O++)
                    if (w.push(E[O]), w.length === A)
                      return w;
                  m = b = k;
                }
              }
              return w.push(p2.slice(b)), w;
            }];
          });
        }, function(t, n, e) {
          var r = e(2), i = e(27), o = e(4)("species");
          t.exports = function(t2, n2) {
            var e2, u = r(t2).constructor;
            return void 0 === u || null == (e2 = r(u)[o]) ? n2 : i(e2);
          };
        }, function(t, n, e) {
          var r = e(0), i = e(13), o = e(8), u = e(28), c = e(16), s = e(3), f = e(31).f, a = e(29).f, l = e(7).f, p = e(64).trim, g = r.Number, v = g, h = g.prototype, d = "Number" == o(e(66)(h)), y = "trim" in String.prototype, x = function(t2) {
            var n2 = c(t2, false);
            if ("string" == typeof n2 && n2.length > 2) {
              var e2, r2, i2, o2 = (n2 = y ? n2.trim() : p(n2, 3)).charCodeAt(0);
              if (43 === o2 || 45 === o2) {
                if (88 === (e2 = n2.charCodeAt(2)) || 120 === e2)
                  return NaN;
              } else if (48 === o2) {
                switch (n2.charCodeAt(1)) {
                  case 66:
                  case 98:
                    r2 = 2, i2 = 49;
                    break;
                  case 79:
                  case 111:
                    r2 = 8, i2 = 55;
                    break;
                  default:
                    return +n2;
                }
                for (var u2, s2 = n2.slice(2), f2 = 0, a2 = s2.length; f2 < a2; f2++)
                  if ((u2 = s2.charCodeAt(f2)) < 48 || u2 > i2)
                    return NaN;
                return parseInt(s2, r2);
              }
            }
            return +n2;
          };
          if (!g(" 0o1") || !g("0b1") || g("+0x1")) {
            g = function(t2) {
              var n2 = arguments.length < 1 ? 0 : t2, e2 = this;
              return e2 instanceof g && (d ? s(function() {
                h.valueOf.call(e2);
              }) : "Number" != o(e2)) ? u(new v(x(n2)), e2, g) : x(n2);
            };
            for (var A, b = e(1) ? f(v) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), m = 0; b.length > m; m++)
              i(v, A = b[m]) && !i(g, A) && l(g, A, a(v, A));
            g.prototype = h, h.constructor = g, e(12)(r, "Number", g);
          }
        }, function(t, n, e) {
          var r = e(6), i = e(9), o = e(3), u = e(65), c = "[" + u + "]", s = RegExp("^" + c + c + "*"), f = RegExp(c + c + "*$"), a = function(t2, n2, e2) {
            var i2 = {}, c2 = o(function() {
              return !!u[t2]() || "\u200B\x85" != "\u200B\x85"[t2]();
            }), s2 = i2[t2] = c2 ? n2(l) : u[t2];
            e2 && (i2[e2] = s2), r(r.P + r.F * c2, "String", i2);
          }, l = a.trim = function(t2, n2) {
            return t2 = String(i(t2)), 1 & n2 && (t2 = t2.replace(s, "")), 2 & n2 && (t2 = t2.replace(f, "")), t2;
          };
          t.exports = a;
        }, function(t, n) {
          t.exports = "	\n\v\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        }, function(t, n, e) {
          var r = e(2), i = e(67), o = e(21), u = e(34)("IE_PROTO"), c = function() {
          }, s = function() {
            var t2, n2 = e(25)("iframe"), r2 = o.length;
            for (n2.style.display = "none", e(69).appendChild(n2), n2.src = "javascript:", (t2 = n2.contentWindow.document).open(), t2.write("<script>document.F=Object<\/script>"), t2.close(), s = t2.F; r2--; )
              delete s.prototype[o[r2]];
            return s();
          };
          t.exports = Object.create || function(t2, n2) {
            var e2;
            return null !== t2 ? (c.prototype = r(t2), e2 = new c(), c.prototype = null, e2[u] = t2) : e2 = s(), void 0 === n2 ? e2 : i(e2, n2);
          };
        }, function(t, n, e) {
          var r = e(7), i = e(2), o = e(68);
          t.exports = e(1) ? Object.defineProperties : function(t2, n2) {
            i(t2);
            for (var e2, u = o(n2), c = u.length, s = 0; c > s; )
              r.f(t2, e2 = u[s++], n2[e2]);
            return t2;
          };
        }, function(t, n, e) {
          var r = e(32), i = e(21);
          t.exports = Object.keys || function(t2) {
            return r(t2, i);
          };
        }, function(t, n, e) {
          var r = e(0).document;
          t.exports = r && r.documentElement;
        }, function(t, n, e) {
          var r = e(6), i = e(40)(5), o = true;
          "find" in [] && Array(1).find(function() {
            o = false;
          }), r(r.P + r.F * o, "Array", { find: function(t2) {
            return i(this, t2, arguments.length > 1 ? arguments[1] : void 0);
          } }), e(41)("find");
        }, function(t, n, e) {
          var r = e(6);
          r(r.P, "Array", { fill: e(72) }), e(41)("fill");
        }, function(t, n, e) {
          var r = e(22), i = e(33), o = e(10);
          t.exports = function(t2) {
            for (var n2 = r(this), e2 = o(n2.length), u = arguments.length, c = i(u > 1 ? arguments[1] : void 0, e2), s = u > 2 ? arguments[2] : void 0, f = void 0 === s ? e2 : i(s, e2); f > c; )
              n2[c++] = t2;
            return n2;
          };
        }, function(t, n, e) {
          e.r(n), e.d(n, "getVersionFromUA", function() {
            return l;
          }), e.d(n, "compareVersion", function() {
            return a;
          }), e.d(n, "UserAgent", function() {
            return Ft;
          });
          var r = e(42), i = e.n(r), o = e(43), u = e.n(o), c = (e(44), e(47), e(52), e(56), e(61), e(63), e(70), e(71), /\d+([._]\d+)*/);
          function s(t2) {
            var n2, e2 = c.exec(t2);
            return null !== (n2 = null == e2 ? void 0 : e2[0].replace(/_/g, ".")) && void 0 !== n2 ? n2 : null;
          }
          function f(t2) {
            var n2 = s(t2);
            return (null == n2 ? void 0 : n2.split(".").map(Number)) || [];
          }
          function a(t2, n2) {
            return e2 = f(t2), r2 = f(n2), (i2 = Array(Math.max(e2.length, r2.length)).fill(0).map(function(t3, n3) {
              return (e2[n3] || 0) - (r2[n3] || 0);
            }).find(function(t3) {
              return 0 !== t3;
            }) || 0) < 0 ? -1 : i2 > 0 ? 1 : 0;
            var e2, r2, i2;
          }
          function l(t2, n2) {
            var e2;
            try {
              e2 = new RegExp("\\b".concat(t2, "\\W+\\d+([\\._]\\d+)*"), "i");
            } catch (t3) {
              return null;
            }
            var r2 = e2.exec(n2);
            return r2 ? s(r2[0].substring(t2.length)) : null;
          }
          var p = function() {
            var t2;
            return function() {
              return void 0 === t2 && (t2 = "undefined" != typeof navigator ? navigator.userAgent : ""), t2;
            };
          }();
          function g(t2) {
            return function(n2) {
              return t2(n2 || p());
            };
          }
          function v(t2) {
            return function(n2, e2) {
              return t2(e2 || p(), n2);
            };
          }
          var h = g(function(t2) {
            return /(mobile)/i.test(t2) || b(t2);
          }), d = g(function(t2) {
            return /(mobile)/i.test(t2) && !x(t2);
          }), y = g(function(t2) {
            return /(iphone)/i.test(t2);
          }), x = g(function(t2) {
            return /(ipad)/i.test(t2);
          }), A = g(function(t2) {
            return /(mobile)/i.test(t2) && E(t2);
          }), b = g(function(t2) {
            return !/(mobile)/i.test(t2) && E(t2);
          }), m = g(function(t2) {
            return !h(t2);
          }), w = g(function(t2) {
            return !h(t2) && /Mac OS X/i.test(t2);
          }), k = g(function(t2) {
            return w(t2) && navigator.maxTouchPoints > 1;
          }), E = g(function(t2) {
            return /android|adr/i.test(t2);
          }), O = g(function(t2) {
            return E(t2) ? l("Android", t2) : null;
          }), S = v(function(t2, n2) {
            return a(O(t2) || "", n2) >= 0;
          }), _ = g(function(t2) {
            return /(iphone|ipad|ipod)/i.test(t2);
          }), M = g(function(t2) {
            return _(t2) ? l("OS", t2) : null;
          }), P = v(function(t2, n2) {
            return a(M(t2) || "", n2) >= 0;
          }), T = g(function(t2) {
            return /(win64|wow64|win32|wow32|windows nt)/i.test(t2);
          }), I = g(function(t2) {
            return /MSAppHost/i.test(t2);
          }), Q = g(function(t2) {
            return /linux/i.test(t2) && !E(t2);
          }), C = g(function(t2) {
            return /linux-kylin/i.test(t2);
          }), j = g(function(t2) {
            return /linux-uos/i.test(t2);
          }), V = g(function(t2) {
            return !h(t2) && /QQBrowser/i.test(t2) && !/QBCore/i.test(t2);
          }), W = g(function(t2) {
            return V(t2) ? l("QQBrowser", t2) : null;
          }), F = v(function(t2, n2) {
            return a(W(t2) || "", n2) >= 0;
          }), N = g(function(t2) {
            return h(t2) && /MQQBrowser/i.test(t2) && !yt(t2) && !H(t2) && !Z(t2) && !wt(t2) && !Qt(t2) && !At(t2) && !jt(t2);
          }), D = g(function(t2) {
            return N(t2) ? l("MQQBrowser", t2) : null;
          }), R = v(function(t2, n2) {
            return a(D(t2) || "", n2) >= 0;
          }), B = g(function(t2) {
            return h(t2) ? N(t2) : V(t2);
          }), q = g(function(t2) {
            return /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i.test(t2);
          }), U = g(function(t2) {
            return l("Chrome", t2);
          }), $ = v(function(t2, n2) {
            return a(U(t2) || "", n2) >= 0;
          }), G = g(function(t2) {
            return /Version\/\S+( Mobile\S*)? Safari\/\S+$/i.test(t2);
          }), L = g(function(t2) {
            return /MSIE/i.test(t2) && !/opera/i.test(t2) || /Trident/i.test(t2);
          }), X = g(function(t2) {
            return /Edge/i.test(t2);
          }), Y = g(function(t2) {
            return /Edg\//i.test(t2);
          }), z = g(function(t2) {
            return /(Firefox|Focus|FxiOS)\//i.test(t2);
          }), H = g(function(t2) {
            return /MicroMessenger/i.test(t2) && !Z(t2) && !bt(t2);
          }), K = g(function(t2) {
            return H(t2) || bt(t2) ? l("MicroMessenger", t2) : null;
          }), J = v(function(t2, n2) {
            return a(K(t2) || "", n2) >= 0;
          }), Z = g(function(t2) {
            return /(wxwork)/i.test(t2);
          }), tt = g(function(t2) {
            return /WeComCEF/i.test(t2) && Z(t2);
          }), nt = g(function(t2) {
            return /(wxworklocal)/i.test(t2);
          }), et = g(function(t2) {
            return /WXDrive/i.test(t2);
          }), rt = g(function(t2) {
            return et(t2) ? l("WXDrive", t2) : null;
          }), it = v(function(t2, n2) {
            return a(rt(t2) || "", n2) >= 0;
          }), ot = g(function(t2) {
            return Z(t2) ? l("wxwork", t2) : null;
          }), ut = v(function(t2, n2) {
            return a(ot(t2) || "", n2) >= 0;
          }), ct = g(function(t2) {
            return nt(t2) ? l("wxworklocal", t2) : null;
          }), st = v(function(t2, n2) {
            return a(ct(t2) || "", n2) >= 0;
          }), ft = g(function(t2) {
            return /QQ\//i.test(t2) && !wt(t2) && !mt(t2) && !gt(t2);
          }), at = g(function(t2) {
            return /QQ\//i.test(t2) && /_GM/i.test(t2);
          }), lt = g(function(t2) {
            return ft(t2) || mt(t2) ? l("QQ", t2) : null;
          }), pt = v(function(t2, n2) {
            return a(lt(t2) || "", n2) >= 0;
          }), gt = g(function(t2) {
            return /TIM/i.test(t2);
          }), vt = g(function(t2) {
            return /QBCore/i.test(t2) && /TIM2.0/i.test(t2);
          }), ht = g(function(t2) {
            return gt(t2) ? l("TIM", t2) : null;
          }), dt = v(function(t2, n2) {
            return a(ht(t2) || "", n2) >= 0;
          }), yt = g(function(t2) {
            return gt(t2) || ft(t2);
          }), xt = g(function(t2) {
            return gt(t2) || /QQ/i.test(t2);
          }), At = g(function(t2) {
            return /miniprogram|miniapp(?!enable)/i.test(t2) || "undefined" != typeof __wxjs_environment && "miniprogram" === __wxjs_environment;
          }), bt = g(function(t2) {
            return /MicroMessenger/i.test(t2) && At(t2);
          }), mt = g(function(t2) {
            return /QQ\/|TIM/i.test(t2) && At(t2);
          }), wt = g(function(t2) {
            return /TencentDocs/i.test(t2);
          }), kt = g(function(t2) {
            return l("TencentDocs", t2);
          }), Et = v(function(t2, n2) {
            return a(kt(t2) || "", n2) >= 0;
          }), Ot = g(function(t2) {
            return /TxDocsPC/i.test(t2);
          }), St = g(function(t2) {
            return Ot(t2);
          }), _t = g(function(t2) {
            return l("TxDocsPC", t2);
          }), Mt = v(function(t2, n2) {
            return a(_t(t2) || "", n2) >= 0;
          }), Pt = g(function(t2) {
            return /TDAppDesktop/i.test(t2);
          }), Tt = g(function(t2) {
            return l("TDAppDesktop", t2);
          }), It = v(function(t2, n2) {
            return a(Tt(t2) || "", n2) >= 0;
          }), Qt = g(function(t2) {
            return /weiyun/i.test(t2);
          }), Ct = g(function(t2) {
            return /SE 2\.X MetaSr 1\.0/i.test(t2);
          }), jt = g(function(t2) {
            return /tencent_wemeet/i.test(t2);
          }), Vt = g(function(t2) {
            return jt(t2) && /meeting_wework/i.test(t2);
          }), Wt = g(function(t2) {
            return /TencentMeetingRooms/i.test(t2);
          }), Ft = function() {
            function t2() {
              var n2 = this, e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : p();
              i()(this, t2), this.getAndroidVersion = function() {
                return O(n2.userAgent);
              }, this.isAndroidVersionAboveOrEqual = function(t3) {
                return S(t3, n2.userAgent);
              }, this.getIOSVersion = function() {
                return M(n2.userAgent);
              }, this.isIOSVersionAboveOrEqual = function(t3) {
                return P(t3, n2.userAgent);
              }, this.getPCQQBrowserVersion = function() {
                return W(n2.userAgent);
              }, this.isPCQQBrowserVersionAboveOrEqual = function(t3) {
                return F(t3, n2.userAgent);
              }, this.getMobileQQBrowserVersion = function() {
                return D(n2.userAgent);
              }, this.isMobileQQBrowserVersionAboveOrEqual = function(t3) {
                return R(t3, n2.userAgent);
              }, this.getChromeVersion = function() {
                return U(n2.userAgent);
              }, this.isChromeVersionAboveOrEqual = function(t3) {
                return $(t3, n2.userAgent);
              }, this.getWeChatVersion = function() {
                return K(n2.userAgent);
              }, this.isWeChatVersionAboveOrEqual = function(t3) {
                return J(t3, n2.userAgent);
              }, this.getWxDriveVersion = function() {
                return rt(n2.userAgent);
              }, this.isWxDriveVersionAboveOrEqual = function(t3) {
                return it(t3, n2.userAgent);
              }, this.getWxWorkVersion = function() {
                return ot(n2.userAgent);
              }, this.isWxWorkVersionAboveOrEqual = function(t3) {
                return ut(t3, n2.userAgent);
              }, this.getWxWorkPrivateVersion = function() {
                return ct(n2.userAgent);
              }, this.isWxWorkPrivateVersionAboveOrEqual = function(t3) {
                return st(t3, n2.userAgent);
              }, this.getQQVersion = function() {
                return lt(n2.userAgent);
              }, this.isQQVersionAboveOrEqual = function(t3) {
                return pt(t3, n2.userAgent);
              }, this.getTimVersion = function() {
                return ht(n2.userAgent);
              }, this.isTimVersionAboveOrEqual = function(t3) {
                return dt(t3, n2.userAgent);
              }, this.getTencentDocsAppVersion = function() {
                return kt(n2.userAgent);
              }, this.isTencentDocsAppVersionAboveOrEqual = function(t3) {
                return Et(t3, n2.userAgent);
              }, this.getPCTencentDocsClientVersion = function() {
                return _t(n2.userAgent);
              }, this.isPCTencentDocsClientVersionAboveOrEqual = function(t3) {
                return Mt(t3, n2.userAgent);
              }, this.getElectronTencentDocsClientVersion = function() {
                return Tt(n2.userAgent);
              }, this.isElectronTencentDocsClientVersionAboveOrEqual = function(t3) {
                return It(t3, n2.userAgent);
              }, Object.defineProperty(this, "userAgent", { value: e2, writable: false });
            }
            return u()(t2, [{ key: "isMobile", get: function() {
              return h(this.userAgent);
            } }, { key: "isMobilePhone", get: function() {
              return d(this.userAgent);
            } }, { key: "isIPhone", get: function() {
              return y(this.userAgent);
            } }, { key: "isIPad", get: function() {
              return x(this.userAgent);
            } }, { key: "isAndroidPhone", get: function() {
              return A(this.userAgent);
            } }, { key: "isAndroidPad", get: function() {
              return b(this.userAgent);
            } }, { key: "isPC", get: function() {
              return m(this.userAgent);
            } }, { key: "isMac", get: function() {
              return w(this.userAgent);
            } }, { key: "isIPadEmulatedMac", get: function() {
              return k(this.userAgent);
            } }, { key: "isAndroid", get: function() {
              return E(this.userAgent);
            } }, { key: "isIOS", get: function() {
              return _(this.userAgent);
            } }, { key: "isWindows", get: function() {
              return T(this.userAgent);
            } }, { key: "isWindowsUWP", get: function() {
              return I(this.userAgent);
            } }, { key: "isLinux", get: function() {
              return Q(this.userAgent);
            } }, { key: "isLinuxKylin", get: function() {
              return C(this.userAgent);
            } }, { key: "isLinuxUOS", get: function() {
              return j(this.userAgent);
            } }, { key: "isPCQQBrowser", get: function() {
              return V(this.userAgent);
            } }, { key: "isMobileQQBrowser", get: function() {
              return N(this.userAgent);
            } }, { key: "isQQBrowser", get: function() {
              return B(this.userAgent);
            } }, { key: "isChrome", get: function() {
              return q(this.userAgent);
            } }, { key: "isSafari", get: function() {
              return G(this.userAgent);
            } }, { key: "isIE", get: function() {
              return L(this.userAgent);
            } }, { key: "isOldEdge", get: function() {
              return X(this.userAgent);
            } }, { key: "isChromiumEdge", get: function() {
              return Y(this.userAgent);
            } }, { key: "isFirefox", get: function() {
              return z(this.userAgent);
            } }, { key: "isWeChat", get: function() {
              return H(this.userAgent);
            } }, { key: "isWxWork", get: function() {
              return Z(this.userAgent);
            } }, { key: "isWxWorkCustom", get: function() {
              return tt(this.userAgent);
            } }, { key: "isWxWorkPrivate", get: function() {
              return nt(this.userAgent);
            } }, { key: "isWxDrive", get: function() {
              return et(this.userAgent);
            } }, { key: "isQQ", get: function() {
              return ft(this.userAgent);
            } }, { key: "isQQForGooglePlay", get: function() {
              return at(this.userAgent);
            } }, { key: "isTim", get: function() {
              return gt(this.userAgent);
            } }, { key: "isPCTim", get: function() {
              return vt(this.userAgent);
            } }, { key: "isTimOrQQ", get: function() {
              return yt(this.userAgent);
            } }, { key: "isTimOrQQFamily", get: function() {
              return xt(this.userAgent);
            } }, { key: "isMiniProgram", get: function() {
              return At(this.userAgent);
            } }, { key: "isWxMiniProgram", get: function() {
              return bt(this.userAgent);
            } }, { key: "isQQMiniProgram", get: function() {
              return mt(this.userAgent);
            } }, { key: "isTencentDocsApp", get: function() {
              return wt(this.userAgent);
            } }, { key: "isPCTencentDocsClient", get: function() {
              return Ot(this.userAgent);
            } }, { key: "isPCTencentDocsApp", get: function() {
              return St(this.userAgent);
            } }, { key: "isElectronTencentDocsClient", get: function() {
              return Pt(this.userAgent);
            } }, { key: "isWeiYunApp", get: function() {
              return Qt(this.userAgent);
            } }, { key: "isSouGou", get: function() {
              return Ct(this.userAgent);
            } }, { key: "isTencentMeeting", get: function() {
              return jt(this.userAgent);
            } }, { key: "isWxWorkTencentMeeting", get: function() {
              return Vt(this.userAgent);
            } }, { key: "isTencentMeetingRooms", get: function() {
              return Wt(this.userAgent);
            } }]), t2;
          }();
          n.default = new Ft();
        }]);
      });
    })(dist);
    return dist.exports;
  }
  var polyfill = {};
  var hasRequiredPolyfill;
  function requirePolyfill() {
    if (hasRequiredPolyfill)
      return polyfill;
    hasRequiredPolyfill = 1;
    Object.defineProperty(polyfill, "__esModule", { value: true });
    if (typeof String.prototype.repeat !== "function") {
      String.prototype.repeat = function(count) {
        if (this == null)
          throw new TypeError("can't convert " + this + " to object");
        var str = "" + this;
        count = +count;
        if (count != count)
          count = 0;
        if (count < 0)
          throw new RangeError("repeat count must be non-negative");
        if (count == Infinity)
          throw new RangeError("repeat count must be less than infinity");
        count = Math.floor(count);
        if (str.length == 0 || count == 0)
          return "";
        if (str.length * count >= 1 << 28)
          throw new RangeError("repeat count must not overflow maximum string size");
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
          str += str;
          count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
      };
    }
    if (typeof String.prototype.padStart !== "function") {
      String.prototype.padStart = function padStart(maxLength, fillString) {
        maxLength = maxLength >> 0;
        fillString = String(typeof fillString !== "undefined" ? fillString : " ");
        if (this.length > maxLength) {
          return String(this);
        } else {
          maxLength = maxLength - this.length;
          if (maxLength > fillString.length) {
            fillString += fillString.repeat(maxLength / fillString.length);
          }
          return fillString.slice(0, maxLength) + String(this);
        }
      };
    }
    if (typeof Array.prototype.fill !== "function") {
      Array.prototype.fill = function fill(value) {
        if (this == null) {
          throw new TypeError("this is null or not defined");
        }
        var O = Object(this);
        var len = O.length >>> 0;
        var start = arguments[1];
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === void 0 ? len : end >> 0;
        var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
        while (k < final) {
          O[k] = value;
          k++;
        }
        return O;
      };
    }
    if (typeof Element !== "undefined" && typeof Element.prototype.remove !== "function") {
      Element.prototype.remove = function() {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }
    if (!Array.prototype.findIndex) {
      Array.prototype.findIndex = function(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (typeof predicate !== "function") {
          throw new TypeError("predicate must be a function");
        }
        var thisArg = arguments[1];
        var k = 0;
        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return k;
          }
          k++;
        }
        return -1;
      };
    }
    if (!Array.prototype.includes) {
      Array.prototype.includes = function(valueToFind, fromIndex) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (len === 0) {
          return false;
        }
        var n = fromIndex | 0;
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        function sameValueZero(x, y) {
          return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
        }
        while (k < len) {
          if (sameValueZero(o[k], valueToFind)) {
            return true;
          }
          k++;
        }
        return false;
      };
    }
    return polyfill;
  }
  var style$3 = {};
  var hasRequiredStyle;
  function requireStyle() {
    if (hasRequiredStyle)
      return style$3;
    hasRequiredStyle = 1;
    Object.defineProperty(style$3, "__esModule", { value: true });
    style$3.injectStyle = void 0;
    var tslib_12 = tslib.exports;
    var version_1 = tslib_12.__importDefault(requireVersion());
    var createElement_1 = requireCreateElement();
    var helper_1 = requireHelper();
    var bundledBy = "1";
    var StyleRegistryManage = function() {
      function StyleRegistryManage2() {
        var globalObj = helper_1.isBrowser ? window : commonjsGlobal;
        globalObj.__dui_style_registry__ = globalObj.__dui_style_registry__ || {};
        this.registry = globalObj.__dui_style_registry__;
      }
      Object.defineProperty(StyleRegistryManage2.prototype, "length", {
        get: function() {
          return Object.keys(this.registry).length;
        },
        enumerable: false,
        configurable: true
      });
      StyleRegistryManage2.prototype.set = function(key, bundledsBy) {
        this.registry[key] = bundledsBy;
      };
      StyleRegistryManage2.prototype.get = function(key) {
        return this.registry[key];
      };
      StyleRegistryManage2.prototype.add = function(key, bundledBy2) {
        if (!this.registry[key]) {
          this.registry[key] = [];
        }
        this.registry[key].push(bundledBy2);
      };
      return StyleRegistryManage2;
    }();
    var styleRegistryManage = new StyleRegistryManage();
    function injectStyle(fileKey, css) {
      var key = version_1.default + "-" + fileKey;
      var domKey = createElement_1.isScopedAttributeDisabled ? fileKey : key;
      var hasElement = Boolean(helper_1.isBrowser && document.querySelector('style[data-dui-key="' + domKey + '"]') || !helper_1.isBrowser);
      if (Array.isArray(styleRegistryManage.get(key)) && hasElement) {
        styleRegistryManage.add(key, bundledBy);
        warnRedundantInject(key);
        return;
      }
      styleRegistryManage.set(key, [bundledBy]);
      var versions = getFileVersions(fileKey);
      if (versions.length > 1) {
        warnMultipleVersions(fileKey, versions);
      }
      if (helper_1.isBrowser) {
        var styleElement = document.createElement("style");
        styleElement.setAttribute("type", "text/css");
        styleElement.setAttribute("data-dui-key", domKey);
        styleElement.innerText = css;
        document.head.appendChild(styleElement);
      } else if (typeof injectContentBeforeRoot === "function") {
        var styleElement = '<style type="text/css" data-dui-key="' + domKey + '">' + css + "</style>";
        injectContentBeforeRoot(styleElement);
      }
    }
    style$3.injectStyle = injectStyle;
    var CONSOLE_DEBOUNCE = 3e3;
    function warnRedundantInject(key) {
      if (!helper_1.isBrowser || !styleRegistryManage.length || !Array.isArray(styleRegistryManage.get(key))) {
        return;
      }
      var count = styleRegistryManage.get(key).length;
      setTimeout(function() {
        if (styleRegistryManage.get(key).length > count) {
          return;
        }
        console.warn("[DUI] " + key + " \u91CD\u590D\u5F15\u5165\u4E86 " + count + " \u6B21");
      }, CONSOLE_DEBOUNCE);
    }
    function warnMultipleVersions(fileKey, versions) {
      if (!helper_1.isBrowser) {
        return;
      }
      setTimeout(function() {
        if (getFileVersions(fileKey).length > versions.length) {
          return;
        }
        console.warn("[DUI] " + fileKey + " \u5B58\u5728\u591A\u4E2A\u7248\u672C:  " + versions.join("  "));
      }, CONSOLE_DEBOUNCE);
    }
    function getFileVersions(fileKey) {
      if (!styleRegistryManage.length) {
        return [];
      }
      var existingKeys = Object.getOwnPropertyNames(styleRegistryManage.registry);
      return existingKeys.filter(function(k) {
        return k.indexOf(fileKey) !== -1;
      }).map(function(k) {
        return k.split("-")[0];
      });
    }
    return style$3;
  }
  var hasRequiredTheme;
  function requireTheme() {
    if (hasRequiredTheme)
      return theme;
    hasRequiredTheme = 1;
    Object.defineProperty(theme, "__esModule", { value: true });
    theme.createThemedClassNames = theme.consumeTheme = void 0;
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var classnames_1 = tslib_12.__importDefault(classNames__default.default);
    var docs_user_agent_1 = tslib_12.__importDefault(requireDist());
    requirePolyfill();
    requireStyle().injectStyle("common/global.css", "[data-dui-0-122-1]{font-family:-apple-system,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif}[data-dui-0-122-1]:focus{outline:none}");
    var enableAntiAlias = docs_user_agent_1.default.isMac && !docs_user_agent_1.default.isIPadEmulatedMac && !docs_user_agent_1.default.isFirefox;
    if (enableAntiAlias) {
      requireStyle().injectStyle("common/anti-alias.css", '[data-dui-0-122-1]{-webkit-font-smoothing:antialiased}[data-dui-0-122-1~="dui-button"]{font-weight:500}');
    }
    var ThemeContext = React2.createContext(null);
    function consumeTheme(renderProp) {
      return h(ThemeContext.Consumer, null, function(themeConfig) {
        var classNames2 = createThemedClassNames(themeConfig);
        return renderProp(classNames2);
      });
    }
    theme.consumeTheme = consumeTheme;
    function appendThemeClassNames(themeConfig, className) {
      if (!className || !themeConfig) {
        return className;
      }
      var currentClassList = className.split(/\s+/);
      var mergedClassList = currentClassList.concat.apply(currentClassList, currentClassList.map(function(name2) {
        return themeConfig[name2];
      }).filter(function(name2) {
        return name2;
      }));
      return mergedClassList.join(" ");
    }
    function createThemedClassNames(themeConfig) {
      return function() {
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          classes[_i] = arguments[_i];
        }
        return appendThemeClassNames(themeConfig, classnames_1.default.apply(void 0, classes));
      };
    }
    theme.createThemedClassNames = createThemedClassNames;
    theme.default = ThemeContext;
    return theme;
  }
  var hasRequiredDivider;
  function requireDivider() {
    if (hasRequiredDivider)
      return Divider;
    hasRequiredDivider = 1;
    Object.defineProperty(Divider, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var PropTypes = tslib_12.__importStar(requirePropTypes());
    var context_1 = requireContext$3();
    var theme_1 = requireTheme();
    var Divider$12 = function(_super) {
      tslib_12.__extends(Divider2, _super);
      function Divider2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function(classNames2) {
          var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, dashed = _a.dashed, children = _a.children, orientation = _a.orientation, textPosition = _a.textPosition, textStyle = _a.textStyle, textClassName = _a.textClassName;
          var containsText = children && orientation === "horizontal";
          return h(context_1.SubMenuContext.Consumer, null, function(_a2) {
            var _b, _c;
            var type = _a2.type;
            var isCompact = type !== "with-icon";
            var cls = classNames2(prefixCls, className, prefixCls + "-" + orientation + (dashed ? "-dashed" : ""), (_b = {}, _b[prefixCls + "-with-text"] = containsText, _b[prefixCls + "-compact"] = isCompact, _b));
            var textCls = classNames2(prefixCls + "-text", textClassName, prefixCls + "-text-" + textPosition, (_c = {}, _c[prefixCls + "-text-compact"] = isCompact, _c));
            return h("div", { className: cls, style: style2 }, containsText ? h("span", { className: textCls, style: textStyle }, children) : null);
          });
        };
        return _this;
      }
      Divider2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Divider2;
    }(React2.Component);
    Divider.default = Divider$12;
    Divider$12.defaultProps = {
      prefixCls: "dui-divider",
      dashed: false,
      orientation: "horizontal",
      textPosition: "center"
    };
    Divider$12.propTypes = {
      prefixCls: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
      dashed: PropTypes.bool,
      orientation: PropTypes.string,
      textPosition: PropTypes.string,
      textStyle: PropTypes.object,
      textClassName: PropTypes.string
    };
    return Divider;
  }
  Object.defineProperty(Divider$1, "__esModule", { value: true });
  var Divider_2 = Divider$1.Divider = void 0;
  var tslib_1$6 = tslib.exports;
  var Divider_1 = tslib_1$6.__importDefault(requireDivider());
  Divider_2 = Divider$1.Divider = Divider_1.default;
  requireStyle().injectStyle("components/Divider/style/index.css", '[data-dui-0-122-1~="dui-divider"]{border:1px solid var(--border-weak,rgba(0,0,0,.04));position:relative;pointer-events:none}[data-dui-0-122-1~="dui-divider-horizontal"],[data-dui-0-122-1~="dui-divider-horizontal-dashed"]{display:block;width:100%;border-top:none;border-left:none;border-right:none;margin:8px 0}[data-dui-0-122-1~="dui-divider-horizontal-dashed"]{border-bottom-style:dashed}[data-dui-0-122-1~="dui-divider-compact"][data-dui-0-122-1~="dui-divider-horizontal"]{margin:4px 0}[data-dui-0-122-1~="dui-divider-vertical"],[data-dui-0-122-1~="dui-divider-vertical-dashed"]{display:inline-block;border-left:none;border-top:none;border-bottom:none;margin:0 12px;height:1em}[data-dui-0-122-1~="dui-divider-vertical-dashed"]{border-right-style:dashed}[data-dui-0-122-1~="dui-divider-compact"][data-dui-0-122-1~="dui-divider-vertical"]{margin:0 6px}[data-dui-0-122-1~="dui-divider-with-text"]{margin:15px 0}[data-dui-0-122-1~="dui-divider-compact"][data-dui-0-122-1~="dui-divider-with-text"]{margin:10px 0}[data-dui-0-122-1~="dui-divider-text"]{position:absolute;background:#fff;font-size:14px;color:#d0d0d0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);padding:0 6px}[data-dui-0-122-1~="dui-divider-text-compact"]{font-size:12px}[data-dui-0-122-1~="dui-divider-text-center"]{left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}[data-dui-0-122-1~="dui-divider-text-left"]{left:24px}[data-dui-0-122-1~="dui-divider-text-right"]{right:24px}');
  Divider$1.default = Divider_1.default;
  var Dropdown$1 = {};
  var Dropdown = {};
  var Trigger = {};
  var documentDom = {};
  var hasRequiredDocumentDom;
  function requireDocumentDom() {
    if (hasRequiredDocumentDom)
      return documentDom;
    hasRequiredDocumentDom = 1;
    Object.defineProperty(documentDom, "__esModule", { value: true });
    documentDom.DocumentDomContext = void 0;
    var tslib_12 = tslib.exports;
    var React2 = tslib_12.__importStar(React__default.default);
    documentDom.DocumentDomContext = React2.createContext(null);
    return documentDom;
  }
  var hasRequiredTrigger;
  function requireTrigger() {
    if (hasRequiredTrigger)
      return Trigger;
    hasRequiredTrigger = 1;
    (function(exports2) {
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.TriggerContext = void 0;
      var tslib_12 = tslib.exports;
      var h = requireCreateElement().h;
      var React2 = tslib_12.__importStar(React__default.default);
      var helper_1 = requireHelper();
      var classnames_1 = tslib_12.__importDefault(classNames__default.default);
      var documentDom_1 = requireDocumentDom();
      var memoize_one_1 = tslib_12.__importDefault(require$$6);
      exports2.TriggerContext = React2.createContext(helper_1.emptyFn);
      var Trigger2 = function(_super) {
        tslib_12.__extends(Trigger3, _super);
        function Trigger3() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.shouldCancel = false;
          _this.trigger = function(e) {
            if (_this.props.disabled || _this.shouldCancel) {
              return;
            }
            if (e._dui_trigger_instances) {
              var index = e._dui_trigger_instances.indexOf(_this);
              if (index !== -1) {
                e._dui_trigger_instances.splice(index, 1);
                if (e._dui_trigger_instances.length === 0) {
                  delete e._dui_trigger_instances;
                }
                return;
              }
            }
            _this.props.action();
          };
          _this.cancel = function(e) {
            if (_this.props.disabled) {
              return;
            }
            var event = e.nativeEvent;
            if (event._dui_trigger_instances) {
              event._dui_trigger_instances.push(_this);
            } else {
              event._dui_trigger_instances = [_this];
            }
          };
          _this.generateCancelSetter = memoize_one_1.default(function(parentSetCancel) {
            return function(shouldCancel) {
              parentSetCancel(shouldCancel);
              _this.shouldCancel = shouldCancel;
            };
          });
          return _this;
        }
        Trigger3.prototype.componentDidMount = function() {
          this.doc.addEventListener("click", this.trigger);
          if (!this.props.disableContextMenu) {
            this.doc.addEventListener("contextmenu", this.trigger);
          }
        };
        Trigger3.prototype.componentWillUnmount = function() {
          this.doc.removeEventListener("click", this.trigger);
          if (!this.props.disableContextMenu) {
            this.doc.removeEventListener("contextmenu", this.trigger);
          }
        };
        Object.defineProperty(Trigger3.prototype, "doc", {
          get: function() {
            return this.context || document;
          },
          enumerable: false,
          configurable: true
        });
        Trigger3.prototype.render = function() {
          var _this = this;
          var _a = this.props, prefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, children = _a.children, domRef = _a.domRef, disableContextMenu = _a.disableContextMenu, testId = _a.testId;
          var classes = classnames_1.default(prefixCls, className);
          return h(exports2.TriggerContext.Consumer, null, function(parentSetCancel) {
            return h(
              exports2.TriggerContext.Provider,
              { value: _this.generateCancelSetter(parentSetCancel) },
              h("div", { className: classes, style: style2, onClick: _this.cancel, onContextMenu: disableContextMenu ? void 0 : _this.cancel, ref: domRef, "data-testid": testId }, children)
            );
          });
        };
        Trigger3.contextType = documentDom_1.DocumentDomContext;
        return Trigger3;
      }(React2.Component);
      exports2.default = Trigger2;
      Trigger2.defaultProps = {
        prefixCls: "dui-trigger",
        action: helper_1.emptyFn,
        disabled: false,
        disableContextMenu: false
      };
    })(Trigger);
    return Trigger;
  }
  var context$2 = {};
  var hasRequiredContext$2;
  function requireContext$2() {
    if (hasRequiredContext$2)
      return context$2;
    hasRequiredContext$2 = 1;
    Object.defineProperty(context$2, "__esModule", { value: true });
    context$2.getDropdownContext = context$2.DropdownContext = void 0;
    var tslib_12 = tslib.exports;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    context$2.DropdownContext = React2.createContext({ visible: true, zIndex: 9999 });
    context$2.getDropdownContext = helper_1.createContextValueGetter();
    return context$2;
  }
  var microTask = {};
  var hasRequiredMicroTask;
  function requireMicroTask() {
    if (hasRequiredMicroTask)
      return microTask;
    hasRequiredMicroTask = 1;
    Object.defineProperty(microTask, "__esModule", { value: true });
    microTask.triggerMicroTask = void 0;
    var internalCallback = null;
    var elem = null;
    var counter = 1;
    if (typeof document !== "undefined") {
      var observer = new MutationObserver(function() {
        internalCallback === null || internalCallback === void 0 ? void 0 : internalCallback();
        internalCallback = null;
      });
      elem = document.createElement("div");
      observer.observe(elem, { attributes: true });
    }
    function triggerMicroTask(callback) {
      if (elem) {
        internalCallback = callback;
        elem.setAttribute("data-dui-micro-task", String(counter++));
      } else {
        Promise.resolve().then(callback);
      }
    }
    microTask.triggerMicroTask = triggerMicroTask;
    return microTask;
  }
  var keepDom = {};
  var hasRequiredKeepDom;
  function requireKeepDom() {
    if (hasRequiredKeepDom)
      return keepDom;
    hasRequiredKeepDom = 1;
    Object.defineProperty(keepDom, "__esModule", { value: true });
    keepDom.decideKeepDom = void 0;
    function decideKeepDom(animationDuration, visible) {
      var _this = this;
      var willLeave = !visible && this._ALC_HELPER_prevVisible;
      this._ALC_HELPER_prevVisible = visible;
      if (visible) {
        return true;
      }
      if (!willLeave) {
        return false;
      }
      setTimeout(function() {
        _this.forceUpdate();
      }, animationDuration);
      return true;
    }
    keepDom.decideKeepDom = decideKeepDom;
    return keepDom;
  }
  var focus = {};
  var hasRequiredFocus;
  function requireFocus() {
    if (hasRequiredFocus)
      return focus;
    hasRequiredFocus = 1;
    Object.defineProperty(focus, "__esModule", { value: true });
    focus.restoreFocus = focus.saveFocus = focus.traverseFocusIn = void 0;
    var BASE_FOCUSABLE_SELECTORS = [
      "a[href]",
      "area[href]",
      'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
      "select:not([disabled]):not([aria-hidden])",
      "textarea:not([disabled]):not([aria-hidden])",
      "button:not([disabled]):not([aria-hidden])",
      "iframe",
      "object",
      "embed",
      "[contenteditable]",
      '[tabindex]:not([tabindex^="-"])'
    ];
    function getFocusableNodesIn(container2) {
      return Array.prototype.slice.call(container2.querySelectorAll(BASE_FOCUSABLE_SELECTORS));
    }
    function traverseFocusIn(container2, e, isReverse) {
      if (isReverse === void 0) {
        isReverse = e === null || e === void 0 ? void 0 : e.shiftKey;
      }
      var focusableNodes = getFocusableNodesIn(container2);
      if (focusableNodes.length === 0) {
        return;
      }
      var focusedIndex = focusableNodes.indexOf(document.activeElement);
      var focusElement;
      if (focusedIndex < 0) {
        focusElement = focusableNodes[0];
      } else {
        var nextFocusIndex = (focusedIndex + (isReverse ? -1 : 1) + focusableNodes.length) % focusableNodes.length;
        focusElement = focusableNodes[nextFocusIndex];
      }
      focusElement.focus();
      focusElement.scrollIntoView();
      e === null || e === void 0 ? void 0 : e.preventDefault();
    }
    focus.traverseFocusIn = traverseFocusIn;
    var activeElement = null;
    function saveFocus() {
      activeElement = document.activeElement;
    }
    focus.saveFocus = saveFocus;
    function runRestoreFocus() {
      activeElement === null || activeElement === void 0 ? void 0 : activeElement.focus();
      activeElement = null;
    }
    function restoreFocus() {
      if (!activeElement) {
        return;
      }
      if (activeElement.tagName === "BUTTON") {
        setTimeout(runRestoreFocus, 0);
      } else {
        runRestoreFocus();
      }
    }
    focus.restoreFocus = restoreFocus;
    return focus;
  }
  var isObject_1;
  var hasRequiredIsObject;
  function requireIsObject() {
    if (hasRequiredIsObject)
      return isObject_1;
    hasRequiredIsObject = 1;
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    isObject_1 = isObject2;
    return isObject_1;
  }
  var _freeGlobal;
  var hasRequired_freeGlobal;
  function require_freeGlobal() {
    if (hasRequired_freeGlobal)
      return _freeGlobal;
    hasRequired_freeGlobal = 1;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    _freeGlobal = freeGlobal;
    return _freeGlobal;
  }
  var _root;
  var hasRequired_root;
  function require_root() {
    if (hasRequired_root)
      return _root;
    hasRequired_root = 1;
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    _root = root2;
    return _root;
  }
  var now_1;
  var hasRequiredNow;
  function requireNow() {
    if (hasRequiredNow)
      return now_1;
    hasRequiredNow = 1;
    var root2 = require_root();
    var now = function() {
      return root2.Date.now();
    };
    now_1 = now;
    return now_1;
  }
  var _trimmedEndIndex;
  var hasRequired_trimmedEndIndex;
  function require_trimmedEndIndex() {
    if (hasRequired_trimmedEndIndex)
      return _trimmedEndIndex;
    hasRequired_trimmedEndIndex = 1;
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    _trimmedEndIndex = trimmedEndIndex;
    return _trimmedEndIndex;
  }
  var _baseTrim;
  var hasRequired_baseTrim;
  function require_baseTrim() {
    if (hasRequired_baseTrim)
      return _baseTrim;
    hasRequired_baseTrim = 1;
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    _baseTrim = baseTrim;
    return _baseTrim;
  }
  var root$7 = require_root();
  var Symbol$5 = root$7.Symbol;
  var _Symbol = Symbol$5;
  var Symbol$4 = _Symbol;
  var objectProto$c = Object.prototype;
  var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
  var nativeObjectToString$1 = objectProto$c.toString;
  var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
  function getRawTag$1(value) {
    var isOwn = hasOwnProperty$9.call(value, symToStringTag$1), tag = value[symToStringTag$1];
    try {
      value[symToStringTag$1] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }
  var _getRawTag = getRawTag$1;
  var objectProto$b = Object.prototype;
  var nativeObjectToString = objectProto$b.toString;
  function objectToString$1(value) {
    return nativeObjectToString.call(value);
  }
  var _objectToString = objectToString$1;
  var Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
  var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
  var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
  function baseGetTag$5(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  var _baseGetTag = baseGetTag$5;
  function isObjectLike$5(value) {
    return value != null && typeof value == "object";
  }
  var isObjectLike_1 = isObjectLike$5;
  var baseGetTag$4 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
  var symbolTag$1 = "[object Symbol]";
  function isSymbol$3(value) {
    return typeof value == "symbol" || isObjectLike$4(value) && baseGetTag$4(value) == symbolTag$1;
  }
  var isSymbol_1 = isSymbol$3;
  var toNumber_1;
  var hasRequiredToNumber;
  function requireToNumber() {
    if (hasRequiredToNumber)
      return toNumber_1;
    hasRequiredToNumber = 1;
    var baseTrim = require_baseTrim(), isObject2 = requireIsObject(), isSymbol2 = isSymbol_1;
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol2(value)) {
        return NAN;
      }
      if (isObject2(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject2(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    toNumber_1 = toNumber;
    return toNumber_1;
  }
  var debounce_1;
  var hasRequiredDebounce;
  function requireDebounce() {
    if (hasRequiredDebounce)
      return debounce_1;
    hasRequiredDebounce = 1;
    var isObject2 = requireIsObject(), now = requireNow(), toNumber = requireToNumber();
    var FUNC_ERROR_TEXT2 = "Expected a function";
    var nativeMax = Math.max, nativeMin = Math.min;
    function debounce(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT2);
      }
      wait = toNumber(wait) || 0;
      if (isObject2(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    debounce_1 = debounce;
    return debounce_1;
  }
  var throttle_1;
  var hasRequiredThrottle;
  function requireThrottle() {
    if (hasRequiredThrottle)
      return throttle_1;
    hasRequiredThrottle = 1;
    var debounce = requireDebounce(), isObject2 = requireIsObject();
    var FUNC_ERROR_TEXT2 = "Expected a function";
    function throttle(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT2);
      }
      if (isObject2(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    throttle_1 = throttle;
    return throttle_1;
  }
  var checkPositionChange = {};
  var hasRequiredCheckPositionChange;
  function requireCheckPositionChange() {
    if (hasRequiredCheckPositionChange)
      return checkPositionChange;
    hasRequiredCheckPositionChange = 1;
    Object.defineProperty(checkPositionChange, "__esModule", { value: true });
    checkPositionChange.checkPositionChange = void 0;
    var helper_1 = requireHelper();
    var CHECK_POSITION_INTERVAL = 100;
    function checkPositionChange$1(dom, onChange) {
      if (!dom) {
        return helper_1.emptyFn;
      }
      var prevPosition = dom.getBoundingClientRect();
      var checkTimer = setInterval(function() {
        var position = dom.getBoundingClientRect();
        if (Math.abs(prevPosition.left - position.left) > 1 || Math.abs(prevPosition.top - position.top) > 1) {
          onChange();
        }
        prevPosition = position;
      }, CHECK_POSITION_INTERVAL);
      return function() {
        return clearInterval(checkTimer);
      };
    }
    checkPositionChange.checkPositionChange = checkPositionChange$1;
    return checkPositionChange;
  }
  var hasRequiredDropdown;
  function requireDropdown() {
    if (hasRequiredDropdown)
      return Dropdown;
    hasRequiredDropdown = 1;
    Object.defineProperty(Dropdown, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
    var helper_1 = requireHelper();
    var Trigger_1 = tslib_12.__importDefault(requireTrigger());
    var context_1 = requireContext$2();
    var theme_1 = requireTheme();
    var microTask_1 = requireMicroTask();
    var keepDom_1 = requireKeepDom();
    var documentDom_1 = requireDocumentDom();
    var focus_1 = requireFocus();
    var throttle_12 = tslib_12.__importDefault(requireThrottle());
    var docs_user_agent_1 = tslib_12.__importDefault(requireDist());
    var checkPositionChange_1 = requireCheckPositionChange();
    var DEFAULT_METRICS = {
      left: "0",
      top: "0"
    };
    var DROPDOWN_TRANSITION_OUT_DURATION = 120;
    var DROPDOWN_TRANSITION_IN_DURATION = 240;
    var outerAlignments = ["auto-outer", "left-outer", "right-outer"];
    var shouldFixAnimationFlickering = docs_user_agent_1.default.isIOS || docs_user_agent_1.default.isIPadEmulatedMac || docs_user_agent_1.default.isIPad;
    var HOVER_DELAY = 100;
    var Dropdown$12 = function(_super) {
      tslib_12.__extends(Dropdown2, _super);
      function Dropdown2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootDomRef = React2.createRef();
        _this.dropContentRef = React2.createRef();
        _this.forceRenderDom = false;
        _this.cancelPositionChangeChecker = null;
        _this.resizeObserver = null;
        _this.isInAnimation = false;
        _this.dropContentObserver = new MutationObserver(function(mutationList) {
          if (mutationList.some(function(_a) {
            var addedNodes = _a.addedNodes, removedNodes = _a.removedNodes;
            return addedNodes.length || removedNodes.length;
          })) {
            _this.refreshDropContentMetric();
          }
        });
        _this.state = {
          visible: false,
          dropContentMetrics: tslib_12.__assign({}, DEFAULT_METRICS),
          actualPlacement: "bottom",
          actualAlignment: _this.isOuterAlignment ? "left-outer" : "left"
        };
        _this.refreshDropContentMetric = throttle_12.default(function() {
          _this.removePreviousClampedSize(_this.updateDropContentMetric);
        }, 20);
        _this.updateDropContentMetric = function() {
          var rootDom = _this.rootDomRef.current;
          var dropContentDom = _this.dropContentRef.current;
          if (!rootDom || !dropContentDom) {
            return;
          }
          var rootDomRect = rootDom.getBoundingClientRect();
          var dropContentDomRect = dropContentDom.getBoundingClientRect();
          var _a = _this.calcHorizontalMetric(rootDomRect, dropContentDomRect), actualAlignment = _a.actualAlignment, horizontalMetric = _a.metric;
          var _b = _this.calcVerticalMetric(rootDomRect, dropContentDomRect), actualPlacement = _b.actualPlacement, verticalMetric = _b.metric;
          var dropContentMetrics = tslib_12.__assign(tslib_12.__assign({}, horizontalMetric), verticalMetric);
          _this.setState({ dropContentMetrics, actualPlacement, actualAlignment });
        };
        _this.hide = function(e) {
          if (e && _this.consumeKeep(e)) {
            return;
          }
          if (!_this.isVisible()) {
            return;
          }
          if (!_this.isControlled) {
            _this.restorePreviousFocus();
          }
          _this.setStateVisible(false);
        };
        _this.show = function(preventStateVisibleUpdate) {
          _this.forceRenderDom = true;
          _this.removePreviousClampedSize(function() {
            requestAnimationFrame(function() {
              _this.forceRenderDom = false;
              _this.updateDropContentMetric();
              !preventStateVisibleUpdate && _this.setStateVisible(true);
            });
          });
        };
        _this.toggle = function() {
          if (_this.props.disabled) {
            return;
          }
          var visible = !_this.isVisible();
          if (visible) {
            _this.show();
          } else {
            _this.hide();
          }
        };
        _this.handleMouseEnter = function() {
          if (_this.props.disabled) {
            return;
          }
          clearTimeout(_this.hideTimeout);
          clearTimeout(_this.showTimeout);
          if (!_this.isVisible()) {
            _this.showTimeout = setTimeout(_this.show, HOVER_DELAY);
          }
        };
        _this.handleMouseLeave = function() {
          if (_this.props.disabled || _this.isInAnimation) {
            return;
          }
          clearTimeout(_this.showTimeout);
          _this.hideTimeout = setTimeout(function() {
            return !_this.isInAnimation && _this.hide();
          }, HOVER_DELAY);
        };
        _this.handleKeydown = function(e) {
          if (e.key === "Escape") {
            _this.hide();
          } else if (e.key === "Tab") {
            _this.traverseFocus(e);
          }
        };
        _this.themedRender = function(classNames2) {
          var _a, _b, _c;
          var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style2 = _d.style, children = _d.children, dropContent = _d.dropContent, disabled2 = _d.disabled, dropContentStyle = _d.dropContentStyle, dropContentClassName = _d.dropContentClassName, forcedZIndex = _d.zIndex, animated = _d.animated, trigger = _d.trigger, destroyOnClose = _d.destroyOnClose, containerDom = _d.containerDom, testId = _d.testId, dropContentTestId = _d.dropContentTestId, containerFollowVisible = _d.containerFollowVisible, containerClassName = _d.containerClassName, containerStyle = _d.containerStyle;
          var _e = _this.state, dropContentMetrics = _e.dropContentMetrics, actualPlacement = _e.actualPlacement, actualAlignment = _e.actualAlignment;
          var visible = _this.isVisible();
          var contextZIndex = _this.context.zIndex;
          var zIndex = forcedZIndex || contextZIndex;
          var cls = classNames2(prefixCls, className, prefixCls + "-" + (visible ? "visible" : "hidden"), (_a = {}, _a[prefixCls + "-disabled"] = disabled2, _a));
          var contentCls = classNames2(prefixCls + "-content", dropContentClassName, prefixCls + "-content-" + actualPlacement, prefixCls + "-content-" + actualAlignment, prefixCls + "-content-" + (visible ? "visible" : "hidden"), prefixCls + "-content-" + (_this.isOuterAlignment ? "outer" : "inner"), (_b = {}, _b[prefixCls + "-content-no-animation"] = !animated, _b));
          var containerCls = classNames2(prefixCls + "-container", containerClassName, (_c = {}, _c[prefixCls + "-container-" + (visible ? "visible" : "hidden")] = containerFollowVisible, _c));
          var shouldDestroyDom = !_this.forceRenderDom && destroyOnClose && !keepDom_1.decideKeepDom.call(_this, DROPDOWN_TRANSITION_OUT_DURATION, visible);
          return h(
            Trigger_1.default,
            { action: _this.hide, className: cls, style: style2, domRef: _this.rootDomRef, testId },
            h(
              "div",
              { onMouseEnter: trigger === "hover" ? _this.handleMouseEnter : void 0, onMouseLeave: trigger === "hover" ? _this.handleMouseLeave : void 0 },
              h("div", { className: containerCls, style: containerStyle, onClick: trigger === "click" ? _this.toggle : void 0 }, children),
              h(
                context_1.DropdownContext.Provider,
                { value: context_1.getDropdownContext({ visible, zIndex: zIndex + 1 }) },
                h(documentDom_1.DocumentDomContext.Consumer, null, function(doc) {
                  return shouldDestroyDom ? null : react_dom_1.default.createPortal(h("div", { className: contentCls, style: tslib_12.__assign(tslib_12.__assign({ zIndex }, dropContentMetrics), dropContentStyle), onClick: _this.hide, ref: _this.dropContentRef, onKeyDown: _this.handleKeydown, tabIndex: -1, "data-testid": dropContentTestId }, dropContent), containerDom || (doc === null || doc === void 0 ? void 0 : doc.body) || document.body);
                })
              )
            )
          );
        };
        return _this;
      }
      Dropdown2.getDerivedStateFromProps = function(props, state) {
        if (props.disabled) {
          return { visible: false };
        }
        return null;
      };
      Object.defineProperty(Dropdown2.prototype, "isOuterAlignment", {
        get: function() {
          return outerAlignments.includes(this.props.alignment);
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Dropdown2.prototype, "isControlled", {
        get: function() {
          return typeof this.props.visible === "boolean";
        },
        enumerable: false,
        configurable: true
      });
      Dropdown2.prototype.componentDidMount = function() {
        this.forceUpdate();
        if (typeof ResizeObserver === "function") {
          this.resizeObserver = new ResizeObserver(this.refreshDropContentMetric);
          this.resizeObserver.observe(this.rootDomRef.current);
        }
      };
      Dropdown2.prototype.componentDidUpdate = function(prevProps, prevState, snapshot) {
        var _this = this;
        var propVisible = this.props.visible;
        var visible = this.isVisible();
        var prevVisible = this.prevVisible;
        this.prevVisible = visible;
        if (!prevVisible && visible) {
          if (propVisible) {
            microTask_1.triggerMicroTask(function() {
              return _this.show(true);
            });
          }
          this.focusSelf();
          this.handleEnteringAnimation();
          this.addListeners();
        }
        if (prevVisible && !visible) {
          this.restorePreviousFocus();
          this.clearListeners();
        }
      };
      Dropdown2.prototype.addListeners = function() {
        var _a, _b;
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this.dropContentRef.current);
        (_b = this.cancelPositionChangeChecker) === null || _b === void 0 ? void 0 : _b.call(this);
        this.cancelPositionChangeChecker = checkPositionChange_1.checkPositionChange(this.rootDomRef.current, this.hide);
        this.dropContentObserver.observe(this.dropContentRef.current, { subtree: true, childList: true });
      };
      Dropdown2.prototype.clearListeners = function() {
        var _a, _b;
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.cancelPositionChangeChecker) === null || _b === void 0 ? void 0 : _b.call(this);
        this.dropContentObserver.disconnect();
      };
      Dropdown2.prototype.componentWillUnmount = function() {
        this.clearListeners();
      };
      Dropdown2.prototype.getSnapshotBeforeUpdate = function() {
        return this.dropContentRef.current;
      };
      Dropdown2.prototype.handleEnteringAnimation = function() {
        this.fixAnimationFlickeringOnIOS();
        this.blockPointerEventsDuringAnimation();
      };
      Dropdown2.prototype.blockPointerEventsDuringAnimation = function() {
        var _this = this;
        this.isInAnimation = true;
        var style2 = this.dropContentRef.current.style;
        var pointerEvents = style2.pointerEvents;
        style2.pointerEvents = "none";
        setTimeout(function() {
          style2.pointerEvents = pointerEvents;
          _this.isInAnimation = false;
        }, DROPDOWN_TRANSITION_IN_DURATION);
      };
      Dropdown2.prototype.fixAnimationFlickeringOnIOS = function() {
        if (!shouldFixAnimationFlickering) {
          return;
        }
        var style2 = this.dropContentRef.current.style;
        setTimeout(function() {
          var opacity = style2.opacity, transform = style2.transform, transition = style2.transition;
          style2.opacity = "0.99";
          style2.transform = "translate(0)";
          style2.transition = "none";
          setTimeout(function() {
            style2.opacity = opacity;
            style2.transform = transform;
            style2.transition = transition;
          }, 0);
        }, DROPDOWN_TRANSITION_IN_DURATION);
      };
      Dropdown2.prototype.isVisible = function() {
        var _a = this.props, forceVisible = _a.visible, disabled2 = _a.disabled;
        if (disabled2) {
          return false;
        }
        var stateVisible = this.state.visible;
        return typeof forceVisible === "boolean" ? forceVisible : stateVisible;
      };
      Dropdown2.prototype.traverseFocus = function(e) {
        var container2 = this.dropContentRef.current;
        if (!container2) {
          return;
        }
        focus_1.traverseFocusIn(container2, e);
      };
      Dropdown2.prototype.isFocusInside = function() {
        var _a;
        return (_a = this.dropContentRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
      };
      Dropdown2.prototype.focusSelf = function() {
        var _this = this;
        if (this.props.autoFocus && this.isVisible() && !this.isFocusInside()) {
          focus_1.saveFocus();
          setTimeout(function() {
            var _a;
            !_this.isFocusInside() && ((_a = _this.dropContentRef.current) === null || _a === void 0 ? void 0 : _a.focus());
          }, DROPDOWN_TRANSITION_IN_DURATION);
        }
      };
      Dropdown2.prototype.restorePreviousFocus = function() {
        if (this.props.autoFocus) {
          focus_1.restoreFocus();
        }
      };
      Dropdown2.prototype.removePreviousClampedSize = function(callback) {
        this.setState({
          dropContentMetrics: tslib_12.__assign(tslib_12.__assign({}, this.state.dropContentMetrics), { height: void 0, width: void 0 })
        }, callback);
      };
      Dropdown2.prototype.calcHorizontalMetric = function(rootDomRect, dropContentDomRect) {
        var _a = this.props, alignment = _a.alignment, matchWidth = _a.matchWidth, viewportMargin = _a.viewportMargin;
        var rootWidth = rootDomRect.width, left = rootDomRect.left, right = rootDomRect.right;
        var selfWidth = dropContentDomRect.width;
        var innerWidth2 = window.innerWidth;
        var viewportGap = viewportMargin;
        var viewportRight = innerWidth2 - viewportGap;
        var actualAlignment = alignment;
        if (alignment === "auto") {
          var rightAvailableSpace = viewportRight - left;
          var leftAvailableSpace = right - viewportGap;
          if (selfWidth > rightAvailableSpace) {
            actualAlignment = rightAvailableSpace >= leftAvailableSpace ? "left" : "right";
          } else {
            actualAlignment = "left";
          }
        } else if (alignment === "auto-outer") {
          actualAlignment = left - selfWidth - viewportGap < 0 ? "right-outer" : "left-outer";
        }
        var result = {
          actualAlignment,
          metric: {}
        };
        if (matchWidth && !this.isOuterAlignment) {
          result.metric.left = left;
          result.metric.width = rootWidth;
          return result;
        }
        var viewportWidth = innerWidth2 - 2 * viewportGap;
        if (actualAlignment === "left") {
          if (selfWidth > viewportWidth) {
            result.metric.left = viewportGap;
            result.metric.width = viewportWidth;
          } else if (left + selfWidth > viewportRight) {
            result.metric.left = viewportRight - selfWidth;
          } else {
            result.metric.left = left;
          }
          return result;
        }
        if (actualAlignment === "right") {
          if (selfWidth > viewportWidth) {
            result.metric.left = viewportGap;
            result.metric.width = viewportWidth;
          } else if (right - selfWidth < viewportGap) {
            result.metric.left = viewportGap;
          } else {
            result.metric.left = right - selfWidth;
          }
          return result;
        }
        if (actualAlignment === "center") {
          result.metric.left = left + (rootWidth - selfWidth) / 2;
        } else if (actualAlignment === "left-outer") {
          result.metric.left = left - selfWidth;
        } else if (actualAlignment === "right-outer") {
          result.metric.left = right;
        }
        return result;
      };
      Dropdown2.prototype.calcVerticalMetric = function(rootDomRect, dropContentDomRect) {
        var _a = this.props, placement = _a.placement, viewportMargin = _a.viewportMargin;
        var bottom = rootDomRect.bottom, top = rootDomRect.top;
        var height = dropContentDomRect.height;
        var viewportGap = viewportMargin;
        var resultHeight;
        var resultTop = 0;
        var actualPlacement = "bottom";
        var isOuter = this.isOuterAlignment;
        var tryTop = function() {
          var anchor = isOuter ? bottom : top;
          resultTop = Math.max(viewportGap, anchor - height);
          resultHeight = anchor - resultTop;
          actualPlacement = "top";
          return resultHeight;
        };
        var tryBottom = function() {
          resultTop = isOuter ? top : bottom;
          resultHeight = Math.min(height, window.innerHeight - viewportGap - resultTop);
          actualPlacement = "bottom";
          return resultHeight;
        };
        if (placement === "top") {
          tryTop();
        } else if (placement === "bottom") {
          tryBottom();
        } else if (placement === "auto") {
          if (tryBottom() === height)
            ;
          else if (tryTop() === height)
            ;
          else {
            tryBottom() >= tryTop() ? tryBottom() : tryTop();
          }
        }
        return {
          metric: {
            top: resultTop + "px",
            height: resultHeight && resultHeight + "px"
          },
          actualPlacement
        };
      };
      Dropdown2.prototype.setStateVisible = function(visible) {
        this.setState({ visible });
        this.props.onVisibleChange(visible);
      };
      Dropdown2.prototype.consumeKeep = function(e) {
        var nativeEvent = e.nativeEvent;
        var result = Boolean(nativeEvent._dui_dropdown_keep);
        delete nativeEvent._dui_dropdown_keep;
        return result;
      };
      Dropdown2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      Dropdown2.contextType = context_1.DropdownContext;
      return Dropdown2;
    }(React2.Component);
    Dropdown.default = Dropdown$12;
    Dropdown$12.defaultProps = {
      prefixCls: "dui-dropdown",
      alignment: "auto",
      matchWidth: false,
      disabled: false,
      onVisibleChange: helper_1.emptyFn,
      placement: "auto",
      animated: true,
      trigger: "click",
      destroyOnClose: true,
      autoFocus: true,
      viewportMargin: 2
    };
    return Dropdown;
  }
  var Keep = {};
  var hasRequiredKeep;
  function requireKeep() {
    if (hasRequiredKeep)
      return Keep;
    hasRequiredKeep = 1;
    Object.defineProperty(Keep, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var PropTypes = tslib_12.__importStar(requirePropTypes());
    var theme_1 = requireTheme();
    var Trigger_1 = requireTrigger();
    var Keep$1 = function(_super) {
      tslib_12.__extends(Keep2, _super);
      function Keep2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseUp = function(e) {
          setTimeout(function() {
            _this.context(false);
          }, 0);
        };
        _this.handleClick = function(e) {
          var _a, _b;
          (_b = (_a = _this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
          var event = e.nativeEvent;
          if (_this.props.disabled || event._dui_bypass_dropdown_keep) {
            return;
          }
          event._dui_dropdown_keep = true;
        };
        _this.handleMouseDown = function(e) {
          _this.context(true);
        };
        _this.themedRender = function(classNames2) {
          var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, children = _a.children;
          _a.disabled;
          var rest = tslib_12.__rest(_a, ["prefixCls", "className", "style", "children", "disabled"]);
          var cls = classNames2(prefixCls, className);
          return h("div", tslib_12.__assign({}, rest, { className: cls, style: style2, onClick: _this.handleClick, onMouseDown: _this.handleMouseDown }), children);
        };
        return _this;
      }
      Keep2.prototype.componentDidMount = function() {
        document.addEventListener("mouseup", this.handleMouseUp);
      };
      Keep2.prototype.componentWillUnmount = function() {
        document.removeEventListener("mouseup", this.handleMouseUp);
      };
      Keep2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      Keep2.contextType = Trigger_1.TriggerContext;
      return Keep2;
    }(React2.Component);
    Keep.default = Keep$1;
    Keep$1.defaultProps = {
      prefixCls: "dui-dropdown-keep",
      disabled: false
    };
    Keep$1.propTypes = {
      prefixCls: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
      disabled: PropTypes.bool
    };
    return Keep;
  }
  Object.defineProperty(Dropdown$1, "__esModule", { value: true });
  var Dropdown_2 = Dropdown$1.Dropdown = void 0;
  var tslib_1$5 = tslib.exports;
  var Dropdown_1 = tslib_1$5.__importDefault(requireDropdown());
  Dropdown_2 = Dropdown$1.Dropdown = Dropdown_1.default;
  requireStyle().injectStyle("components/Dropdown/style/index.css", '[data-dui-0-122-1~="dui-dropdown-disabled"]{opacity:.6}@-webkit-keyframes dui-dropdown-slide-in-bottom{0%{opacity:0;-webkit-transform:scaleX(1) translateY(-20px);transform:scaleX(1) translateY(-20px)}to{opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}}@keyframes dui-dropdown-slide-in-bottom{0%{opacity:0;-webkit-transform:scaleX(1) translateY(-20px);transform:scaleX(1) translateY(-20px)}to{opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}}@-webkit-keyframes dui-dropdown-slide-in-top{0%{opacity:0;-webkit-transform:scaleX(1) translateY(20px);transform:scaleX(1) translateY(20px)}to{opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}}@keyframes dui-dropdown-slide-in-top{0%{opacity:0;-webkit-transform:scaleX(1) translateY(20px);transform:scaleX(1) translateY(20px)}to{opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}}[data-dui-0-122-1~="dui-dropdown"]{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:inline-block;-webkit-tap-highlight-color:transparent}[data-dui-0-122-1~="dui-dropdown-container"]{border-radius:2px}[data-dui-0-122-1~="dui-dropdown-container-visible"]{background:var(--tsp-fill-medium,rgba(51,77,102,.08))}[data-dui-0-122-1~="dui-dropdown-content"]{-webkit-box-sizing:border-box;box-sizing:border-box;position:fixed;z-index:9999;-webkit-transition-property:opacity,visibility,-webkit-transform;transition-property:opacity,visibility,-webkit-transform;transition-property:opacity,transform,visibility;transition-property:opacity,transform,visibility,-webkit-transform;-webkit-transition-timing-function:cubic-bezier(.4,0,.2,1);transition-timing-function:cubic-bezier(.4,0,.2,1);-webkit-tap-highlight-color:transparent;-webkit-animation-timing-function:cubic-bezier(.4,0,.2,1);animation-timing-function:cubic-bezier(.4,0,.2,1);-webkit-animation-duration:.24s;animation-duration:.24s}[data-dui-0-122-1~="dui-dropdown-content-bottom"]{-webkit-animation-name:dui-dropdown-slide-in-bottom;animation-name:dui-dropdown-slide-in-bottom}[data-dui-0-122-1~="dui-dropdown-content-top"]{-webkit-animation-name:dui-dropdown-slide-in-top;animation-name:dui-dropdown-slide-in-top}[data-dui-0-122-1~="dui-dropdown-content-left-outer"]{padding-right:5px}[data-dui-0-122-1~="dui-dropdown-content-right-outer"]{padding-left:5px}[data-dui-0-122-1~="dui-dropdown-content-inner"][data-dui-0-122-1~="dui-dropdown-content-bottom"]{padding-top:5px}[data-dui-0-122-1~="dui-dropdown-content-inner"][data-dui-0-122-1~="dui-dropdown-content-top"]{padding-bottom:5px}[data-dui-0-122-1~="dui-dropdown-content-visible"]{-webkit-transition-duration:.24s;transition-duration:.24s;visibility:visible;opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}[data-dui-0-122-1~="dui-dropdown-content-hidden"]{-webkit-transition-duration:.12s;transition-duration:.12s;visibility:hidden;pointer-events:none}[data-dui-0-122-1~="dui-dropdown-content-hidden"][data-dui-0-122-1~="dui-dropdown-content-bottom"]{opacity:0;-webkit-transform:scaleX(1) translateY(-20px);transform:scaleX(1) translateY(-20px)}[data-dui-0-122-1~="dui-dropdown-content-hidden"][data-dui-0-122-1~="dui-dropdown-content-top"]{opacity:0;-webkit-transform:scaleX(1) translateY(20px);transform:scaleX(1) translateY(20px)}[data-dui-0-122-1~="dui-dropdown-content-no-animation"]{-webkit-transition-duration:0s;transition-duration:0s;-webkit-animation-duration:0s;animation-duration:0s}');
  var Keep_1 = tslib_1$5.__importDefault(requireKeep());
  Dropdown_1.default.Keep = Keep_1.default;
  var _default$4 = Dropdown$1.default = Dropdown_1.default;
  var Menu$1 = {};
  var Menu = {};
  var hasRequiredMenu;
  function requireMenu() {
    if (hasRequiredMenu)
      return Menu;
    hasRequiredMenu = 1;
    Object.defineProperty(Menu, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    var context_1 = requireContext$2();
    var context_2 = requireContext$3();
    var theme_1 = requireTheme();
    var focus_1 = requireFocus();
    var Menu$12 = function(_super) {
      tslib_12.__extends(Menu2, _super);
      function Menu2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listRef = React2.createRef();
        _this.clickedIds = [];
        _this.selectedItemDoms = /* @__PURE__ */ new Set();
        _this.handleClick = function(e) {
          if (_this.clickedIds.length === 0) {
            return;
          }
          var id = _this.clickedIds.shift();
          _this.clickedIds = [];
          _this.props.onClick(id, e);
          _this.context.onClick();
        };
        _this.handleItemClick = function(id) {
          _this.clickedIds.push(id);
        };
        _this.handleContextMenu = function(e) {
          e.preventDefault();
        };
        _this.handleKeyDown = function(e) {
          if (!_this.isVisible()) {
            return;
          }
          var container2 = _this.listRef.current;
          if (e.key === "ArrowDown") {
            focus_1.traverseFocusIn(container2, e, false);
          } else if (e.key === "ArrowUp") {
            focus_1.traverseFocusIn(container2, e, true);
          }
        };
        _this.themedRender = function(classNames2) {
          var _a;
          var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style2 = _b.style, children = _b.children, itemStyle = _b.itemStyle, selectedIds = _b.selectedIds, type = _b.type, itemClassName = _b.itemClassName, selectable = _b.selectable, subMenuViewportMargin = _b.subMenuViewportMargin, testId = _b.testId;
          _b.onClick;
          _b.visible;
          _b.keyDownEventDom;
          var rest = tslib_12.__rest(_b, ["prefixCls", "className", "style", "children", "itemStyle", "selectedIds", "type", "itemClassName", "selectable", "subMenuViewportMargin", "testId", "onClick", "visible", "keyDownEventDom"]);
          var selfVisible = _this.isVisible();
          var cls = classNames2(prefixCls, prefixCls + "-" + type, className, (_a = {}, _a[prefixCls + "-hidden"] = !selfVisible, _a[prefixCls + "-non-selectable"] = !selectable, _a));
          return h(context_1.DropdownContext.Consumer, null, function(_a2) {
            var dropdownVisible = _a2.visible;
            return h(
              context_2.MenuItemContext.Provider,
              { value: context_2.getMenuItemContext({
                itemStyle,
                itemClassName,
                clickHandler: _this.handleItemClick,
                selectedIds,
                selectedItemDoms: _this.selectedItemDoms
              }) },
              h(
                context_2.SubMenuContext.Provider,
                { value: context_2.getSubMenuContext({
                  zIndex: 1e4,
                  visible: dropdownVisible && selfVisible,
                  type,
                  horizontalPlacement: "right",
                  viewportMargin: subMenuViewportMargin
                }) },
                h("ul", tslib_12.__assign({ className: cls, style: style2, onClick: _this.handleClick, onContextMenu: _this.handleContextMenu, role: "menu", "aria-haspopup": true, ref: _this.listRef, "data-testid": testId }, rest), children)
              )
            );
          });
        };
        return _this;
      }
      Object.defineProperty(Menu2.prototype, "keyDownDom", {
        get: function() {
          return this.props.keyDownEventDom === void 0 ? document : this.props.keyDownEventDom;
        },
        enumerable: false,
        configurable: true
      });
      Menu2.prototype.isVisible = function() {
        return this.context.visible && this.props.visible;
      };
      Menu2.prototype.scrollToSelected = function() {
        var _a;
        var selectedDoms = Array.from(this.selectedItemDoms.values());
        (_a = selectedDoms[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
      };
      Menu2.prototype.componentDidMount = function() {
        var _a;
        this.forceUpdate();
        (_a = this.keyDownDom) === null || _a === void 0 ? void 0 : _a.addEventListener("keydown", this.handleKeyDown);
      };
      Menu2.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.keyDownDom) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", this.handleKeyDown);
      };
      Menu2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      Menu2.contextType = context_2.ContextMenuContext;
      return Menu2;
    }(React2.Component);
    Menu.default = Menu$12;
    Menu$12.defaultProps = {
      prefixCls: "dui-menu",
      onClick: helper_1.emptyFn,
      selectedIds: [],
      visible: true,
      type: "normal",
      selectable: true,
      subMenuViewportMargin: 2
    };
    return Menu;
  }
  var Item = {};
  var hasRequiredItem;
  function requireItem() {
    if (hasRequiredItem)
      return Item;
    hasRequiredItem = 1;
    Object.defineProperty(Item, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    var context_1 = requireContext$3();
    var Keep_12 = tslib_12.__importDefault(requireKeep());
    var theme_1 = requireTheme();
    var Dropdown_12 = tslib_12.__importDefault(Dropdown$1);
    var Item$1 = function(_super) {
      tslib_12.__extends(Item2, _super);
      function Item2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React2.createRef();
        _this.state = {
          actionActive: false
        };
        _this.refDom = function(dom) {
          _this.domRef.current = dom;
          var propRef = _this.props.domRef;
          var selectedItemDoms = _this.context.selectedItemDoms;
          if (_this.isSelected()) {
            selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.add(dom);
          } else {
            selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.delete(dom);
          }
          if (!propRef) {
            return;
          }
          if (typeof propRef === "function") {
            propRef(dom);
          } else {
            propRef.current = dom;
          }
        };
        _this.handleClick = function(e) {
          var _a;
          var clickHandler = _this.context.clickHandler;
          var _b = _this.props, disabled2 = _b.disabled, onClick = _b.onClick;
          if (e.detail) {
            (_a = _this.domRef.current) === null || _a === void 0 ? void 0 : _a.blur();
          }
          if (disabled2 || e.nativeEvent._dui_menu_item_action) {
            return;
          }
          var result = onClick(e);
          if (result === false) {
            return;
          }
          if (!e.isPropagationStopped()) {
            clickHandler(_this.props.id);
          }
        };
        _this.handleKeyDown = function(e) {
          var _a;
          var _b = _this.props, disabled2 = _b.disabled, onKeyDown = _b.onKeyDown;
          if (disabled2) {
            return;
          }
          var result = onKeyDown(e);
          if (result === false) {
            return;
          }
          if ([" ", "Enter"].includes(e.key)) {
            e.preventDefault();
            (_a = _this.domRef.current) === null || _a === void 0 ? void 0 : _a.click();
          }
        };
        _this.handleActionClick = function(e) {
          e.nativeEvent._dui_menu_item_action = true;
        };
        _this.handleToggleAction = function(actionActive) {
          _this.setState({ actionActive });
        };
        _this.handleMouseEnter = function(e) {
          var _a = _this.props, disabled2 = _a.disabled, onMouseEnter = _a.onMouseEnter;
          if (disabled2) {
            return;
          }
          onMouseEnter(e);
        };
        _this.handleMouseLeave = function(e) {
          var _a = _this.props, disabled2 = _a.disabled, onMouseLeave = _a.onMouseLeave;
          if (disabled2) {
            return;
          }
          onMouseLeave(e);
        };
        _this.themedRender = function(classNames2) {
          var _a;
          var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style2 = _b.style, disabled2 = _b.disabled, description = _b.description, htmlId = _b.htmlId, containerClassName = _b.containerClassName, containerStyle = _b.containerStyle, testId = _b.testId, action = _b.action;
          _b.id;
          _b.children;
          _b.icon;
          _b.onClick;
          _b.onKeyDown;
          _b.selected;
          _b.domRef;
          _b.actionTriggersDropdownHide;
          _b.onMouseEnter;
          _b.onMouseLeave;
          var rest = tslib_12.__rest(_b, ["prefixCls", "className", "style", "disabled", "description", "htmlId", "containerClassName", "containerStyle", "testId", "action", "id", "children", "icon", "onClick", "onKeyDown", "selected", "domRef", "actionTriggersDropdownHide", "onMouseEnter", "onMouseLeave"]);
          var actionActive = _this.state.actionActive;
          var _c = _this.context, itemStyle = _c.itemStyle, itemClassName = _c.itemClassName;
          var selected = _this.isSelected();
          var cls = classNames2(prefixCls, className, itemClassName, (_a = {}, _a[prefixCls + "-disabled"] = disabled2, _a[prefixCls + "-selected"] = selected, _a[prefixCls + "-with-action"] = action, _a[prefixCls + "-with-action-active"] = actionActive, _a));
          var containerCls = classNames2(prefixCls + "-container", containerClassName);
          return h(
            Keep_12.default,
            { disabled: !disabled2, className: containerCls, style: containerStyle },
            h(
              "li",
              tslib_12.__assign({ className: cls, style: tslib_12.__assign(tslib_12.__assign({}, itemStyle), style2), onClick: _this.handleClick, ref: _this.refDom, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave, role: "menuitem", "aria-disabled": disabled2, "aria-checked": selected, tabIndex: disabled2 ? -1 : 0, onKeyDown: _this.handleKeyDown, id: htmlId, "data-testid": testId }, rest),
              _this.renderChildren(classNames2),
              description ? h("span", { className: classNames2(prefixCls + "-description") }, description) : null,
              _this.renderAdditionalAction(classNames2)
            )
          );
        };
        return _this;
      }
      Item2.prototype.isSelected = function() {
        if (typeof this.props.selected === "boolean") {
          return this.props.selected;
        }
        return this.context.selectedIds.indexOf(this.props.id) !== -1;
      };
      Item2.prototype.renderChildren = function(classNames2) {
        var _a = this.props, prefixCls = _a.prefixCls, children = _a.children, icon = _a.icon;
        var iconElem = icon ? typeof icon === "string" ? h("div", { className: classNames2(prefixCls + "-icon"), style: { backgroundImage: 'url("' + icon + '")' } }) : icon : null;
        var content = typeof children === "string" ? h("div", { className: classNames2(prefixCls + "-text-container") }, children) : children;
        return iconElem ? h(
          "div",
          { className: classNames2(prefixCls + "-icon-container") },
          iconElem,
          content
        ) : content;
      };
      Item2.prototype.renderAdditionalAction = function(classNames2) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, action = _c.action, actionTriggersDropdownHide = _c.actionTriggersDropdownHide;
        var actionActive = this.state.actionActive;
        if (!action) {
          return null;
        }
        var wrapperClassName = classNames2(prefixCls + "-action-wrapper", (_a = {}, _a[prefixCls + "-action-wrapper-active"] = actionActive, _a));
        var actionClassName = classNames2(prefixCls + "-action", (_b = {}, _b[prefixCls + "-action-active"] = actionActive, _b));
        return h(
          Dropdown_12.default.Keep,
          { className: wrapperClassName, onClick: this.handleActionClick, disabled: actionTriggersDropdownHide },
          h(
            Dropdown_12.default,
            { dropContent: action, alignment: "right-outer", dropContentClassName: classNames2(prefixCls + "-action-content"), visible: actionActive, onVisibleChange: this.handleToggleAction },
            h(Dropdown_12.default.Keep, { className: actionClassName })
          )
        );
      };
      Item2.prototype.componentWillUnmount = function() {
        var selectedItemDoms = this.context.selectedItemDoms;
        var dom = this.domRef.current;
        selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.delete(dom);
      };
      Item2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      Item2.contextType = context_1.MenuItemContext;
      return Item2;
    }(React2.Component);
    Item.default = Item$1;
    Item$1.defaultProps = {
      prefixCls: "dui-menu-item",
      id: "",
      onMouseEnter: helper_1.emptyFn,
      onMouseLeave: helper_1.emptyFn,
      onClick: helper_1.emptyFn,
      disabled: false,
      onKeyDown: helper_1.emptyFn,
      actionTriggersDropdownHide: true
    };
    return Item;
  }
  var SubMenu = {};
  var hasRequiredSubMenu;
  function requireSubMenu() {
    if (hasRequiredSubMenu)
      return SubMenu;
    hasRequiredSubMenu = 1;
    Object.defineProperty(SubMenu, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
    var Item_12 = tslib_12.__importDefault(requireItem());
    var context_1 = requireContext$3();
    var Keep_12 = tslib_12.__importDefault(requireKeep());
    var theme_1 = requireTheme();
    var helper_1 = requireHelper();
    var focus_1 = requireFocus();
    var DEFAULT_METRICS = {
      verticalPlacement: "bottom",
      horizontalPlacement: "right",
      location: { left: "0px", top: "0px" },
      forcedHeight: 0
    };
    var SUBMENU_OFFSET = -2;
    var SubMenu$1 = function(_super) {
      tslib_12.__extends(SubMenu2, _super);
      function SubMenu2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemRef = React2.createRef();
        _this.popupWrapperRef = React2.createRef();
        _this.popupContentRef = React2.createRef();
        _this.state = {
          visible: false,
          metrics: tslib_12.__assign({}, DEFAULT_METRICS)
        };
        _this.handleMouseEnter = function() {
          clearTimeout(_this.hideTimeout);
          if (_this.props.disabled || _this.isVisible()) {
            return;
          }
          clearTimeout(_this.showTimeout);
          _this.showTimeout = setTimeout(function() {
            _this.setState({
              metrics: tslib_12.__assign(tslib_12.__assign({}, _this.state.metrics), { forcedHeight: 0 })
            }, function() {
              _this.updatePopoutMetrics();
              _this.setStateVisible(true);
            });
          }, _this.props.hoverDelay);
        };
        _this.handleMouseLeave = function(e) {
          if (_this.props.disabled || !e.relatedTarget) {
            return;
          }
          clearTimeout(_this.showTimeout);
          _this.hideTimeout = setTimeout(function() {
            return _this.setStateVisible(false);
          }, _this.props.hoverDelay);
        };
        _this.handleLeavePage = function() {
          if (_this.props.disabled || document.visibilityState !== "hidden") {
            return;
          }
          _this.setStateVisible(false);
        };
        _this.handleSubmenuClick = function(e) {
          var onClick = _this.props.onClick;
          if (onClick) {
            var shouldKeep = onClick(e) === false;
            if (!shouldKeep) {
              var keepEvent = e.nativeEvent;
              keepEvent._dui_bypass_dropdown_keep = true;
            }
            return true;
          }
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          return false;
        };
        _this.handleSubMenuItemKeyDown = function(e) {
          if (_this.props.disabled) {
            return false;
          }
          if ([" ", "Enter", "ArrowRight"].includes(e.key)) {
            _this.handleMouseEnter();
            e.preventDefault();
            setTimeout(function() {
              var container2 = _this.popupContentRef.current;
              container2 && focus_1.traverseFocusIn(container2, null, false);
            }, 50);
          }
          return false;
        };
        _this.handleContentKeyDown = function(e) {
          var _a;
          if (_this.props.disabled) {
            return;
          }
          var container2 = _this.popupContentRef.current;
          e.stopPropagation();
          if (["ArrowDown", "ArrowUp"].includes(e.key)) {
            e.nativeEvent.stopImmediatePropagation();
            focus_1.traverseFocusIn(container2, e, e.key === "ArrowUp");
          }
          if (e.key === "ArrowLeft") {
            _this.setStateVisible(false);
            (_a = _this.itemDom) === null || _a === void 0 ? void 0 : _a.focus();
          }
        };
        _this.themedRender = function(classNames2) {
          var _a, _b;
          var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style2 = _c.style, children = _c.children, id = _c.id, title2 = _c.title, disabled2 = _c.disabled, popupStyle = _c.popupStyle, popupClassName = _c.popupClassName, forcedZIndex = _c.zIndex, icon = _c.icon, selectable = _c.selectable, propType = _c.type, description = _c.description, selected = _c.selected, testId = _c.testId, popupTestId = _c.popupTestId, onClick = _c.onClick, containerDom = _c.containerDom;
          var _d = _this.context, contextZIndex = _d.zIndex, parentType = _d.type;
          var _e = _this.state.metrics, location2 = _e.location, verticalPlacement = _e.verticalPlacement, forcedHeight = _e.forcedHeight, horizontalPlacement = _e.horizontalPlacement;
          var zIndex = forcedZIndex || contextZIndex;
          var visible = _this.isVisible();
          var cls = classNames2(prefixCls, className, (_a = {}, _a[prefixCls + "-disabled"] = disabled2, _a[prefixCls + "-with-desc"] = description, _a[prefixCls + "-clickable"] = onClick, _a));
          var popupWrapperCls = classNames2(prefixCls + "-wrapper", prefixCls + "-wrapper-" + (visible ? "visible" : "hidden-" + verticalPlacement));
          var type = propType || parentType;
          var contentCls = classNames2(prefixCls + "-content", popupClassName, prefixCls + "-content-" + type, (_b = {}, _b[prefixCls + "-content-non-selectable"] = !selectable, _b));
          return h(
            context_1.SubMenuContext.Provider,
            { value: context_1.getSubMenuContext({
              zIndex: zIndex + 1,
              visible,
              type,
              horizontalPlacement,
              viewportMargin: _this.context.viewportMargin
            }) },
            h(
              "div",
              { onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave },
              h(
                Keep_12.default,
                null,
                h(Item_12.default, { id, className: cls, style: style2, ref: _this.itemRef, disabled: disabled2, onClick: _this.handleSubmenuClick, onKeyDown: _this.handleSubMenuItemKeyDown, icon, description, selected, "data-testid": testId }, title2 || id)
              ),
              react_dom_1.default.createPortal(h(
                "div",
                { className: popupWrapperCls, ref: _this.popupWrapperRef, style: tslib_12.__assign(tslib_12.__assign({}, location2), { zIndex }) },
                h("ul", { className: contentCls, style: tslib_12.__assign({ height: forcedHeight ? forcedHeight + "px" : void 0 }, popupStyle), ref: _this.popupContentRef, role: "menu", "aria-haspopup": true, "aria-expanded": visible, onKeyDown: _this.handleContentKeyDown, "data-testid": popupTestId }, children)
              ), containerDom || document.body)
            )
          );
        };
        return _this;
      }
      SubMenu2.getDerivedStateFromProps = function(props, state) {
        if (props.disabled) {
          return { visible: false };
        }
        return null;
      };
      Object.defineProperty(SubMenu2.prototype, "itemDom", {
        get: function() {
          var _a;
          return (_a = this.itemRef.current) === null || _a === void 0 ? void 0 : _a.domRef.current;
        },
        enumerable: false,
        configurable: true
      });
      SubMenu2.prototype.componentDidMount = function() {
        document.addEventListener("visibilitychange", this.handleLeavePage);
      };
      SubMenu2.prototype.componentWillUnmount = function() {
        document.removeEventListener("visibilitychange", this.handleLeavePage);
        clearTimeout(this.hideTimeout);
        clearTimeout(this.showTimeout);
      };
      SubMenu2.prototype.updatePopoutMetrics = function() {
        var itemDom = this.itemDom;
        if (!itemDom) {
          return;
        }
        var popupDom = this.popupWrapperRef.current;
        if (!popupDom) {
          return;
        }
        var maxRight = window.innerWidth, maxBottom = window.innerHeight;
        var _a = itemDom.getBoundingClientRect(), parentRight = _a.right, parentLeft = _a.left, parentTop = _a.top, parentBottom = _a.bottom;
        var _b = popupDom.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = this.context, parentMenuPlacement = _c.horizontalPlacement, viewportMargin = _c.viewportMargin;
        var availableDirections = [];
        if (parentRight + width < maxRight) {
          availableDirections.push("right");
        }
        if (parentLeft - width > 0) {
          availableDirections.push("left");
        }
        var horizontalPlacement = availableDirections.includes(parentMenuPlacement) ? parentMenuPlacement : availableDirections[0] || "right";
        var gap = viewportMargin;
        var remainingBottom = maxBottom - parentTop - gap;
        var remainingTop = parentBottom - gap;
        var verticalPlacement = "bottom";
        var forcedHeight = 0;
        if (height >= remainingBottom) {
          if (height >= remainingTop) {
            if (remainingBottom >= remainingTop) {
              verticalPlacement = "bottom";
              forcedHeight = remainingBottom;
            } else {
              verticalPlacement = "top";
              forcedHeight = remainingTop;
            }
          } else {
            verticalPlacement = "top";
          }
        } else {
          verticalPlacement = "bottom";
        }
        var resultLeft = window.pageXOffset + (horizontalPlacement === "right" ? parentRight + SUBMENU_OFFSET : parentLeft - width - SUBMENU_OFFSET);
        var resultTop = window.pageYOffset + (verticalPlacement === "bottom" ? parentTop : parentBottom - (forcedHeight || height));
        var result = {
          verticalPlacement,
          horizontalPlacement,
          location: { left: resultLeft + "px", top: resultTop + "px" },
          forcedHeight
        };
        this.setState({ metrics: result });
      };
      SubMenu2.prototype.isVisible = function() {
        var selfVisible = this.state.visible;
        var parentVisible = this.context.visible;
        var disabled2 = this.props.disabled;
        return parentVisible && selfVisible && !disabled2;
      };
      SubMenu2.prototype.setStateVisible = function(visible) {
        var _this = this;
        this.setState({ visible }, function() {
          _this.props.onVisibleChange(visible);
        });
      };
      SubMenu2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      SubMenu2.contextType = context_1.SubMenuContext;
      return SubMenu2;
    }(React2.Component);
    SubMenu.default = SubMenu$1;
    SubMenu$1.defaultProps = {
      prefixCls: "dui-menu-submenu",
      id: "",
      disabled: false,
      onVisibleChange: helper_1.emptyFn,
      selectable: true,
      hoverDelay: 100
    };
    return SubMenu;
  }
  var ContextMenu = {};
  var hasRequiredContextMenu;
  function requireContextMenu() {
    if (hasRequiredContextMenu)
      return ContextMenu;
    hasRequiredContextMenu = 1;
    Object.defineProperty(ContextMenu, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
    var PropTypes = tslib_12.__importStar(requirePropTypes());
    var Trigger_1 = tslib_12.__importDefault(requireTrigger());
    var helper_1 = requireHelper();
    var theme_1 = requireTheme();
    var context_1 = requireContext$3();
    var throttle_12 = tslib_12.__importDefault(requireThrottle());
    var DEFAULT_METRICS = {
      horizontal: "right",
      vertical: "bottom",
      height: 0
    };
    var ContextMenu$1 = function(_super) {
      tslib_12.__extends(ContextMenu2, _super);
      function ContextMenu2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popupRef = React2.createRef();
        _this.anchorRef = React2.createRef();
        _this.state = {
          visible: false,
          menu: null,
          location: {
            left: 0,
            top: 0
          },
          metrics: tslib_12.__assign({}, DEFAULT_METRICS)
        };
        _this.handleScroll = throttle_12.default(function(e) {
          var _a;
          if ((_a = _this.popupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            return;
          }
          _this.hide();
        }, 30);
        _this.handleContextMenu = function(e) {
          e.preventDefault();
          var _a = _this.props, menu2 = _a.menu, disabled2 = _a.disabled, onVisibleChange = _a.onVisibleChange;
          if (disabled2) {
            return;
          }
          _this.setState({
            menu: typeof menu2 === "function" ? menu2(e) : menu2,
            visible: false,
            location: { left: e.pageX, top: e.pageY },
            metrics: tslib_12.__assign(tslib_12.__assign({}, _this.state.metrics), { height: 0 })
          }, function() {
            _this.updatePopoutMetrics();
            _this.setState({ visible: true }, function() {
              onVisibleChange(true);
            });
          });
        };
        _this.hide = function() {
          if (!_this.isVisible()) {
            return;
          }
          _this.setState({ visible: false }, function() {
            _this.props.onVisibleChange(false);
          });
        };
        _this.themedRender = function(classNames2) {
          var _a;
          var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style2 = _b.style, children = _b.children, disabled2 = _b.disabled, popupStyle = _b.popupStyle, zIndex = _b.zIndex, popupClassName = _b.popupClassName;
          var visible = _this.isVisible();
          var cls = classNames2(prefixCls, className, (_a = {}, _a[prefixCls + "-disabled"] = disabled2, _a));
          var _c = _this.state, _d = _c.location, left = _d.left, top = _d.top, menu2 = _c.menu, _e = _c.metrics, height = _e.height, vertical = _e.vertical, horizontal = _e.horizontal;
          var popupCls = classNames2(prefixCls + "-popup", popupClassName, prefixCls + "-popup-" + horizontal + "-" + vertical, prefixCls + "-popup-" + (visible ? "visible" : "hidden"));
          return h(
            Trigger_1.default,
            { action: _this.hide },
            h("div", { className: cls, style: style2, onContextMenu: _this.handleContextMenu, ref: _this.anchorRef }, children),
            react_dom_1.default.createPortal(h(
              Trigger_1.default,
              { className: popupCls, style: tslib_12.__assign({ left: left + "px", top: top + "px", height: height ? height + "px" : void 0, zIndex }, popupStyle), action: _this.hide, domRef: _this.popupRef, disableContextMenu: true },
              h(context_1.ContextMenuContext.Provider, { value: context_1.getContextMenuContext({ visible, onClick: _this.hide }) }, menu2)
            ), document.body)
          );
        };
        return _this;
      }
      ContextMenu2.getDerivedStateFromProps = function(props, state) {
        if (props.disabled) {
          return { visible: false };
        }
        return null;
      };
      ContextMenu2.prototype.componentDidMount = function() {
        document.addEventListener("scroll", this.handleScroll, { passive: true, capture: true });
        document.addEventListener("wheel", this.handleScroll);
      };
      ContextMenu2.prototype.componentWillUnmount = function() {
        document.removeEventListener("scroll", this.handleScroll);
        document.removeEventListener("wheel", this.handleScroll);
      };
      ContextMenu2.prototype.isVisible = function() {
        var _a = this.props, forceVisible = _a.visible, disabled2 = _a.disabled;
        if (disabled2) {
          return false;
        }
        var stateVisible = this.state.visible;
        return typeof forceVisible === "boolean" ? forceVisible : stateVisible;
      };
      ContextMenu2.prototype.updatePopoutMetrics = function() {
        var _a = this.props, popupBoundary = _a.popupBoundary, popupMargin = _a.popupMargin;
        var anchorDom = this.anchorRef.current;
        var popupDom = this.popupRef.current;
        if (!popupDom || !anchorDom) {
          return;
        }
        var _b = this.state.location, left = _b.left, top = _b.top;
        var targetLeft = left - window.pageXOffset;
        var targetTop = top - window.pageYOffset;
        var maxLeft = 0, maxRight = window.innerWidth, maxTop = 0, maxBottom = window.innerHeight;
        var _c = anchorDom.getBoundingClientRect(), containerLeft = _c.left, containerRight = _c.right, containerTop = _c.top, containerBottom = _c.bottom;
        if (popupBoundary === "container") {
          maxLeft = Math.max(maxLeft, containerLeft);
          maxRight = Math.min(maxRight, containerRight);
          maxTop = Math.max(maxTop, containerTop);
          maxBottom = Math.min(maxBottom, containerBottom);
        }
        maxLeft += popupMargin;
        maxRight -= popupMargin;
        maxTop += popupMargin;
        maxBottom -= popupMargin;
        var _d = popupDom.getBoundingClientRect(), width = _d.width, height = _d.height;
        var horizontal = targetLeft + width <= maxRight ? "right" : targetLeft <= (maxRight + maxLeft) / 2 ? "right" : "left";
        var remainingBottom = maxBottom - targetTop, remainingTop = targetTop - maxTop;
        var vertical = "bottom";
        var forcedHeight = 0;
        if (height > remainingBottom) {
          if (height > remainingTop) {
            if (remainingBottom >= remainingTop) {
              vertical = "bottom";
              forcedHeight = remainingBottom;
            } else {
              vertical = "top";
              forcedHeight = remainingTop;
            }
          } else {
            vertical = "top";
          }
        } else {
          vertical = "bottom";
        }
        var result = {
          horizontal,
          vertical,
          height: forcedHeight
        };
        this.setState({ metrics: result });
      };
      ContextMenu2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return ContextMenu2;
    }(React2.Component);
    ContextMenu.default = ContextMenu$1;
    ContextMenu$1.defaultProps = {
      prefixCls: "dui-menu-contextmenu",
      disabled: false,
      popupBoundary: "viewport",
      popupMargin: 0,
      onVisibleChange: helper_1.emptyFn
    };
    ContextMenu$1.propTypes = {
      prefixCls: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
      menu: PropTypes.any,
      disabled: PropTypes.bool,
      popupStyle: PropTypes.object,
      popupClassName: PropTypes.string,
      visible: PropTypes.bool,
      popupBoundary: PropTypes.oneOf(["container", "viewport"]),
      popupMargin: PropTypes.number,
      onVisibleChange: PropTypes.func,
      zIndex: PropTypes.number
    };
    return ContextMenu;
  }
  var Input$2 = {};
  var Input$1 = {};
  var Input = {};
  var context$1 = {};
  var hasRequiredContext$1;
  function requireContext$1() {
    if (hasRequiredContext$1)
      return context$1;
    hasRequiredContext$1 = 1;
    Object.defineProperty(context$1, "__esModule", { value: true });
    context$1.FormItemContext = void 0;
    var tslib_12 = tslib.exports;
    var React2 = tslib_12.__importStar(React__default.default);
    context$1.FormItemContext = React2.createContext({
      status: "default"
    });
    return context$1;
  }
  var hasRequiredInput$2;
  function requireInput$2() {
    if (hasRequiredInput$2)
      return Input;
    hasRequiredInput$2 = 1;
    Object.defineProperty(Input, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    var context_1 = requireContext$1();
    var theme_1 = requireTheme();
    var Input$12 = function(_super) {
      tslib_12.__extends(Input2, _super);
      function Input2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leftIconRef = React2.createRef();
        _this.rightIconsRef = React2.createRef();
        _this.state = {
          value: _this.props.defaultValue
        };
        _this.handleChange = function(e) {
          if (_this.props.disabled) {
            return;
          }
          var value = e.target.value;
          _this.props.onChange(value, e);
          _this.setState({ value });
        };
        _this.preventLoseFocus = function(e) {
          e.preventDefault();
        };
        _this.handleClear = function() {
          _this.setState({ value: "" }, function() {
            _this.props.onChange("");
          });
        };
        _this.handleIconKeyDown = function(handler) {
          return function(e) {
            var disabled2 = _this.props.disabled;
            if (disabled2 || !handler) {
              return;
            }
            if ([" ", "Enter"].includes(e.key)) {
              e.preventDefault();
              handler();
            }
          };
        };
        _this.themedRender = function(classNames2) {
          var _a, _b;
          var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style2 = _c.style, disabled2 = _c.disabled, underline = _c.underline;
          _c.icon;
          var leftIcon = _c.leftIcon;
          _c.onClickIcon;
          var onClickLeftIcon = _c.onClickLeftIcon;
          _c.onChange;
          var inputStyle = _c.inputStyle;
          _c.showClear;
          var forcedValue = _c.value;
          _c.defaultValue;
          var inputRef = _c.inputRef, inputClassName = _c.inputClassName, testId = _c.testId, errorTip = _c.errorTip, rest = tslib_12.__rest(_c, ["prefixCls", "className", "style", "disabled", "underline", "icon", "leftIcon", "onClickIcon", "onClickLeftIcon", "onChange", "inputStyle", "showClear", "value", "defaultValue", "inputRef", "inputClassName", "testId", "errorTip"]);
          var stateValue = _this.state.value;
          var status = _this.status;
          var value = typeof forcedValue === "string" ? forcedValue : stateValue;
          var cls = classNames2(prefixCls, className, (_a = {}, _a[prefixCls + "-disabled"] = disabled2, _a));
          var inputCls = classNames2(prefixCls + "-input", inputClassName, prefixCls + "-input-" + status, (_b = {}, _b[prefixCls + "-input-underline"] = underline, _b));
          var errorTipCls = classNames2(prefixCls + "-error-text");
          var clearVisible = !!(value && !disabled2);
          return h(
            "div",
            { className: cls, style: style2, "data-testid": testId },
            _this.renderSingleIcon({
              prop: leftIcon,
              description: "left",
              handler: onClickLeftIcon,
              ref: _this.leftIconRef
            }, classNames2),
            h("input", tslib_12.__assign({ className: inputCls, style: tslib_12.__assign(tslib_12.__assign({}, _this.getIconPaddings()), inputStyle), onChange: _this.handleChange, value, disabled: disabled2, ref: inputRef }, rest)),
            _this.renderRightIcons(clearVisible, classNames2),
            errorTip && h("div", { className: errorTipCls }, errorTip)
          );
        };
        return _this;
      }
      Input2.prototype.componentDidMount = function() {
        this.forceUpdate();
      };
      Object.defineProperty(Input2.prototype, "status", {
        get: function() {
          if (this.props.errorTip) {
            return "error";
          }
          return this.context.status;
        },
        enumerable: false,
        configurable: true
      });
      Input2.prototype.getIconPaddings = function() {
        var leftIconDom = this.leftIconRef.current;
        var rightIconsDom = this.rightIconsRef.current;
        var result = {};
        var gap = 2;
        if (leftIconDom) {
          result.paddingLeft = leftIconDom.getBoundingClientRect().width + gap + "px";
        }
        if (rightIconsDom) {
          result.paddingRight = rightIconsDom.getBoundingClientRect().width + gap + "px";
        }
        return result;
      };
      Input2.prototype.renderSingleIcon = function(_a, classNames2) {
        var _b;
        var prop = _a.prop, description = _a.description, handler = _a.handler, ref = _a.ref;
        var _c = this.props, prefixCls = _c.prefixCls, underline = _c.underline;
        var cls = classNames2(prefixCls + "-icon", (_b = {}, _b[prefixCls + "-icon-" + description] = description, _b[prefixCls + "-icon-clickable"] = handler, _b[prefixCls + "-icon-underline"] = underline, _b));
        return prop ? h("div", { className: cls, onMouseDown: this.preventLoseFocus, onClick: handler, ref, tabIndex: handler ? 0 : -1, onKeyDown: handler ? this.handleIconKeyDown(handler) : void 0, role: "button" }, typeof prop === "string" ? h("span", { className: classNames2(prefixCls + "-icon-img"), style: { backgroundImage: 'url("' + prop + '")' } }) : prop) : null;
      };
      Input2.prototype.renderRightIcons = function(clearVisible, classNames2) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, showClear = _c.showClear, icon = _c.icon, onClickIcon = _c.onClickIcon, underline = _c.underline;
        var clearCls = classNames2(prefixCls + "-clear", (_a = {}, _a[prefixCls + "-clear-visible"] = clearVisible, _a[prefixCls + "-icon"] = !underline, _a[prefixCls + "-clear-underline"] = underline, _a));
        var containerCls = classNames2(prefixCls + "-icon-container", (_b = {}, _b[prefixCls + "-icon-container-underline"] = underline, _b));
        return showClear || icon ? h(
          "div",
          { className: containerCls, ref: this.rightIconsRef },
          showClear ? h("button", { className: clearCls, onMouseDown: this.preventLoseFocus, onClick: this.handleClear }) : null,
          this.renderSingleIcon({
            prop: icon,
            handler: onClickIcon
          }, classNames2)
        ) : null;
      };
      Input2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      Input2.contextType = context_1.FormItemContext;
      return Input2;
    }(React2.Component);
    Input.default = Input$12;
    Input$12.defaultProps = {
      prefixCls: "dui-input",
      onChange: helper_1.emptyFn,
      showClear: false,
      defaultValue: ""
    };
    return Input;
  }
  var Password = {};
  var hasRequiredPassword;
  function requirePassword() {
    if (hasRequiredPassword)
      return Password;
    hasRequiredPassword = 1;
    Object.defineProperty(Password, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var react_12 = tslib_12.__importDefault(React__default.default);
    var Input_12 = tslib_12.__importDefault(requireInput$2());
    var theme_1 = requireTheme();
    var openEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIuNjM3Ij48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgZD0iTTE1Ljk0NiA5LjIyOEE3LjcyIDcuNzIgMCAwIDAgMi4zNTEgOS4xM2E3LjcxNyA3LjcxNyAwIDAgMCAxMy41OTUuMDk4eiIvPjxwYXRoIHN0cm9rZT0iI2ZmZiIgZD0iTTkuMTUgMTIuMjAyYTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNnoiLz48L3N2Zz4=";
    var closedEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PHBhdGggZD0iTTEuODU2IDEwLjc5NGwyLjIxMy0zLjMzTTYuNDE3IDEzbC45MTItMy43NDNtOC44NjcgMS41ODVsLTIuMDYtMy40MjdtLTIuNTcyIDUuNTkzbC0uOTM0LTMuNzZNMS44NTYgNmMyLjAzIDIuMzkzIDQuMzc0IDMuNjQ0IDcuMDMgMy43NTRzNS4wOS0xLjE0MiA3LjMxLTMuNzU0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgb3BhY2l0eT0iLjY0MiIvPjwvc3ZnPg==";
    var Password$1 = function(_super) {
      tslib_12.__extends(Password2, _super);
      function Password2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = react_12.default.createRef();
        _this.state = {
          passwordVisible: false
        };
        _this.refDom = function(dom) {
          _this.inputRef.current = dom;
          var propRef = _this.props.inputRef;
          if (!propRef) {
            return;
          }
          if (typeof propRef === "function") {
            propRef(dom);
          } else {
            propRef.current = dom;
          }
        };
        _this.togglePasswordVisibility = function() {
          var dom = _this.inputRef.current;
          var selectionStart = dom.selectionStart, selectionEnd = dom.selectionEnd;
          _this.setState(function(prevState) {
            return { passwordVisible: !prevState.passwordVisible };
          }, function() {
            setTimeout(function() {
              dom.setSelectionRange(selectionStart, selectionEnd);
            }, 0);
          });
        };
        _this.themedRender = function(classNames2) {
          var _a = _this.props, showToggle = _a.showToggle, rest = tslib_12.__rest(_a, ["showToggle"]);
          var passwordVisible = _this.state.passwordVisible;
          var iconUrl = passwordVisible ? openEyeUrl : closedEyeUrl;
          return h(Input_12.default, tslib_12.__assign({ icon: showToggle ? iconUrl : void 0, inputStyle: { letterSpacing: passwordVisible ? "2px" : "4px" }, onClickIcon: _this.togglePasswordVisibility, type: passwordVisible ? "text" : "password", inputRef: _this.refDom }, rest));
        };
        return _this;
      }
      Password2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Password2;
    }(react_12.default.Component);
    Password.default = Password$1;
    Password$1.defaultProps = {
      showToggle: true
    };
    return Password;
  }
  var hasRequiredInput$1;
  function requireInput$1() {
    if (hasRequiredInput$1)
      return Input$1;
    hasRequiredInput$1 = 1;
    Object.defineProperty(Input$1, "__esModule", { value: true });
    Input$1.Input = void 0;
    var tslib_12 = tslib.exports;
    var Input_12 = tslib_12.__importDefault(requireInput$2());
    Input$1.Input = Input_12.default;
    requireStyle().injectStyle("components/Input/style/index.css", `[data-dui-0-122-1~="dui-input"]{-webkit-tap-highlight-color:transparent;position:relative}[data-dui-0-122-1~="dui-input-disabled"]{pointer-events:none}[data-dui-0-122-1~="dui-input-input"]{display:block;outline:none;font-size:14px;height:36px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:7px 11px;border:1px solid var(--border-medium,rgba(0,0,0,.08));border-radius:4px;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;color:var(--text-ultrastrong,rgba(0,0,0,.88));background:transparent}[data-dui-0-122-1~="dui-input-input"]:not([data-dui-0-122-1~="dui-input-input-underline"]):disabled{color:var(--text-weak,rgba(0,0,0,.24));border-color:var(--border-weak,rgba(0,0,0,.04))}[data-dui-0-122-1~="dui-input-input"]::-webkit-input-placeholder{color:var(--text-weak,rgba(0,0,0,.24));letter-spacing:normal}[data-dui-0-122-1~="dui-input-input"]::-moz-placeholder{color:var(--text-weak,rgba(0,0,0,.24));letter-spacing:normal}[data-dui-0-122-1~="dui-input-input"]:-ms-input-placeholder{color:var(--text-weak,rgba(0,0,0,.24));letter-spacing:normal}[data-dui-0-122-1~="dui-input-input"]::-ms-input-placeholder{color:var(--text-weak,rgba(0,0,0,.24));letter-spacing:normal}[data-dui-0-122-1~="dui-input-input"]::placeholder{color:var(--text-weak,rgba(0,0,0,.24));letter-spacing:normal}[data-dui-0-122-1~="dui-input-input"]:hover{border-color:var(--border-strong,rgba(0,0,0,.12))}[data-dui-0-122-1~="dui-input-input"]:focus{border-color:var(--accent-default,#1e6fff)}[data-dui-0-122-1~="dui-input-input-underline"]{padding:6px 0;border-color:transparent;border-bottom-color:var(--border-medium,rgba(0,0,0,.08));border-radius:0}[data-dui-0-122-1~="dui-input-input-underline"]:hover{border-color:transparent;border-bottom-color:var(--border-strong,rgba(0,0,0,.12))}[data-dui-0-122-1~="dui-input-input-underline"]:focus{border-color:transparent;border-bottom-color:var(--accent-default,#1e6fff)}[data-dui-0-122-1~="dui-input-input-underline"]:disabled{color:var(--text-weak,rgba(0,0,0,.24));border-bottom-color:var(--border-weak,rgba(0,0,0,.04))}[data-dui-0-122-1~="dui-input-input-error"],[data-dui-0-122-1~="dui-input-input-error"]:focus,[data-dui-0-122-1~="dui-input-input-error"]:hover{border-color:var(--critical-default,#ff4747)}[data-dui-0-122-1~="dui-input-input-error"][data-dui-0-122-1~="dui-input-input-underline"]{border-color:transparent;border-bottom-color:var(--critical-default,#ff4747)}[data-dui-0-122-1~="dui-input-clear"],[data-dui-0-122-1~="dui-input-icon"]{border:none;margin:0;padding:0;background:transparent;-webkit-tap-highlight-color:transparent}[data-dui-0-122-1~="dui-input-clear"]{display:inline-block;width:16px;height:16px;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'%3E%3Ccircle cx='8' cy='8' r='8' fill='%233d5266' fill-opacity='.16'/%3E%3Cpath fill-rule='evenodd' d='M10.833 10.832a.584.584 0 00.004-.814L8.822 8.002l2.015-2.02a.584.584 0 00-.004-.814.58.58 0 00-.814-.004L7.999 7.18l-2.02-2.02c-.209-.209-.592-.218-.814.004s-.218.605-.004.818l2.02 2.02-2.02 2.02a.59.59 0 00.004.814.593.593 0 00.814.004l2.02-2.02 2.02 2.015a.58.58 0 00.814-.004z' fill='%23fff'/%3E%3C/svg%3E");background-position:50%;background-repeat:no-repeat;visibility:hidden;cursor:pointer}[data-dui-0-122-1~="dui-input-clear-visible"]{visibility:visible}[data-dui-0-122-1~="dui-input-clear"]:hover{opacity:.5}[data-dui-0-122-1~="dui-input-icon-container"],[data-dui-0-122-1~="dui-input-icon-left"]{position:absolute;height:100%;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}[data-dui-0-122-1~="dui-input-icon"],[data-dui-0-122-1~="dui-input-icon-container"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row nowrap;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-input-icon"]{width:39px;height:100%;border-radius:3px}[data-dui-0-122-1~="dui-input-icon-container"]{right:0}[data-dui-0-122-1~="dui-input-icon-container-underline"]>:not(:last-child){margin-right:7px}[data-dui-0-122-1~="dui-input-icon-underline"]{width:auto;height:auto}[data-dui-0-122-1~="dui-input-icon-clickable"]{cursor:pointer}[data-dui-0-122-1~="dui-input-icon-clickable"]:not([data-dui-0-122-1~="dui-input-icon-underline"]):not([data-dui-0-122-1~="dui-input-clear-underline"]):hover{background-color:rgba(0,0,0,.04)}[data-dui-0-122-1~="dui-input-icon-clickable"]:not([data-dui-0-122-1~="dui-input-icon-underline"]):not([data-dui-0-122-1~="dui-input-clear-underline"]):active{background-color:rgba(0,0,0,.08)}[data-dui-0-122-1~="dui-input-icon-img"]{display:inline-block;width:16px;height:16px;background-size:cover;background-position:50%;background-repeat:no-repeat}[data-dui-0-122-1~="dui-input-icon-left"]{left:0}[data-dui-0-122-1~="dui-input-icon-right"]{height:100%;right:0}[data-dui-0-122-1~="dui-input-error-text"]{color:var(--text-error,#eb3639);font-size:12px;line-height:16px;position:absolute;top:100%;left:0;margin-top:4px}`);
    var Password_1 = tslib_12.__importDefault(requirePassword());
    Input_12.default.Password = Password_1.default;
    Input$1.default = Input_12.default;
    return Input$1;
  }
  var hasRequiredInput;
  function requireInput() {
    if (hasRequiredInput)
      return Input$2;
    hasRequiredInput = 1;
    Object.defineProperty(Input$2, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var react_12 = tslib_12.__importDefault(React__default.default);
    var theme_1 = requireTheme();
    var Input_12 = tslib_12.__importDefault(requireInput$1());
    var Keep_12 = tslib_12.__importDefault(requireKeep());
    var MenuInput = function(_super) {
      tslib_12.__extends(MenuInput2, _super);
      function MenuInput2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function(classNames2) {
          var _a = _this.props, className = _a.className, inputClassName = _a.inputClassName, prefixCls = _a.prefixCls, containerClassName = _a.containerClassName, containerStyle = _a.containerStyle, prefix = _a.prefix, postfix = _a.postfix, rest = tslib_12.__rest(_a, ["className", "inputClassName", "prefixCls", "containerClassName", "containerStyle", "prefix", "postfix"]);
          var cls = classNames2(prefixCls, className);
          var inputCls = classNames2(prefixCls + "-input", inputClassName);
          var containerCls = classNames2(prefixCls + "-container", containerClassName);
          var prefixDomCls = classNames2(prefixCls + "-prefix");
          var postfixDomCls = classNames2(prefixCls + "-postfix");
          return h(
            Keep_12.default,
            { className: containerCls, style: containerStyle },
            prefix && h("div", { className: prefixDomCls }, prefix),
            h(Input_12.default, tslib_12.__assign({ className: cls, inputClassName: inputCls }, rest)),
            postfix && h("div", { className: postfixDomCls }, postfix)
          );
        };
        return _this;
      }
      MenuInput2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return MenuInput2;
    }(react_12.default.Component);
    Input$2.default = MenuInput;
    MenuInput.defaultProps = {
      prefixCls: "dui-menu-input"
    };
    return Input$2;
  }
  Object.defineProperty(Menu$1, "__esModule", { value: true });
  var Menu_2 = Menu$1.Menu = void 0;
  var tslib_1$4 = tslib.exports;
  var Menu_1 = tslib_1$4.__importDefault(requireMenu());
  Menu_2 = Menu$1.Menu = Menu_1.default;
  var Item_1 = tslib_1$4.__importDefault(requireItem());
  var SubMenu_1 = tslib_1$4.__importDefault(requireSubMenu());
  var ContextMenu_1 = tslib_1$4.__importDefault(requireContextMenu());
  var Input_1 = tslib_1$4.__importDefault(requireInput());
  requireStyle().injectStyle("components/Menu/style/index.css", `[data-dui-0-122-1~="dui-menu"],[data-dui-0-122-1~="dui-menu-submenu-content"]{-webkit-box-shadow:0 2px 12px 2px rgba(68,73,77,.16);box-shadow:0 2px 12px 2px rgba(68,73,77,.16);list-style:none;padding:8px 0;margin:0;border:1px solid rgba(0,0,0,.12);border-radius:4px;-webkit-tap-highlight-color:transparent;overflow-y:auto;overflow-x:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;height:100%;background-color:#fff}@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))){[data-dui-0-122-1~="dui-menu"],[data-dui-0-122-1~="dui-menu-submenu-content"]{background-color:hsla(0,0%,100%,.92);-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px)}}[data-dui-0-122-1~="dui-menu-hidden"]{visibility:hidden}[data-dui-0-122-1~="dui-menu-item"]{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;white-space:nowrap;-webkit-transition:background-color .1s linear;transition:background-color .1s linear;padding:9px 16px 9px 28px;font-size:12px;height:12px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row nowrap;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;color:var(--text-ultrastrong,rgba(0,0,0,.88));cursor:pointer}[data-dui-0-122-1~="dui-menu-item-disabled"]{opacity:.3;pointer-events:none}[data-dui-0-122-1~="dui-menu-item-icon-container"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[data-dui-0-122-1~="dui-menu-item-with-action-active"] [data-dui-0-122-1~="dui-menu-item-icon-container"],[data-dui-0-122-1~="dui-menu-item-with-action"]:hover [data-dui-0-122-1~="dui-menu-item-icon-container"]{max-width:calc(100% - 24px)}[data-dui-0-122-1~="dui-menu-item-text-container"]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}[data-dui-0-122-1~="dui-menu-item-icon"]{width:20px;height:20px;background-repeat:no-repeat;background-size:contain;background-position:50%;margin-right:8px;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}[data-dui-0-122-1~="dui-menu-item-description"]{font-size:12px;color:var(--text-medium,rgba(0,0,0,.4));margin-left:10px}[data-dui-0-122-1~="dui-menu-item-disabled"] [data-dui-0-122-1~="dui-menu-item-description"]{color:rgba(0,0,0,.8)}[data-dui-0-122-1~="dui-menu-item-selected"]:before{content:"";position:absolute;display:inline-block;width:16px;height:16px;left:8px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-repeat:no-repeat;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cpath d='M12.5 3l1.5.944L5.671 13l-.885-.957L2 9l1.5-1 2.215 2.22z' fill='%231e6fff' fill-rule='evenodd'/%3E%3C/svg%3E");background-size:contain;background-position:50%}:not([data-dui-0-122-1~="dui-menu-item-disabled"])[data-dui-0-122-1~="dui-menu-item"]:focus,:not([data-dui-0-122-1~="dui-menu-item-disabled"])[data-dui-0-122-1~="dui-menu-item"]:hover{background-color:var(--feedback-hover,rgba(51,77,102,.06))}:not([data-dui-0-122-1~="dui-menu-item-disabled"])[data-dui-0-122-1~="dui-menu-item"]:active{background-color:var(--feedback-active,rgba(51,77,102,.08))}[data-dui-0-122-1~="dui-menu-item-action"]{width:24px;height:24px;border-radius:2px;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M7 11v2H5v-2h2zm6 0v2h-2v-2h2zm6 0v2h-2v-2h2z' fill='%23464d5a'/%3E%3C/svg%3E");background-position:50%;background-repeat:no-repeat;background-size:contain}[data-dui-0-122-1~="dui-menu-item-action-active"],[data-dui-0-122-1~="dui-menu-item-action"]:hover{background-color:rgba(0,0,0,.08)}[data-dui-0-122-1~="dui-menu-item-action-content"]{margin-top:-4px;margin-left:10px}[data-dui-0-122-1~="dui-menu-item-action-wrapper"]{height:24px;visibility:hidden}[data-dui-0-122-1~="dui-menu-item-action-wrapper-active"],[data-dui-0-122-1~="dui-menu-item"]:hover [data-dui-0-122-1~="dui-menu-item-action-wrapper"]{visibility:visible}[data-dui-0-122-1~="dui-menu-submenu"]:after{content:"";background:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='6'%3E%3Cpath d='M3.936 3.123L.374 5.95a.261.261 0 01-.31 0A.158.158 0 010 5.826V.174C0 .078.098 0 .22 0a.25.25 0 01.154.05l3.562 2.827a.15.15 0 010 .246z' opacity='.4'/%3E%3C/svg%3E");display:inline-block;width:4px;height:6px;background-position:50%;background-size:cover;margin-left:24px}[data-dui-0-122-1~="dui-menu-submenu-with-desc"]:after{position:absolute;right:16px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);margin-left:0}[data-dui-0-122-1~="dui-menu-submenu-with-desc"] [data-dui-0-122-1~="dui-menu-item-description"]{margin-right:16px}:not([data-dui-0-122-1~="dui-menu-submenu-clickable"])[data-dui-0-122-1~="dui-menu-submenu"]:active{background-color:var(--feedback-hover,rgba(51,77,102,.06))}[data-dui-0-122-1~="dui-menu-submenu-wrapper"]{padding:0;background:transparent;position:absolute;-webkit-transition-property:visibility,opacity,-webkit-transform;transition-property:visibility,opacity,-webkit-transform;transition-property:visibility,opacity,transform;transition-property:visibility,opacity,transform,-webkit-transform;-webkit-transition-timing-function:cubic-bezier(.4,0,.2,1);transition-timing-function:cubic-bezier(.4,0,.2,1)}[data-dui-0-122-1~="dui-menu-submenu-wrapper-visible"]{visibility:visible;-webkit-transition-duration:.16s;transition-duration:.16s;opacity:1;-webkit-transform:scaleX(1) translate(0);transform:scaleX(1) translate(0)}[data-dui-0-122-1~="dui-menu-submenu-wrapper-hidden-bottom"],[data-dui-0-122-1~="dui-menu-submenu-wrapper-hidden-top"]{visibility:hidden;-webkit-transition-duration:.12s;transition-duration:.12s}[data-dui-0-122-1~="dui-menu-submenu-wrapper-hidden-bottom"]{opacity:0;-webkit-transform:scaleX(1) translateY(-5px);transform:scaleX(1) translateY(-5px)}[data-dui-0-122-1~="dui-menu-submenu-wrapper-hidden-top"]{opacity:0;-webkit-transform:scaleX(1) translateY(5px);transform:scaleX(1) translateY(5px)}[data-dui-0-122-1~="dui-menu-contextmenu-popup"]{position:absolute;z-index:9999;overflow-y:auto;overflow-x:hidden;-webkit-box-shadow:0 2px 12px 2px rgba(68,73,77,.16);box-shadow:0 2px 12px 2px rgba(68,73,77,.16)}[data-dui-0-122-1~="dui-menu-contextmenu-popup-hidden"]{visibility:hidden}[data-dui-0-122-1~="dui-menu-contextmenu-popup-left-top"]{-webkit-transform:translate(-100%,-100%);transform:translate(-100%,-100%)}[data-dui-0-122-1~="dui-menu-contextmenu-popup-left-bottom"]{-webkit-transform:translateX(-100%);transform:translateX(-100%)}[data-dui-0-122-1~="dui-menu-contextmenu-popup-right-top"]{-webkit-transform:translateY(-100%);transform:translateY(-100%)}[data-dui-0-122-1~="dui-menu-input-container"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;color:var(--text-ultrastrong,rgba(0,0,0,.88))}[data-dui-0-122-1~="dui-menu-input-postfix"]{margin-left:4px}[data-dui-0-122-1~="dui-menu-input-prefix"]{margin-right:4px}[data-dui-0-122-1~="dui-menu-input-input"]{width:32px;height:20px;font-size:12px;padding:2px;text-align:center;border-radius:2px;border-color:var(--border-medium,rgba(0,0,0,.08))}[data-dui-0-122-1~="dui-menu-compact"],[data-dui-0-122-1~="dui-menu-submenu-content-compact"]{padding:6px 0;border:1px solid rgba(0,0,0,.12);-webkit-box-shadow:0 2px 12px 2px rgba(68,73,77,.16);box-shadow:0 2px 12px 2px rgba(68,73,77,.16)}[data-dui-0-122-1~="dui-menu-compact"] [data-dui-0-122-1~="dui-menu-item"],[data-dui-0-122-1~="dui-menu-submenu-content-compact"] [data-dui-0-122-1~="dui-menu-item"]{font-size:12px;height:12px;padding:8px 12px 8px 28px}[data-dui-0-122-1~="dui-menu-non-selectable"] [data-dui-0-122-1~="dui-menu-item"],[data-dui-0-122-1~="dui-menu-submenu-content-non-selectable"] [data-dui-0-122-1~="dui-menu-item"]{padding-left:16px}[data-dui-0-122-1~="dui-menu-non-selectable"] [data-dui-0-122-1~="dui-menu-item-selected"]:before,[data-dui-0-122-1~="dui-menu-submenu-content-non-selectable"] [data-dui-0-122-1~="dui-menu-item-selected"]:before{display:none}[data-dui-0-122-1~="dui-menu-submenu-content-with-icon"] [data-dui-0-122-1~="dui-menu-item"],[data-dui-0-122-1~="dui-menu-with-icon"] [data-dui-0-122-1~="dui-menu-item"]{height:12px}[data-dui-0-122-1~="dui-menu"]>[data-dui-0-122-1~="dui-tooltip-wrapper"]{display:block}`);
  Menu_1.default.Item = Item_1.default;
  Menu_1.default.SubMenu = SubMenu_1.default;
  Menu_1.default.ContextMenu = ContextMenu_1.default;
  Menu_1.default.Input = Input_1.default;
  Menu$1.default = Menu_1.default;
  var baseGetTag$3 = _baseGetTag, isObject$2 = requireIsObject();
  var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
  function isFunction$2(value) {
    if (!isObject$2(value)) {
      return false;
    }
    var tag = baseGetTag$3(value);
    return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  var isFunction_1 = isFunction$2;
  var root$6 = require_root();
  var coreJsData$1 = root$6["__core-js_shared__"];
  var _coreJsData = coreJsData$1;
  var coreJsData = _coreJsData;
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked$1(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  var _isMasked = isMasked$1;
  var funcProto$1 = Function.prototype;
  var funcToString$1 = funcProto$1.toString;
  function toSource$2(func) {
    if (func != null) {
      try {
        return funcToString$1.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  var _toSource = toSource$2;
  var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$1 = requireIsObject(), toSource$1 = _toSource;
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto = Function.prototype, objectProto$a = Object.prototype;
  var funcToString = funcProto.toString;
  var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative$1(value) {
    if (!isObject$1(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource$1(value));
  }
  var _baseIsNative = baseIsNative$1;
  function getValue$1(object, key) {
    return object == null ? void 0 : object[key];
  }
  var _getValue = getValue$1;
  var baseIsNative = _baseIsNative, getValue = _getValue;
  function getNative$7(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  var _getNative = getNative$7;
  var getNative$6 = _getNative;
  var defineProperty$1 = function() {
    try {
      var func = getNative$6(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var _defineProperty = defineProperty$1;
  var defineProperty = _defineProperty;
  function baseAssignValue$1(object, key, value) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var _baseAssignValue = baseAssignValue$1;
  function arrayAggregator$1(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }
  var _arrayAggregator = arrayAggregator$1;
  function createBaseFor$1(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  var _createBaseFor = createBaseFor$1;
  var createBaseFor = _createBaseFor;
  var baseFor$1 = createBaseFor();
  var _baseFor = baseFor$1;
  function baseTimes$1(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  var _baseTimes = baseTimes$1;
  var baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
  var argsTag$2 = "[object Arguments]";
  function baseIsArguments$1(value) {
    return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
  }
  var _baseIsArguments = baseIsArguments$1;
  var baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1;
  var objectProto$9 = Object.prototype;
  var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
  var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
  var isArguments$2 = baseIsArguments(function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike$2(value) && hasOwnProperty$7.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
  };
  var isArguments_1 = isArguments$2;
  var isArray$9 = Array.isArray;
  var isArray_1 = isArray$9;
  var isBuffer$2 = { exports: {} };
  function stubFalse() {
    return false;
  }
  var stubFalse_1 = stubFalse;
  (function(module2, exports2) {
    var root2 = require_root(), stubFalse2 = stubFalse_1;
    var freeExports = exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root2.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer2 = nativeIsBuffer || stubFalse2;
    module2.exports = isBuffer2;
  })(isBuffer$2, isBuffer$2.exports);
  var MAX_SAFE_INTEGER$1 = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex$2(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  var _isIndex = isIndex$2;
  var MAX_SAFE_INTEGER = 9007199254740991;
  function isLength$3(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  var isLength_1 = isLength$3;
  var baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$1 = isObjectLike_1;
  var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
  var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
  function baseIsTypedArray$1(value) {
    return isObjectLike$1(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
  }
  var _baseIsTypedArray = baseIsTypedArray$1;
  function baseUnary$1(func) {
    return function(value) {
      return func(value);
    };
  }
  var _baseUnary = baseUnary$1;
  var _nodeUtil = { exports: {} };
  (function(module2, exports2) {
    var freeGlobal = require_freeGlobal();
    var freeExports = exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil2 = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module2.exports = nodeUtil2;
  })(_nodeUtil, _nodeUtil.exports);
  var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtil.exports;
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  var isTypedArray_1 = isTypedArray$2;
  var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$8 = isArray_1, isBuffer$1 = isBuffer$2.exports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1;
  var objectProto$8 = Object.prototype;
  var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
  function arrayLikeKeys$1(value, inherited) {
    var isArr = isArray$8(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex$1(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  var _arrayLikeKeys = arrayLikeKeys$1;
  var objectProto$7 = Object.prototype;
  function isPrototype$1(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$7;
    return value === proto;
  }
  var _isPrototype = isPrototype$1;
  function overArg$1(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var _overArg = overArg$1;
  var overArg = _overArg;
  var nativeKeys$1 = overArg(Object.keys, Object);
  var _nativeKeys = nativeKeys$1;
  var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
  var objectProto$6 = Object.prototype;
  var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
  function baseKeys$1(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty$5.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  var _baseKeys = baseKeys$1;
  var isFunction = isFunction_1, isLength$1 = isLength_1;
  function isArrayLike$2(value) {
    return value != null && isLength$1(value.length) && !isFunction(value);
  }
  var isArrayLike_1 = isArrayLike$2;
  var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$1 = isArrayLike_1;
  function keys$3(object) {
    return isArrayLike$1(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  var keys_1 = keys$3;
  var baseFor = _baseFor, keys$2 = keys_1;
  function baseForOwn$1(object, iteratee) {
    return object && baseFor(object, iteratee, keys$2);
  }
  var _baseForOwn = baseForOwn$1;
  var isArrayLike = isArrayLike_1;
  function createBaseEach$1(eachFunc, fromRight) {
    return function(collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  var _createBaseEach = createBaseEach$1;
  var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
  var baseEach$1 = createBaseEach(baseForOwn);
  var _baseEach = baseEach$1;
  var baseEach = _baseEach;
  function baseAggregator$1(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection2) {
      setter(accumulator, value, iteratee(value), collection2);
    });
    return accumulator;
  }
  var _baseAggregator = baseAggregator$1;
  function listCacheClear$1() {
    this.__data__ = [];
    this.size = 0;
  }
  var _listCacheClear = listCacheClear$1;
  function eq$2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var eq_1 = eq$2;
  var eq$1 = eq_1;
  function assocIndexOf$4(array, key) {
    var length = array.length;
    while (length--) {
      if (eq$1(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var _assocIndexOf = assocIndexOf$4;
  var assocIndexOf$3 = _assocIndexOf;
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete$1(key) {
    var data = this.__data__, index = assocIndexOf$3(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  var _listCacheDelete = listCacheDelete$1;
  var assocIndexOf$2 = _assocIndexOf;
  function listCacheGet$1(key) {
    var data = this.__data__, index = assocIndexOf$2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  var _listCacheGet = listCacheGet$1;
  var assocIndexOf$1 = _assocIndexOf;
  function listCacheHas$1(key) {
    return assocIndexOf$1(this.__data__, key) > -1;
  }
  var _listCacheHas = listCacheHas$1;
  var assocIndexOf = _assocIndexOf;
  function listCacheSet$1(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  var _listCacheSet = listCacheSet$1;
  var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
  function ListCache$4(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache$4.prototype.clear = listCacheClear;
  ListCache$4.prototype["delete"] = listCacheDelete;
  ListCache$4.prototype.get = listCacheGet;
  ListCache$4.prototype.has = listCacheHas;
  ListCache$4.prototype.set = listCacheSet;
  var _ListCache = ListCache$4;
  var ListCache$3 = _ListCache;
  function stackClear$1() {
    this.__data__ = new ListCache$3();
    this.size = 0;
  }
  var _stackClear = stackClear$1;
  function stackDelete$1(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  var _stackDelete = stackDelete$1;
  function stackGet$1(key) {
    return this.__data__.get(key);
  }
  var _stackGet = stackGet$1;
  function stackHas$1(key) {
    return this.__data__.has(key);
  }
  var _stackHas = stackHas$1;
  var getNative$5 = _getNative, root$5 = require_root();
  var Map$3 = getNative$5(root$5, "Map");
  var _Map = Map$3;
  var getNative$4 = _getNative;
  var nativeCreate$4 = getNative$4(Object, "create");
  var _nativeCreate = nativeCreate$4;
  var nativeCreate$3 = _nativeCreate;
  function hashClear$1() {
    this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
    this.size = 0;
  }
  var _hashClear = hashClear$1;
  function hashDelete$1(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  var _hashDelete = hashDelete$1;
  var nativeCreate$2 = _nativeCreate;
  var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
  var objectProto$5 = Object.prototype;
  var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
  function hashGet$1(key) {
    var data = this.__data__;
    if (nativeCreate$2) {
      var result = data[key];
      return result === HASH_UNDEFINED$2 ? void 0 : result;
    }
    return hasOwnProperty$4.call(data, key) ? data[key] : void 0;
  }
  var _hashGet = hashGet$1;
  var nativeCreate$1 = _nativeCreate;
  var objectProto$4 = Object.prototype;
  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
  function hashHas$1(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$3.call(data, key);
  }
  var _hashHas = hashHas$1;
  var nativeCreate = _nativeCreate;
  var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
  function hashSet$1(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
    return this;
  }
  var _hashSet = hashSet$1;
  var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
  function Hash$1(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  Hash$1.prototype.clear = hashClear;
  Hash$1.prototype["delete"] = hashDelete;
  Hash$1.prototype.get = hashGet;
  Hash$1.prototype.has = hashHas;
  Hash$1.prototype.set = hashSet;
  var _Hash = Hash$1;
  var Hash = _Hash, ListCache$2 = _ListCache, Map$2 = _Map;
  function mapCacheClear$1() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map$2 || ListCache$2)(),
      "string": new Hash()
    };
  }
  var _mapCacheClear = mapCacheClear$1;
  function isKeyable$1(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  var _isKeyable = isKeyable$1;
  var isKeyable = _isKeyable;
  function getMapData$4(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  var _getMapData = getMapData$4;
  var getMapData$3 = _getMapData;
  function mapCacheDelete$1(key) {
    var result = getMapData$3(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  var _mapCacheDelete = mapCacheDelete$1;
  var getMapData$2 = _getMapData;
  function mapCacheGet$1(key) {
    return getMapData$2(this, key).get(key);
  }
  var _mapCacheGet = mapCacheGet$1;
  var getMapData$1 = _getMapData;
  function mapCacheHas$1(key) {
    return getMapData$1(this, key).has(key);
  }
  var _mapCacheHas = mapCacheHas$1;
  var getMapData = _getMapData;
  function mapCacheSet$1(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  var _mapCacheSet = mapCacheSet$1;
  var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
  function MapCache$3(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache$3.prototype.clear = mapCacheClear;
  MapCache$3.prototype["delete"] = mapCacheDelete;
  MapCache$3.prototype.get = mapCacheGet;
  MapCache$3.prototype.has = mapCacheHas;
  MapCache$3.prototype.set = mapCacheSet;
  var _MapCache = MapCache$3;
  var ListCache$1 = _ListCache, Map$1 = _Map, MapCache$2 = _MapCache;
  var LARGE_ARRAY_SIZE = 200;
  function stackSet$1(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache$1) {
      var pairs = data.__data__;
      if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache$2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  var _stackSet = stackSet$1;
  var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
  function Stack$2(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  Stack$2.prototype.clear = stackClear;
  Stack$2.prototype["delete"] = stackDelete;
  Stack$2.prototype.get = stackGet;
  Stack$2.prototype.has = stackHas;
  Stack$2.prototype.set = stackSet;
  var _Stack = Stack$2;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  function setCacheAdd$1(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  var _setCacheAdd = setCacheAdd$1;
  function setCacheHas$1(value) {
    return this.__data__.has(value);
  }
  var _setCacheHas = setCacheHas$1;
  var MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
  function SetCache$1(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache$1();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
  SetCache$1.prototype.has = setCacheHas;
  var _SetCache = SetCache$1;
  function arraySome$1(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  var _arraySome = arraySome$1;
  function cacheHas$1(cache, key) {
    return cache.has(key);
  }
  var _cacheHas = cacheHas$1;
  var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
  var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
  function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  var _equalArrays = equalArrays$2;
  var root$4 = require_root();
  var Uint8Array$1 = root$4.Uint8Array;
  var _Uint8Array = Uint8Array$1;
  function mapToArray$1(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  var _mapToArray = mapToArray$1;
  function setToArray$1(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var _setToArray = setToArray$1;
  var Symbol$2 = _Symbol, Uint8Array2 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
  var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
  var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]";
  var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
  function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag$1:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag$1:
        var convert = mapToArray;
      case setTag$1:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG$2;
        stack.set(object, other);
        var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  var _equalByTag = equalByTag$1;
  function arrayPush$1(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  var _arrayPush = arrayPush$1;
  var arrayPush = _arrayPush, isArray$7 = isArray_1;
  function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$7(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  var _baseGetAllKeys = baseGetAllKeys$1;
  function arrayFilter$1(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  var _arrayFilter = arrayFilter$1;
  function stubArray$1() {
    return [];
  }
  var stubArray_1 = stubArray$1;
  var arrayFilter = _arrayFilter, stubArray = stubArray_1;
  var objectProto$3 = Object.prototype;
  var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  var _getSymbols = getSymbols$1;
  var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
  function getAllKeys$1(object) {
    return baseGetAllKeys(object, keys$1, getSymbols);
  }
  var _getAllKeys = getAllKeys$1;
  var getAllKeys = _getAllKeys;
  var COMPARE_PARTIAL_FLAG$3 = 1;
  var objectProto$2 = Object.prototype;
  var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
  function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  var _equalObjects = equalObjects$1;
  var getNative$3 = _getNative, root$3 = require_root();
  var DataView$1 = getNative$3(root$3, "DataView");
  var _DataView = DataView$1;
  var getNative$2 = _getNative, root$2 = require_root();
  var Promise$2 = getNative$2(root$2, "Promise");
  var _Promise = Promise$2;
  var getNative$1 = _getNative, root$1 = require_root();
  var Set$2 = getNative$1(root$1, "Set");
  var _Set = Set$2;
  var getNative = _getNative, root = require_root();
  var WeakMap$1 = getNative(root, "WeakMap");
  var _WeakMap = WeakMap$1;
  var DataView = _DataView, Map = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
  var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
  var dataViewTag = "[object DataView]";
  var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
  var getTag$1 = baseGetTag;
  if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag$1(new Map()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap && getTag$1(new WeakMap()) != weakMapTag) {
    getTag$1 = function(value) {
      var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  var _getTag = getTag$1;
  var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$6 = isArray_1, isBuffer = isBuffer$2.exports, isTypedArray = isTypedArray_1;
  var COMPARE_PARTIAL_FLAG$2 = 1;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
  var objectProto$1 = Object.prototype;
  var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
  function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$6(object), othIsArr = isArray$6(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack$1());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
      var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$1.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack$1());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack$1());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  var _baseIsEqualDeep = baseIsEqualDeep$1;
  var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
  function baseIsEqual$2(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
  }
  var _baseIsEqual = baseIsEqual$2;
  var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
  var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
  function baseIsMatch$1(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  var _baseIsMatch = baseIsMatch$1;
  var isObject = requireIsObject();
  function isStrictComparable$2(value) {
    return value === value && !isObject(value);
  }
  var _isStrictComparable = isStrictComparable$2;
  var isStrictComparable$1 = _isStrictComparable, keys = keys_1;
  function getMatchData$1(object) {
    var result = keys(object), length = result.length;
    while (length--) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable$1(value)];
    }
    return result;
  }
  var _getMatchData = getMatchData$1;
  function matchesStrictComparable$2(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var _matchesStrictComparable = matchesStrictComparable$2;
  var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
  function baseMatches$1(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  var _baseMatches = baseMatches$1;
  var isArray$5 = isArray_1, isSymbol$2 = isSymbol_1;
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
  function isKey$3(value, object) {
    if (isArray$5(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$2(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  var _isKey = isKey$3;
  var MapCache = _MapCache;
  var FUNC_ERROR_TEXT = "Expected a function";
  function memoize$1(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize$1.Cache || MapCache)();
    return memoized;
  }
  memoize$1.Cache = MapCache;
  var memoize_1 = memoize$1;
  var memoize = memoize_1;
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped$1(func) {
    var result = memoize(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }
  var _memoizeCapped = memoizeCapped$1;
  var memoizeCapped = _memoizeCapped;
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath$1 = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46) {
      result.push("");
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
  });
  var _stringToPath = stringToPath$1;
  function arrayMap$1(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  var _arrayMap = arrayMap$1;
  var Symbol$1 = _Symbol, arrayMap = _arrayMap, isArray$4 = isArray_1, isSymbol$1 = isSymbol_1;
  var INFINITY$1 = 1 / 0;
  var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString$1(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray$4(value)) {
      return arrayMap(value, baseToString$1) + "";
    }
    if (isSymbol$1(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
  }
  var _baseToString = baseToString$1;
  var baseToString = _baseToString;
  function toString$1(value) {
    return value == null ? "" : baseToString(value);
  }
  var toString_1 = toString$1;
  var isArray$3 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
  function castPath$2(value, object) {
    if (isArray$3(value)) {
      return value;
    }
    return isKey$2(value, object) ? [value] : stringToPath(toString(value));
  }
  var _castPath = castPath$2;
  var isSymbol = isSymbol_1;
  var INFINITY = 1 / 0;
  function toKey$4(value) {
    if (typeof value == "string" || isSymbol(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
  }
  var _toKey = toKey$4;
  var castPath$1 = _castPath, toKey$3 = _toKey;
  function baseGet$2(object, path) {
    path = castPath$1(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey$3(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  var _baseGet = baseGet$2;
  var baseGet$1 = _baseGet;
  function get$1(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet$1(object, path);
    return result === void 0 ? defaultValue : result;
  }
  var get_1 = get$1;
  function baseHasIn$1(object, key) {
    return object != null && key in Object(object);
  }
  var _baseHasIn = baseHasIn$1;
  var castPath = _castPath, isArguments = isArguments_1, isArray$2 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
  function hasPath$1(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while (++index < length) {
      var key = toKey$2(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray$2(object) || isArguments(object));
  }
  var _hasPath = hasPath$1;
  var baseHasIn = _baseHasIn, hasPath = _hasPath;
  function hasIn$1(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  var hasIn_1 = hasIn$1;
  var baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  function baseMatchesProperty$1(path, srcValue) {
    if (isKey$1(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey$1(path), srcValue);
    }
    return function(object) {
      var objValue = get(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  var _baseMatchesProperty = baseMatchesProperty$1;
  function identity$1(value) {
    return value;
  }
  var identity_1 = identity$1;
  function baseProperty$1(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  var _baseProperty = baseProperty$1;
  var baseGet = _baseGet;
  function basePropertyDeep$1(path) {
    return function(object) {
      return baseGet(object, path);
    };
  }
  var _basePropertyDeep = basePropertyDeep$1;
  var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
  function property$1(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  var property_1 = property$1;
  var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray$1 = isArray_1, property = property_1;
  function baseIteratee$1(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == "object") {
      return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  var _baseIteratee = baseIteratee$1;
  var arrayAggregator = _arrayAggregator, baseAggregator = _baseAggregator, baseIteratee = _baseIteratee, isArray = isArray_1;
  function createAggregator$1(setter, initializer) {
    return function(collection, iteratee) {
      var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee(iteratee), accumulator);
    };
  }
  var _createAggregator = createAggregator$1;
  var baseAssignValue = _baseAssignValue, createAggregator = _createAggregator;
  var objectProto = Object.prototype;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) {
      result[key].push(value);
    } else {
      baseAssignValue(result, key, [value]);
    }
  });
  var groupBy_1 = groupBy;
  const PlacementContext = React.createContext(void 0);
  const toolbarWrapper = "_toolbarWrapper_kgaa3_1";
  const presentController = "_presentController_kgaa3_8";
  const autoTranslucent = "_autoTranslucent_kgaa3_36";
  const pageInfo = "_pageInfo_kgaa3_43";
  const group = "_group_kgaa3_49";
  const menu = "_menu_kgaa3_60";
  const btnWrap = "_btnWrap_kgaa3_85";
  const actived = "_actived_kgaa3_72";
  const disabled = "_disabled_kgaa3_134";
  const styles$2 = {
    toolbarWrapper,
    presentController,
    autoTranslucent,
    pageInfo,
    group,
    menu,
    btnWrap,
    actived,
    disabled
  };
  const SvgArrowLeftLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.38398 12.0715L14.306 6.14951L13.4221 5.26562L6.61621 12.0715L13.4221 18.8774L14.306 17.9935L8.38398 12.0715Z", fill: "currentColor" }));
  const SvgArrowRightLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4415 5.26562L17.2474 12.0715L10.4415 18.8774L9.55762 17.9935L15.4796 12.0715L9.55762 6.14951L10.4415 5.26562Z", fill: "currentColor" }));
  const SvgBottombarFill = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("title", null, "bottombar_fill"), /* @__PURE__ */ React__namespace.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React__namespace.createElement("g", { id: "bottombar_fill", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__namespace.createElement("g", null, /* @__PURE__ */ React__namespace.createElement("rect", { id: "\\u77E9\\u5F62", x: 0, y: 0, width: 24, height: 24 }), /* @__PURE__ */ React__namespace.createElement("path", { d: "M9.809,13.309 L10.692,14.192 L7.134,17.752 L9.99162909,17.7512208 L9.99162909,19 L5,19 L5,14.0048834 L6.24790727,14.0048834 L6.247,16.873 L9.809,13.309 Z M14.191,13.309 L17.753,16.873 L17.7520927,14.0048834 L19,14.0048834 L19,19 L14.0083709,19 L14.0083709,17.7512208 L16.866,17.752 L13.308,14.192 L14.191,13.309 Z M9.99162909,5 L9.99162909,6.24877916 L7.133,6.248 L10.692,9.808 L9.809,10.691 L6.247,7.127 L6.24790727,9.99511664 L5,9.99511664 L5,5 L9.99162909,5 Z M19,5 L19,9.99511664 L17.7520927,9.99511664 L17.753,7.127 L14.191,10.691 L13.308,9.808 L16.867,6.248 L14.0083709,6.24877916 L14.0083709,5 L19,5 Z", id: "\\u5F62\\u72B6\\u7ED3\\u5408", fill: "currentColor" }))));
  const SvgBottombarOutFill = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("title", null, "bottombar_out_fill"), /* @__PURE__ */ React__namespace.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React__namespace.createElement("g", { id: "bottombar_out_fill", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React__namespace.createElement("rect", { id: "\\u77E9\\u5F62", x: 0, y: 0, width: 24, height: 24 }), /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.8824037,19 L5,18.1169798 L8.866,14.248 L6.00837091,14.2487792 L6.00837091,13 L11,13 L11,17.9951166 L9.75209273,17.9951166 L9.753,15.127 L5.8824037,19 Z M18.1175963,19 L14.247,15.127 L14.2479073,17.9951166 L13,17.9951166 L13,13 L17.9916291,13 L17.9916291,14.2487792 L15.134,14.248 L19,18.1169798 L18.1175963,19 Z M6.00837091,11 L6.00837091,9.75122084 L8.867,9.752 L5,5.88302021 L5.8824037,5 L9.753,8.873 L9.75209273,6.00488336 L11,6.00488336 L11,11 L6.00837091,11 Z M13,11 L13,6.00488336 L14.2479073,6.00488336 L14.247,8.873 L18.1175963,5 L19,5.88302021 L15.133,9.752 L17.9916291,9.75122084 L17.9916291,11 L13,11 Z", id: "\\u5F62\\u72B6\\u7ED3\\u5408", fill: "currentColor" })));
  const SvgZoominLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.75 11C16.75 14.1756 14.1756 16.75 11 16.75C7.82436 16.75 5.25 14.1756 5.25 11C5.25 7.82436 7.82436 5.25 11 5.25C14.1756 5.25 16.75 7.82436 16.75 11ZM15.4881 16.3721C14.273 17.3883 12.7079 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.708 17.3883 14.2731 16.372 15.4882L19.0658 18.182L18.1819 19.0659L15.4881 16.3721ZM14 10.3501V11.6001H11.5996V14H10.3496V11.6001H8V10.3501H10.3496V8H11.5996V10.3501H14Z", fill: "currentColor" }));
  const SvgZoomoutLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 16.75C14.1756 16.75 16.75 14.1756 16.75 11C16.75 7.82436 14.1756 5.25 11 5.25C7.82436 5.25 5.25 7.82436 5.25 11C5.25 14.1756 7.82436 16.75 11 16.75ZM11 18C12.7079 18 14.273 17.3883 15.4881 16.3721L18.1819 19.0659L19.0658 18.182L16.372 15.4882C17.3883 14.2731 18 12.708 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18ZM14 11.6001V10.3501H8V11.6001H14Z", fill: "currentColor" }));
  const SvgNotesviewLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 5C19.7761 5 20 5.22386 20 5.5V18.5C20 18.7761 19.7761 19 19.5 19H4.5C4.22386 19 4 18.7761 4 18.5V5.5C4 5.22386 4.22386 5 4.5 5H19.5ZM18.75 6.25H5.25V17.75H18.75V6.25ZM14 12.625V11.375H7V12.625H14ZM11 14.375V15.625H7V14.375H11ZM17 9.625V8.375H7V9.625H17Z", fill: "currentColor" }));
  const SvgTurnoffLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5996 2.99976H11.3496V11.9998H12.5996V2.99976ZM4 11.9999C4 9.03904 5.60845 6.4539 7.99923 5.07056L8.62433 6.15327C6.60712 7.32047 5.25 9.50168 5.25 11.9999C5.25 15.7278 8.27208 18.7499 12 18.7499C15.7279 18.7499 18.75 15.7278 18.75 11.9999C18.75 9.50588 17.3974 7.32781 15.3858 6.15917L16.0129 5.07756C18.397 6.46262 20 9.04403 20 11.9999C20 16.4181 16.4183 19.9999 12 19.9999C7.58172 19.9999 4 16.4181 4 11.9999Z", fill: "currentColor" }));
  const SvgRemotepresentationLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 25, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 6.25V16.75H8.31245L7.13597 18H4.5C3.94772 18 3.5 17.5523 3.5 17V6C3.5 5.44772 3.94772 5 4.5 5H19.5C20.0523 5 20.5 5.44772 20.5 6V17C20.5 17.5523 20.0523 18 19.5 18H16.8639L15.6874 16.75H19.25V6.25H4.75ZM16 20L12 15.75L8 20H16Z", fill: "currentColor" }));
  const SvgMarkSwitchLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.1923 17.2907C17.7506 16.0542 18.75 14.1438 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 14.1441 6.2497 16.0548 7.80842 17.2912L9.00042 13H9.60019L11.536 8.1605C11.7036 7.74142 12.2968 7.74142 12.4645 8.1605L14.4003 13H15.0004L16.1923 17.2907ZM16.5506 18.5806C18.6349 17.1365 20 14.7277 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.2287 20 14.3928 19.723 15.4331 19.228L15.4331 19.2282C15.8242 19.0421 16.1977 18.8253 16.5506 18.5808L16.5506 18.5806ZM15.0924 18.0015L14.0503 14.25H9.95053L8.90833 18.0019C9.8346 18.48 10.8858 18.75 12 18.75C13.1145 18.75 14.166 18.4799 15.0924 18.0015Z", fill: "currentColor" }));
  const SvgViewswitchLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { d: "M8.25 8V6.25H19.75V15H20C20.5523 15 21 14.5523 21 14V6C21 5.44772 20.5523 5 20 5H8C7.44772 5 7 5.44772 7 6V8H5C4.44772 8 4 8.44772 4 9V18C4 18.5523 4.44772 19 5 19H17V20.5L20 18.5L17 16.5V17.75H5.25V9.25H16.75V12H18V9C18 8.44772 17.5523 8 17 8H8.25Z", fill: "currentColor" }), /* @__PURE__ */ React__namespace.createElement("path", { d: "M15 16.25L12 14.25L15 12.25V13.75H18V15H15V16.25Z", fill: "currentColor" }));
  const SvgToolbarEllipse = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#454D5A" }, props), /* @__PURE__ */ React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10.75H6.5V13.25H4V10.75ZM10.75 10.75H13.25V13.25H10.75V10.75ZM20 10.75H17.5V13.25H20V10.75Z", fill: "currentColor" }));
  const SvgLaserpointerOnLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React__namespace.createElement("path", { opacity: 0.7, d: "M7.41394 11.8848C6.15677 11.8848 5.52718 10.4364 6.41613 9.58937L13.0584 4.26534C13.6095 3.74024 13.9991 4.15659 13.9991 4.15659C13.9991 4.15659 14.5502 4.63664 13.9991 5.16174L10.8207 9.19555H17.5861C18.8432 9.19555 19.4728 10.6439 18.5839 11.4909L12.1747 17.6062C11.6236 18.1313 10.7302 18.1313 10.1791 17.6062C9.62803 17.0811 9.62803 16.2297 10.1791 15.7046L14.1793 11.8848H7.41394Z", fill: "#DBDDE1" }), /* @__PURE__ */ React__namespace.createElement("circle", { cx: 11.5, cy: 16.5, r: 2.5, fill: "#E9EBED" }));
  const SvgLaserpointerOffLight24 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", __spreadValues({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React__namespace.createElement("path", { opacity: 0.698219, d: "M7.41394 11.8848C6.15677 11.8848 5.52718 10.4364 6.41613 9.58937L13.0584 4.26534C13.6095 3.74024 13.9991 4.15659 13.9991 4.15659C13.9991 4.15659 14.5502 4.63664 13.9991 5.16174L10.8207 9.19555H17.5861C18.8432 9.19555 19.4728 10.6439 18.5839 11.4909L12.1747 17.6062C11.6236 18.1313 10.7302 18.1313 10.1791 17.6062C9.62803 17.0811 9.62803 16.2297 10.1791 15.7046L14.1793 11.8848H7.41394Z", fill: "#EB3639" }), /* @__PURE__ */ React__namespace.createElement("circle", { cx: 11.5, cy: 16.5, r: 2.5, fill: "#EB3639" }));
  var Tooltip$1 = {};
  var Tooltip = {};
  var hasRequiredTooltip;
  function requireTooltip() {
    if (hasRequiredTooltip)
      return Tooltip;
    hasRequiredTooltip = 1;
    Object.defineProperty(Tooltip, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
    var helper_1 = requireHelper();
    var Trigger_1 = tslib_12.__importDefault(requireTrigger());
    var theme_1 = requireTheme();
    var keepDom_1 = requireKeepDom();
    var checkPositionChange_1 = requireCheckPositionChange();
    var TOOLTIP_VERTICAL_GAP = 8;
    var TOOLTIP_HORIZONTAL_GAP = 4;
    var VIEWPORT_MARGIN = 2;
    var TOOLTIP_TRANSITION_DURATION = 200;
    var defaultPosition = {
      left: "0px",
      top: "0px"
    };
    var Tooltip$12 = function(_super) {
      tslib_12.__extends(Tooltip2, _super);
      function Tooltip2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootRef = React2.createRef();
        _this.overlayContainerRef = React2.createRef();
        _this.forceRenderDom = false;
        _this.cancelPositionChangeChecker = null;
        _this.state = {
          currentVisible: !!_this.props.defaultVisible,
          position: defaultPosition
        };
        _this.show = function() {
          if (_this.props.disabled) {
            return;
          }
          _this.forceRenderDom = true;
          _this.setState({ position: defaultPosition }, function() {
            _this.runVisibleEffects();
            _this.setStateVisible(true);
            _this.forceRenderDom = false;
          });
        };
        _this.hide = function() {
          clearTimeout(_this.showTimeout);
          if (!_this.isVisible()) {
            return;
          }
          _this.setStateVisible(false);
        };
        _this.toggle = function() {
          if (_this.props.disabled) {
            return;
          }
          if (_this.isVisible()) {
            _this.hide();
          } else {
            _this.show();
          }
        };
        _this.handleClickAnchor = function() {
          var _a = _this.props, trigger = _a.trigger, hideOnClick = _a.hideOnClick;
          if (trigger === "click") {
            _this.toggle();
          } else if (trigger === "hover" && hideOnClick) {
            _this.hide();
          }
        };
        _this.handleMouseDownAnchor = function() {
          var _a = _this.props, trigger = _a.trigger, hideOnMouseDown = _a.hideOnMouseDown;
          if (hideOnMouseDown && trigger === "hover") {
            _this.hide();
          }
        };
        _this.handleMouseEnter = function() {
          clearTimeout(_this.hideTimeout);
          clearTimeout(_this.showTimeout);
          _this.showTimeout = setTimeout(_this.show, _this.props.hoverDelay);
        };
        _this.handleMouseLeave = function() {
          clearTimeout(_this.showTimeout);
          _this.hideTimeout = setTimeout(_this.hide, _this.props.hoverDelay);
        };
        _this.themedRender = function(classNames2) {
          var _a;
          var _b = _this.props, className = _b.className, style2 = _b.style, prefixCls = _b.prefixCls, placement = _b.placement, children = _b.children, overlayClassName = _b.overlayClassName, overlayStyle = _b.overlayStyle, trigger = _b.trigger, offset = _b.offset, zIndex = _b.zIndex, containerClassName = _b.containerClassName, containerStyle = _b.containerStyle, destroyOnClose = _b.destroyOnClose, overlayHoverable = _b.overlayHoverable, containerDom = _b.containerDom;
          var wrapperCls = classNames2(prefixCls, className, prefixCls + "-wrapper");
          var overlayCls = classNames2(prefixCls + "-content", overlayClassName);
          var overlayStyleWithOffset = tslib_12.__assign(tslib_12.__assign({}, overlayStyle), { transform: "translate" + (placement === "top" || placement === "bottom" ? "X" : "Y") + "(" + offset + "px)" });
          var visible = _this.isVisible();
          var overlayContainerCls = classNames2(prefixCls + "-container", containerClassName, (_a = {}, _a[prefixCls + "-container-visible"] = visible, _a));
          var shouldDestroyDom = !_this.forceRenderDom && destroyOnClose && !keepDom_1.decideKeepDom.call(_this, TOOLTIP_TRANSITION_DURATION, visible);
          var hoverTarget = "";
          if (trigger === "hover") {
            hoverTarget = overlayHoverable ? "outer" : "inner";
          }
          return h(
            Trigger_1.default,
            { className: wrapperCls, style: style2, action: _this.hide, disabled: trigger !== "click" },
            h(
              "div",
              { onMouseEnter: hoverTarget === "outer" ? _this.handleMouseEnter : void 0, onMouseLeave: hoverTarget === "outer" ? _this.handleMouseLeave : void 0, ref: _this.rootRef },
              h("div", { onClick: _this.handleClickAnchor, onMouseDown: _this.handleMouseDownAnchor, onMouseEnter: hoverTarget === "inner" ? _this.handleMouseEnter : void 0, onMouseLeave: hoverTarget === "inner" ? _this.handleMouseLeave : void 0 }, children),
              shouldDestroyDom ? null : react_dom_1.default.createPortal(h(
                "div",
                { className: overlayContainerCls, ref: _this.overlayContainerRef, style: tslib_12.__assign(tslib_12.__assign({ zIndex }, containerStyle), _this.state.position) },
                h("div", { className: overlayCls, style: overlayStyleWithOffset, "aria-atomic": true, "aria-live": "assertive" }, _this.renderTitle(classNames2))
              ), containerDom || document.body)
            )
          );
        };
        return _this;
      }
      Tooltip2.getDerivedStateFromProps = function(props, state) {
        if (props.disabled) {
          return { currentVisible: false };
        }
        return null;
      };
      Tooltip2.prototype.componentDidMount = function() {
        if (this.isVisible()) {
          this.runVisibleEffects();
        }
      };
      Tooltip2.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.cancelPositionChangeChecker) === null || _a === void 0 ? void 0 : _a.call(this);
        clearTimeout(this.showTimeout);
        clearTimeout(this.hideTimeout);
      };
      Tooltip2.prototype.componentDidUpdate = function(prevProps) {
        var _a;
        if (!prevProps.visible && this.props.visible) {
          this.runVisibleEffects();
        }
        if (!this.isVisible()) {
          (_a = this.cancelPositionChangeChecker) === null || _a === void 0 ? void 0 : _a.call(this);
        }
      };
      Tooltip2.prototype.isVisible = function() {
        var _a = this.props, forceVisible = _a.visible, disabled2 = _a.disabled;
        if (disabled2) {
          return false;
        }
        var stateVisible = this.state.currentVisible;
        return typeof forceVisible === "boolean" ? forceVisible : stateVisible;
      };
      Tooltip2.prototype.setStateVisible = function(currentVisible) {
        this.setState({ currentVisible });
        this.props.onVisibleChange(currentVisible);
      };
      Tooltip2.prototype.runVisibleEffects = function() {
        var _this = this;
        this.setState({
          position: this.calcOverlayPosition()
        }, function() {
          requestAnimationFrame(function() {
            var _a;
            (_a = _this.cancelPositionChangeChecker) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.cancelPositionChangeChecker = checkPositionChange_1.checkPositionChange(_this.rootRef.current, _this.hide);
          });
        });
      };
      Tooltip2.prototype.calcStartPositionByAlignment = function(parentStart, parentEnd, selfLength) {
        var alignment = this.props.alignment;
        switch (alignment) {
          case "start":
            return parentStart;
          case "center":
            return (parentStart + parentEnd - selfLength) / 2;
          case "end":
            return parentEnd - selfLength;
          default:
            return 0;
        }
      };
      Tooltip2.prototype.calcOverlayPosition = function() {
        var rootDom = this.rootRef.current;
        var containerDom = this.overlayContainerRef.current;
        if (!rootDom || !containerDom) {
          return { left: "0px", top: "0px" };
        }
        var rootRect = rootDom.getBoundingClientRect();
        var containerRect = containerDom.getBoundingClientRect();
        var placement = this.props.placement;
        if (typeof placement === "string") {
          return this.calcOverlayPositionByPlacement(rootRect, containerRect, placement).position;
        }
        for (var _i = 0, _a = placement; _i < _a.length; _i++) {
          var tryPlacement = _a[_i];
          var _b = this.calcOverlayPositionByPlacement(rootRect, containerRect, tryPlacement), position = _b.position, canFitIn = _b.canFitIn;
          if (canFitIn) {
            return position;
          }
        }
        return this.calcOverlayPositionByPlacement(rootRect, containerRect, placement[0]).position;
      };
      Tooltip2.prototype.calcOverlayPositionByPlacement = function(rootRect, containerRect, placement) {
        var leftX = rootRect.left, rightX = rootRect.right, topY = rootRect.top, bottomY = rootRect.bottom;
        var width = containerRect.width, height = containerRect.height;
        var _a = this.props, containerOffsetX = _a.containerOffsetX, containerOffsetY = _a.containerOffsetY;
        var resultLeft = containerOffsetX;
        var resultTop = containerOffsetY;
        if (placement === "bottom" || placement === "top") {
          resultLeft += this.calcStartPositionByAlignment(leftX, rightX, width);
        }
        if (placement === "left") {
          resultLeft += leftX - TOOLTIP_HORIZONTAL_GAP - width;
        }
        if (placement === "right") {
          resultLeft += rightX + TOOLTIP_HORIZONTAL_GAP;
        }
        var finalLeft = helper_1.castInto(resultLeft, [VIEWPORT_MARGIN, innerWidth - width - VIEWPORT_MARGIN]);
        if (placement === "left" || placement === "right") {
          resultTop += this.calcStartPositionByAlignment(topY, bottomY, height);
        }
        if (placement === "top") {
          resultTop += topY - TOOLTIP_VERTICAL_GAP - height;
        }
        if (placement === "bottom") {
          resultTop += bottomY + TOOLTIP_VERTICAL_GAP;
        }
        var finalTop = helper_1.castInto(resultTop, [VIEWPORT_MARGIN, innerHeight - height - VIEWPORT_MARGIN]);
        return {
          position: { left: finalLeft + "px", top: finalTop + "px" },
          canFitIn: finalLeft === resultLeft && finalTop === resultTop
        };
      };
      Tooltip2.prototype.renderTitle = function(classNames2) {
        var _a = this.props, prefixCls = _a.prefixCls, title2 = _a.title;
        if (Array.isArray(title2) && title2.every(function(line) {
          return typeof line === "string";
        })) {
          return h("div", { className: classNames2(prefixCls + "-title-multiline") }, title2.map(function(line, index) {
            return h("div", { key: index }, line);
          }));
        }
        return title2;
      };
      Tooltip2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Tooltip2;
    }(React2.Component);
    Tooltip.default = Tooltip$12;
    Tooltip$12.defaultProps = {
      prefixCls: "dui-tooltip",
      title: "",
      placement: "bottom",
      trigger: "hover",
      onVisibleChange: helper_1.emptyFn,
      disabled: false,
      offset: 0,
      containerOffsetX: 0,
      containerOffsetY: 0,
      destroyOnClose: true,
      alignment: "center",
      hoverDelay: 400,
      hideOnClick: false,
      hideOnMouseDown: false,
      overlayHoverable: true
    };
    return Tooltip;
  }
  Object.defineProperty(Tooltip$1, "__esModule", { value: true });
  Tooltip$1.Tooltip = void 0;
  var tslib_1$3 = tslib.exports;
  requireStyle().injectStyle("components/Tooltip/style/index.css", '@-webkit-keyframes dui-tooltip-fade-in{0%{opacity:0}to{opacity:1}}@keyframes dui-tooltip-fade-in{0%{opacity:0}to{opacity:1}}[data-dui-0-122-1~="dui-tooltip-wrapper"]{display:inline-block;position:relative}[data-dui-0-122-1~="dui-tooltip-container"]{position:fixed;visibility:hidden;-webkit-transition-property:opacity,visibility;transition-property:opacity,visibility;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-timing-function:linear;transition-timing-function:linear;z-index:10002;opacity:0;-webkit-animation:dui-tooltip-fade-in .2s linear;animation:dui-tooltip-fade-in .2s linear;font-size:medium}[data-dui-0-122-1~="dui-tooltip-container-visible"]{visibility:visible;opacity:1}[data-dui-0-122-1~="dui-tooltip-content"]{display:inline-block;padding:7px 12px;font-size:12px;line-height:18px;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:var(--text-ultrastrong,rgba(0,0,0,.88));-webkit-box-shadow:0 6px 32px 2px rgba(68,73,77,.16),0 4px 6px 2px rgba(0,0,0,.04);box-shadow:0 6px 32px 2px rgba(68,73,77,.16),0 4px 6px 2px rgba(0,0,0,.04);word-break:break-word;background-color:var(--bg-lv4-default,#fff)}[data-dui-0-122-1~="dui-tooltip-title-multiline"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;line-height:16px}');
  var Tooltip_1 = tslib_1$3.__importDefault(requireTooltip());
  Tooltip$1.Tooltip = Tooltip_1.default;
  var _default$3 = Tooltip$1.default = Tooltip_1.default;
  function isPc(ua = window.navigator.userAgent) {
    return !/SymbianOS|iphone|android|iPad/i.test(ua);
  }
  const TooltipPackage = (_a) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    const placement = React.useContext(PlacementContext);
    const tooltipPlacement = (placement == null ? void 0 : placement.startsWith("top")) ? "bottom" : "top";
    return isPc() ? /* @__PURE__ */ React__default.default.createElement(_default$3, __spreadValues({ trigger: "hover", hideOnClick: true, placement: tooltipPlacement }, rest), children) : /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, children);
  };
  const Button$2 = ({ children, onClick, actived: actived2, disabled: disabled2, ariaLabel }) => /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      "aria-label": ariaLabel,
      className: classNames__default.default([
        styles$2.btnWrap,
        {
          [styles$2.actived]: actived2,
          [styles$2.disabled]: disabled2
        }
      ]),
      onClick: disabled2 ? void 0 : onClick
    },
    children
  );
  function Title({ text, shortcut }) {
    return /* @__PURE__ */ React__default.default.createElement("span", null, text, shortcut && /* @__PURE__ */ React__default.default.createElement("b", null, "(", shortcut, ")"));
  }
  const renderIcon = (icon) => {
    if (typeof icon === "string") {
      return /* @__PURE__ */ React__default.default.createElement("img", { src: icon });
    }
    return icon;
  };
  const IconButton = ({ title: title2, description, icon, onClick, actived: actived2, disabled: disabled2 }) => /* @__PURE__ */ React__default.default.createElement(Button$2, { onClick, actived: actived2, disabled: disabled2, ariaLabel: title2 }, /* @__PURE__ */ React__default.default.createElement(TooltipPackage, { title: /* @__PURE__ */ React__default.default.createElement(Title, { text: title2, shortcut: description }) }, renderIcon(icon)));
  function filter(list, predicate) {
    const result = [];
    for (const item of list) {
      if (Array.isArray(item)) {
        const l = filter(item, predicate);
        if (l.length === 0)
          continue;
        result.push(l);
      } else if (predicate(item)) {
        result.push(item);
      }
    }
    return result;
  }
  const arrangeConfig = (config, shouldFold) => {
    const result = filter(config, (item) => item.condition !== false);
    const { left = [], rest = [], right = [] } = groupBy_1(result, (group2) => {
      var _a;
      return (_a = group2[0].fixed) != null ? _a : "rest";
    });
    if (!shouldFold || rest.length <= 1)
      return [...left, ...rest, ...right];
    const renderItem = (item) => "render" in item ? /* @__PURE__ */ React__default.default.createElement(Menu_2.Item, { key: item.key }, item.render()) : /* @__PURE__ */ React__default.default.createElement(
      Menu_2.Item,
      {
        key: item.key,
        className: classNames__default.default({ actived: item.actived }),
        icon: item.icon,
        description: item.description,
        onClick: item.onClick
      },
      item.title
    );
    const addDivider = (list) => {
      const result2 = [];
      list.forEach((item) => {
        if (item === null || item === void 0)
          return;
        if (result2.length > 0)
          result2.push(/* @__PURE__ */ React__default.default.createElement(Divider_2, null));
        result2.push(item);
      });
      return result2;
    };
    const menu2 = /* @__PURE__ */ React__default.default.createElement(Menu_2, { className: styles$2.menu }, addDivider(rest.map((i) => i.map(renderItem))));
    const fold = {
      key: "zoom",
      render: () => /* @__PURE__ */ React__default.default.createElement(Dropdown_2, { trigger: "hover", containerStyle: { padding: "8px 0" }, dropContent: menu2 }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles$2.btnWrap }, /* @__PURE__ */ React__default.default.createElement(SvgToolbarEllipse, null)))
    };
    return [...left, [fold], ...right];
  };
  const renderConfig = (config) => config.map((group2, idx) => /* @__PURE__ */ React__default.default.createElement("div", { className: styles$2.group, key: idx }, group2.map((item) => {
    if ("render" in item)
      return item.render();
    return /* @__PURE__ */ React__default.default.createElement(IconButton, __spreadValues({}, item));
  })));
  const calcPlacement = (placement) => {
    if (!placement)
      return {};
    const MARGIN = 20;
    const placementMap = {
      "top-left": { top: MARGIN, left: MARGIN },
      "top-right": { top: MARGIN, right: MARGIN },
      "bottom-left": { bottom: MARGIN, left: MARGIN },
      "bottom-right": { bottom: MARGIN, right: MARGIN }
    };
    const style2 = placementMap[placement];
    return style2 ? __spreadProps(__spreadValues({}, style2), { position: "fixed" }) : {};
  };
  function Toolbar(props) {
    const { style: style2, className, config, placement, fold = "auto", autoTranslucent: autoTranslucent2 = true } = props;
    const isWide = _default$5("(min-width: 1000px)");
    const shouldFold = fold === "auto" ? !isWide : fold;
    const cfg = arrangeConfig(config, shouldFold);
    return /* @__PURE__ */ React__default.default.createElement(PlacementContext.Provider, { value: placement }, /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        className: classNames__default.default([
          styles$2.presentController,
          className,
          {
            [styles$2.autoTranslucent]: autoTranslucent2
          }
        ]),
        style: __spreadValues(__spreadValues({}, calcPlacement(placement)), style2),
        onClick: (e) => e.stopPropagation()
      },
      renderConfig(cfg)
    ));
  }
  const clockText = "_clockText_jifu7_1";
  const styles$1 = {
    clockText
  };
  function initI18n(resources) {
    const init = (options) => {
      if (!i18next__default.default.getResource || !i18next__default.default.addResource)
        return;
      Object.entries(resources).forEach(([lng, resource]) => {
        Object.entries(resource).forEach(([key, value]) => {
          const ns = options.defaultNS || "legacy";
          if (!i18next__default.default.getResource(lng, ns, key)) {
            i18next__default.default.addResource(lng, ns, key, value);
          }
        });
      });
    };
    i18next__default.default.isInitialized ? init(i18next__default.default.options) : i18next__default.default.on("initialized", init);
  }
  function initLocales() {
    const resources = {
      "zh-CN": {
        "\u4E0A\u4E00\u9875": "\u4E0A\u4E00\u9875",
        "\u4E0B\u4E00\u9875": "\u4E0B\u4E00\u9875",
        "\u5173\u95ED\u6FC0\u5149\u7B14": "\u5173\u95ED\u6FC0\u5149\u7B14",
        "\u6253\u5F00\u6FC0\u5149\u7B14": "\u6253\u5F00\u6FC0\u5149\u7B14",
        "\u5207\u6362\u89C2\u4F17\u89C6\u56FE": "\u5207\u6362\u89C2\u4F17\u89C6\u56FE",
        "\u5207\u6362\u5907\u6CE8\u89C6\u56FE": "\u5207\u6362\u5907\u6CE8\u89C6\u56FE",
        "\u9000\u51FA\u5168\u5C4F": "\u9000\u51FA\u5168\u5C4F",
        "\u8FDB\u5165\u5168\u5C4F": "\u8FDB\u5165\u5168\u5C4F",
        "\u9000\u51FA\u6F14\u793A": "\u9000\u51FA\u6F14\u793A",
        "\u5907\u6CE8\u89C6\u56FE": "\u5907\u6CE8\u89C6\u56FE",
        "\u4E0A\u5348": "\u4E0A\u5348",
        "\u4E0B\u5348": "\u4E0B\u5348",
        "\u5173\u95ED\u6279\u6CE8": "\u5173\u95ED\u6279\u6CE8",
        "\u6253\u5F00\u6279\u6CE8": "\u6253\u5F00\u6279\u6CE8"
      },
      "zh-HK": {
        "\u4E0A\u4E00\u9875": "\u4E0A\u4E00\u9801",
        "\u4E0B\u4E00\u9875": "\u4E0B\u4E00\u9801",
        "\u5173\u95ED\u6FC0\u5149\u7B14": "\u95DC\u9589\u6FC0\u5149\u7B46",
        "\u6253\u5F00\u6FC0\u5149\u7B14": "\u6253\u958B\u6FC0\u5149\u7B46",
        "\u5207\u6362\u89C2\u4F17\u89C6\u56FE": "\u5207\u63DB\u89C0\u773E\u8996\u5716",
        "\u5207\u6362\u5907\u6CE8\u89C6\u56FE": "\u5207\u63DB\u5099\u8A3B\u8996\u5716",
        "\u9000\u51FA\u5168\u5C4F": "\u9000\u51FA\u5168\u5C4F",
        "\u8FDB\u5165\u5168\u5C4F": "\u9032\u5165\u5168\u5C4F",
        "\u9000\u51FA\u6F14\u793A": "\u9000\u51FA\u6F14\u793A",
        "\u5907\u6CE8\u89C6\u56FE": "\u5099\u8A3B\u8996\u5716",
        "\u4E0A\u5348": "\u4E0A\u5348",
        "\u4E0B\u5348": "\u4E0B\u5348",
        "\u5173\u95ED\u6279\u6CE8": "\u95DC\u9589\u6279\u8A3B",
        "\u6253\u5F00\u6279\u6CE8": "\u6253\u958B\u6279\u8A3B"
      },
      "en-US": {
        "\u4E0A\u4E00\u9875": "Previous page",
        "\u4E0B\u4E00\u9875": "Next page",
        "\u5173\u95ED\u6FC0\u5149\u7B14": "Turn Off Laser Pointer",
        "\u6253\u5F00\u6FC0\u5149\u7B14": "Turn On Laser Pointer",
        "\u5207\u6362\u89C2\u4F17\u89C6\u56FE": "Switch to Audience View",
        "\u5207\u6362\u5907\u6CE8\u89C6\u56FE": "Switch to Notes View",
        "\u9000\u51FA\u5168\u5C4F": "Exit full screen",
        "\u8FDB\u5165\u5168\u5C4F": "Go to full screen",
        "\u9000\u51FA\u6F14\u793A": "Exit play",
        "\u5907\u6CE8\u89C6\u56FE": "Notes View",
        "\u4E0A\u5348": "AM",
        "\u4E0B\u5348": "PM",
        "\u5173\u95ED\u6279\u6CE8": "Turn Off Comment",
        "\u6253\u5F00\u6279\u6CE8": "Turn On Comment"
      }
    };
    initI18n(resources);
  }
  const $t = (...args) => i18next__default.default.t(...args) || args[0];
  const formatTime = (t) => {
    const min = t.getMinutes().toLocaleString("zh", { minimumIntegerDigits: 2 });
    const hour = t.getHours().toLocaleString("zh", { minimumIntegerDigits: 2 });
    const preText = +hour < 12 ? $t("\u4E0A\u5348") : $t("\u4E0B\u5348");
    return `${preText}  ${hour} : ${min}`;
  };
  function Clock() {
    const [date, setDate] = React.useState(new Date());
    React.useEffect(() => {
      const timer = setInterval(() => {
        setDate(new Date());
      }, 1e3);
      return () => clearTimeout(timer);
    });
    return /* @__PURE__ */ React__default.default.createElement("div", { className: styles$1.clockText }, formatTime(date));
  }
  var Checkbox$1 = {};
  var Checkbox = {};
  var instanceId = {};
  var hasRequiredInstanceId;
  function requireInstanceId() {
    if (hasRequiredInstanceId)
      return instanceId;
    hasRequiredInstanceId = 1;
    Object.defineProperty(instanceId, "__esModule", { value: true });
    instanceId.createGlobalInstanceId = void 0;
    var helper_1 = requireHelper();
    var globalObj = helper_1.isBrowser ? window : commonjsGlobal;
    globalObj.__dui_instance_counter__ = globalObj.__dui_instance_counter__ || {};
    var counterMap = globalObj.__dui_instance_counter__;
    function createGlobalInstanceId(type) {
      counterMap[type] = counterMap[type] || 0;
      counterMap[type]++;
      return "dui" + type + "Id-" + counterMap[type];
    }
    instanceId.createGlobalInstanceId = createGlobalInstanceId;
    return instanceId;
  }
  var hasRequiredCheckbox;
  function requireCheckbox() {
    if (hasRequiredCheckbox)
      return Checkbox;
    hasRequiredCheckbox = 1;
    Object.defineProperty(Checkbox, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    var theme_1 = requireTheme();
    var instanceId_1 = requireInstanceId();
    var Checkbox$12 = function(_super) {
      tslib_12.__extends(Checkbox2, _super);
      function Checkbox2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = instanceId_1.createGlobalInstanceId("Checkbox");
        _this.state = {
          checked: Boolean(_this.props.defaultChecked)
        };
        _this.handleChange = function(e) {
          var props = _this.props;
          if (props.disabled) {
            return;
          }
          if (!("checked" in props)) {
            _this.setState({
              checked: e.target.checked
            });
          }
          props.onChange(e.target.checked, {
            target: tslib_12.__assign(tslib_12.__assign({}, props), { checked: e.target.checked }),
            stopPropagation: e.stopPropagation.bind(e),
            preventDefault: e.preventDefault.bind(e),
            nativeEvent: e.nativeEvent
          });
        };
        _this.themedRender = function(classNames2) {
          var _a, _b;
          var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style2 = _c.style, children = _c.children, disabled2 = _c.disabled, hollow = _c.hollow, labelClickable = _c.labelClickable, shape = _c.shape, iconClassName = _c.iconClassName, labelClassName = _c.labelClassName, iconStyle = _c.iconStyle, labelStyle = _c.labelStyle, fillType = _c.fillType, rest = tslib_12.__rest(_c, ["prefixCls", "className", "style", "children", "disabled", "hollow", "labelClickable", "shape", "iconClassName", "labelClassName", "iconStyle", "labelStyle", "fillType"]);
          var checked = "checked" in _this.props ? _this.props.checked : _this.state.checked;
          var cls = classNames2(prefixCls, className, prefixCls + "-" + (hollow ? "hollow" : "normal"), prefixCls + "-" + fillType, (_a = {}, _a[prefixCls + "-multi-line"] = React2.Children.count(children) > 1, _a[prefixCls + "-checked"] = checked, _a[prefixCls + "-disabled"] = disabled2, _a));
          var inputCls = classNames2(prefixCls + "-input", (_b = {}, _b[prefixCls + "-input-full"] = labelClickable, _b));
          var iconCls = classNames2(prefixCls + "-icon", prefixCls + "-icon-" + shape, iconClassName);
          var labelCls = classNames2(prefixCls + "-label", labelClassName);
          var ariaLabel = _this.id;
          return h(
            "div",
            { className: cls, style: style2 },
            h("input", tslib_12.__assign({}, rest, { type: "checkbox", className: inputCls, onChange: _this.handleChange, disabled: disabled2, "aria-labelledby": ariaLabel })),
            h("span", { className: iconCls, style: iconStyle, "aria-hidden": true }),
            h("div", { className: labelCls, style: labelStyle, id: ariaLabel }, children)
          );
        };
        return _this;
      }
      Checkbox2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Checkbox2;
    }(React2.Component);
    Checkbox.default = Checkbox$12;
    Checkbox$12.defaultProps = {
      prefixCls: "dui-checkbox",
      onChange: helper_1.emptyFn,
      disabled: false,
      hollow: false,
      labelClickable: true,
      shape: "square",
      fillType: "tick"
    };
    return Checkbox;
  }
  var Group = {};
  var util = {};
  var hasRequiredUtil;
  function requireUtil() {
    if (hasRequiredUtil)
      return util;
    hasRequiredUtil = 1;
    Object.defineProperty(util, "__esModule", { value: true });
    util.renderChildren = void 0;
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    function renderChildren(props, checkedValues, handleSingleChange, Component, itemStyle) {
      var children = props.children;
      var options = props.options || [];
      var disabled2 = props.disabled;
      var style2 = tslib_12.__assign({ paddingBottom: 18 }, itemStyle);
      if (options.length) {
        return options.map(function(option, index) {
          if (typeof option === "string") {
            return h(Component, { key: index, value: option, onChange: handleSingleChange, checked: checkedValues.indexOf(option) !== -1, disabled: disabled2, style: tslib_12.__assign({}, style2) }, option);
          } else {
            return h(Component, tslib_12.__assign({}, option, { key: index, value: option.value, onChange: handleSingleChange, checked: checkedValues.indexOf(option.value) !== -1, disabled: option.disabled || disabled2, style: tslib_12.__assign(tslib_12.__assign({}, style2), option.style) }), option.label);
          }
        });
      }
      return React2.Children.map(children, function(child) {
        return React2.cloneElement(child, {
          checked: checkedValues.indexOf(child.props.value) !== -1,
          onChange: handleSingleChange,
          disabled: child.props.disabled || disabled2,
          style: tslib_12.__assign(tslib_12.__assign({}, style2), child.props.style)
        });
      });
    }
    util.renderChildren = renderChildren;
    return util;
  }
  var hasRequiredGroup;
  function requireGroup() {
    if (hasRequiredGroup)
      return Group;
    hasRequiredGroup = 1;
    Object.defineProperty(Group, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var PropTypes = tslib_12.__importStar(requirePropTypes());
    var util_12 = requireUtil();
    var helper_1 = requireHelper();
    var Checkbox_12 = tslib_12.__importDefault(requireCheckbox());
    var theme_1 = requireTheme();
    var Group$1 = function(_super) {
      tslib_12.__extends(Group2, _super);
      function Group2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
          values: _this.props.defaultValues || []
        };
        _this.handleSingleChange = function(checked, e) {
          if (_this.props.disabled) {
            return;
          }
          var checkedValues = _this.state.values;
          var newValues = [];
          if (checkedValues.indexOf(e.target.value) >= 0 && !checked) {
            newValues = checkedValues.filter(function(v) {
              return v !== e.target.value;
            });
            _this.setState({ values: newValues });
            _this.props.onChange(newValues, e);
          } else if (checkedValues.indexOf(e.target.value) === -1 && checked) {
            newValues = checkedValues.concat(e.target.value);
            _this.setState({ values: newValues });
            _this.props.onChange(newValues, e);
          }
        };
        _this.themedRender = function(classNames2) {
          var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style2 = _a.style, itemStyle = _a.itemStyle;
          var cls = classNames2(prefixCls, className);
          return h("div", { className: cls, style: style2 }, util_12.renderChildren(_this.props, _this.state.values, _this.handleSingleChange, Checkbox_12.default, itemStyle));
        };
        return _this;
      }
      Group2.getDerivedStateFromProps = function(props, state) {
        if ("values" in props) {
          return { values: props.values };
        }
        return null;
      };
      Group2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Group2;
    }(React2.Component);
    Group.default = Group$1;
    Group$1.defaultProps = {
      prefixCls: "dui-checkbox-group",
      disabled: false,
      onChange: helper_1.emptyFn
    };
    Group$1.propTypes = {
      prefixCls: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
      options: PropTypes.array,
      disabled: PropTypes.bool,
      values: PropTypes.array,
      children: PropTypes.node,
      defaultValues: PropTypes.array,
      onChange: PropTypes.func,
      itemStyle: PropTypes.object
    };
    return Group;
  }
  Object.defineProperty(Checkbox$1, "__esModule", { value: true });
  Checkbox$1.Checkbox = void 0;
  var tslib_1$2 = tslib.exports;
  var Checkbox_1 = tslib_1$2.__importDefault(requireCheckbox());
  Checkbox$1.Checkbox = Checkbox_1.default;
  var Group_1 = tslib_1$2.__importDefault(requireGroup());
  requireStyle().injectStyle("components/Checkbox/style/index.css", `[data-dui-0-122-1~="dui-checkbox"]{position:relative;padding-left:24px;font-size:14px;line-height:20px;-webkit-tap-highlight-color:transparent}[data-dui-0-122-1~="dui-checkbox-disabled"]{pointer-events:none}[data-dui-0-122-1~="dui-checkbox-multi-line"]{padding-left:24px}[data-dui-0-122-1~="dui-checkbox-icon"]{position:absolute;z-index:1;left:0;top:2px;width:16px;height:16px;border:1px solid var(--border-ultrastrong,rgba(0,0,0,.16));-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-checkbox-icon-square"]{border-radius:2px}[data-dui-0-122-1~="dui-checkbox-icon-circle"]{border-radius:50%}[data-dui-0-122-1~="dui-checkbox-normal"]:hover [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:var(--feedback-hover,rgba(51,77,102,.06))}[data-dui-0-122-1~="dui-checkbox-normal"]:active [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:var(--feedback-active,rgba(51,77,102,.08))}[data-dui-0-122-1~="dui-checkbox-hollow"]:hover [data-dui-0-122-1~="dui-checkbox-icon"]{border-color:var(--accent-default,#1e6fff)}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:var(--accent-default,#1e6fff);border-color:transparent}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-checked"]:hover [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:var(--accent-hover,#175ceb)}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-checked"]:active [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:var(--accent-pressed,#134ae0)}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]{background-color:#fff;border-color:var(--accent-default,#1e6fff)}[data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{content:"";display:block}[data-dui-0-122-1~="dui-checkbox-tick"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{width:100%;height:100%;background-position:50%;background-repeat:no-repeat}[data-dui-0-122-1~="dui-checkbox-dash"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{width:8px;height:2px}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-tick"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8'%3E%3Cpath fill='%23fff' d='M3.64 5.6L8.9 0 10 1.168 3.57 8 0 4.204l1.17-1.242z' fill-rule='evenodd'/%3E%3C/svg%3E")}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-tick"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8'%3E%3Cpath fill='%231E6FFF' d='M3.64 5.6L8.9 0 10 1.168 3.57 8 0 4.204l1.17-1.242z' fill-rule='evenodd'/%3E%3C/svg%3E")}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-dash"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background:#fff}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-dash"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background:var(--accent-default,#1e6fff)}[data-dui-0-122-1~="dui-checkbox-disabled"] [data-dui-0-122-1~="dui-checkbox-label"]{opacity:.36}[data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"],[data-dui-0-122-1~="dui-checkbox-disabled"] [data-dui-0-122-1~="dui-checkbox-icon"]{border-color:#e9ebed}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]{background:#e9ebed;border-color:transparent}[data-dui-0-122-1~="dui-checkbox-normal"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8'%3E%3Cpath fill='%23fff' d='M3.64 5.6L8.9 0 10 1.168 3.57 8 0 4.204l1.17-1.242z' fill-rule='evenodd'/%3E%3C/svg%3E")}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-tick"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]{background:#fff}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-tick"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8'%3E%3Cpath opacity='.08' d='M3.64 5.6L8.9 0 10 1.168 3.57 8 0 4.204l1.17-1.242z' fill-rule='evenodd'/%3E%3C/svg%3E")}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-dash"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]{background:#fff}[data-dui-0-122-1~="dui-checkbox-hollow"][data-dui-0-122-1~="dui-checkbox-disabled"][data-dui-0-122-1~="dui-checkbox-dash"][data-dui-0-122-1~="dui-checkbox-checked"] [data-dui-0-122-1~="dui-checkbox-icon"]:after{background:#e9ebed}[data-dui-0-122-1~="dui-checkbox-input"]{position:absolute;z-index:2;margin:0;opacity:0;left:0;top:0;height:100%;width:16px;cursor:pointer}[data-dui-0-122-1~="dui-checkbox-input-full"]{width:100%}`);
  Checkbox_1.default.Group = Group_1.default;
  var _default$2 = Checkbox$1.default = Checkbox_1.default;
  const container = "_container_6fb3v_1";
  const closeBtn = "_closeBtn_6fb3v_11";
  const closeLabel = "_closeLabel_6fb3v_22";
  const style$2 = {
    container,
    closeBtn,
    closeLabel
  };
  function Panel(props) {
    return /* @__PURE__ */ React__default.default.createElement("div", { className: classNames__default.default(style$2.container, props.containerClassName), style: props.containerStyle }, /* @__PURE__ */ React__default.default.createElement("button", { "aria-label": "Close", className: style$2.closeBtn, onClick: props.onClose }, /* @__PURE__ */ React__default.default.createElement("span", { className: style$2.closeLabel })), props.children);
  }
  const invite = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT7nvJbnu4QgNDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxjaXJjbGUgaWQ9InBhdGgtMSIgY3g9IjEyIiBjeT0iMTIiIHI9IjEyIj48L2NpcmNsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJQUFQtUEMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJQUFQt5p+l55yL5Y+C5LiO5oiQ5ZGYIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQ2LjAwMDAwMCwgLTU3Ni4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDIyLjAwMDAwMCwgMjg0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNS4wMDAwMDAsIDI5My4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQml0bWFwLUNvcHktMiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTExLDExIEwxMSw2IEwxMyw2IEwxMywxMSBMMTgsMTEgTDE4LDEzIEwxMywxMyBMMTMsMTggTDExLDE4IEwxMSwxMyBMNiwxMyBMNiwxMSBMMTEsMTEgWiIgaWQ9IuW9oueKtue7k+WQiCIgZmlsbD0iI0FEQURBRCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
  const audience = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NS4yICg3ODE4MSkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+6buY6K6k5aS05YOPMjR4MjQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTEiIGN4PSIxMiIgY3k9IjEyIiByPSIxMiI+PC9jaXJjbGU+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iUFBULVBDIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUFBULeafpeeci+WPguS4juaIkOWRmCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ0Ni4wMDAwMDAsIC01MzYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtMTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQyMi4wMDAwMDAsIDI4NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSLpu5jorqTlpLTlg48yNHgyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUuMDAwMDAwLCAyNTMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8cGF0aAogICAgICAgICAgICAgICAgICAgICAgICBkPSJNNC4wMDAxMTE5LDIwIEMzLjk5MzE5NDA3LDE5LjI4NjE4NjkgNC4zMDY2OTU0NCwxOC42NzU5NjU0IDUuMDM2MjY3NzEsMTguMjk2NzMwNSBDNi4zNjQxMTg2NCwxNy42MDY1Nzc3IDcuNzE2NzI2MSwxNi45NjQwMDIgOS4wNTg2NDMyNCwxNi4zMDEwMzYyIEMxMC41NDg1MzcsMTUuNTY0NzIyMSAxMC42NTcxMjgyLDE1LjIyNjg2NzIgOS43MDAzNDQwOCwxMy44Nzk0MTI1IEM4LjU4Nzk4NzYxLDEyLjMxMjQ3OTUgOC40MzM4MjE4NywxMC41NTU1MjA5IDguNzExMjA3NjcsOC43NTE1NTE0MiBDOC45NTU5NTk4Niw3LjE1OTEzMDY2IDEwLjQyODQxMTUsNi4wMDE3MDE1OCAxMS45OTU5NTA4LDYgQzEzLjYxNjk0MTcsNS45OTgwMjAwMSAxNS4xMDM3NDA4LDcuMjI1NjgyMTIgMTUuMzE2MTQwNyw4Ljg4MjEwNTU3IEMxNS41NDg1MTQ2LDEwLjY5MzcyMTQgMTUuMzYwNTksMTIuNDM2ODAzMyAxNC4yMTg5NzU4LDEzLjk4ODE2MDQgQzEzLjM1MjQ5NjgsMTUuMTY1MTMwMSAxMy40ODgzNzY0LDE1LjU3OTE2NTIgMTQuODAzMjg2NCwxNi4yNDAxNDg3IEMxNi4wNTY4Njc3LDE2Ljg2OTk4MDQgMTcuMzIwODU4LDE3LjQ3OTEzODcgMTguNTgyNTk3NywxOC4wOTIyNjE3IEMxOS4yMzQ3MDc2LDE4LjQwOTE2IDE5Ljc4NTgyMiwxOC43OTYyOTEzIDE5LjkzNjYxMTgsMTkuNTg3MjYyNSBDMTkuOTY0ODQ3NSwxOS43MzU0MTM4IDE5Ljk4MzkwNDgsMTkuODcyODY3IDE5Ljk5MzI2OTksMjAgTDIwLDIwIEwyMCwyNCBMNCwyNCBMNCwyMCBaIgogICAgICAgICAgICAgICAgICAgICAgICBpZD0i5ZCI5bm25b2i54q2IiBmaWxsPSIjQURBREFEIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
  const title = "_title_v4lhd_1";
  const member = "_member_v4lhd_5";
  const avatar = "_avatar_v4lhd_10";
  const name = "_name_v4lhd_26";
  const memberList = "_memberList_v4lhd_36";
  const allowFlipCheckbox = "_allowFlipCheckbox_v4lhd_60";
  const style$1 = {
    title,
    member,
    avatar,
    name,
    memberList,
    allowFlipCheckbox
  };
  function LiveMemberDialog(props) {
    const onClickAddNew = () => {
      props.onClose();
      props.onInviteUser();
    };
    const onCheckChanged = (value) => {
      var _a;
      (_a = props.onFlipChanged) == null ? void 0 : _a.call(props, value);
    };
    const { memberList: memberList2, memberCount } = props;
    const audienceNum = `\u53C2\u4E0E\u6210\u5458(${memberCount})`;
    const showList = [...memberList2];
    const anonymousCount = props.memberCount - memberList2.length;
    if (anonymousCount > 0) {
      showList.push({
        uid: "-1",
        name: `${anonymousCount}\u540D\u89C2\u4F17`,
        userPic: audience
      });
    }
    showList.push({
      uid: "-2",
      name: "\u9080\u8BF7\u597D\u53CB",
      userPic: invite
    });
    const members = showList.map(({ uid, userPic, name: name2 }) => {
      const isInvite = uid === "-2";
      console.info(props.speakerName);
      return /* @__PURE__ */ React__default.default.createElement(
        "div",
        {
          key: uid,
          className: style$1.member,
          onClick: isInvite ? onClickAddNew : void 0,
          style: { cursor: isInvite ? "pointer" : "unset" }
        },
        /* @__PURE__ */ React__default.default.createElement("div", { className: style$1.avatar }, /* @__PURE__ */ React__default.default.createElement("img", { src: userPic })),
        /* @__PURE__ */ React__default.default.createElement("div", { className: style$1.name }, props.speakerName === name2 ? `(\u6B63\u5728\u6F14\u793A)${name2}` : name2)
      );
    });
    return /* @__PURE__ */ React__default.default.createElement(_default$4.Keep, null, /* @__PURE__ */ React__default.default.createElement(Panel, { onClose: props.onClose }, /* @__PURE__ */ React__default.default.createElement("div", { className: style$1.title }, audienceNum), /* @__PURE__ */ React__default.default.createElement("div", { className: style$1.memberList }, members), !props.hideAllowFlip && /* @__PURE__ */ React__default.default.createElement("div", { className: style$1.allowFlipCheckbox }, /* @__PURE__ */ React__default.default.createElement(
      _default$2,
      {
        checked: props.allowFlip,
        onChange: onCheckChanged,
        style: { fontSize: 16, display: "inline-block" }
      },
      "\u5141\u8BB8\u89C2\u770B\u8005\u7FFB\u770B\u6587\u6863\u5168\u6587"
    ))));
  }
  var Modal$1 = {};
  var Modal = {};
  var Button$1 = {};
  var Button = {};
  var hasRequiredButton;
  function requireButton() {
    if (hasRequiredButton)
      return Button;
    hasRequiredButton = 1;
    Object.defineProperty(Button, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var PropTypes = tslib_12.__importStar(requirePropTypes());
    var theme_1 = requireTheme();
    var Button$12 = function(_super) {
      tslib_12.__extends(Button2, _super);
      function Button2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function(classNames2) {
          var _a;
          var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style2 = _b.style, type = _b.type, size = _b.size, disabled2 = _b.disabled, icon = _b.icon, testId = _b.testId, rest = tslib_12.__rest(_b, ["prefixCls", "className", "style", "type", "size", "disabled", "icon", "testId"]);
          var cls = classNames2(prefixCls, className, (_a = {}, _a[prefixCls + "-type-" + type] = type, _a[prefixCls + "-size-" + size] = size, _a[prefixCls + "-with-icon"] = icon, _a[prefixCls + "-type-" + type + "-disabled"] = disabled2, _a));
          var containerCls = classNames2(prefixCls + "-container");
          var iconCls = classNames2(prefixCls + "-icon");
          return h(
            "button",
            tslib_12.__assign({}, rest, { className: cls, style: style2, disabled: disabled2, "data-testid": testId }),
            h(
              "div",
              { className: containerCls },
              icon ? typeof icon === "string" ? h("span", { className: iconCls, style: { backgroundImage: 'url("' + icon + '")' } }) : icon : null,
              _this.props.children
            )
          );
        };
        return _this;
      }
      Button2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Button2;
    }(React2.Component);
    Button.default = Button$12;
    Button$12.defaultProps = {
      prefixCls: "dui-button",
      type: "default",
      size: "default"
    };
    Button$12.propTypes = {
      prefixCls: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
      type: PropTypes.oneOf(["default", "primary", "warning", "plain", "golden", "golden-outline"]),
      size: PropTypes.oneOf(["default", "small", "large"]),
      icon: PropTypes.node
    };
    return Button;
  }
  Object.defineProperty(Button$1, "__esModule", { value: true });
  Button$1.Button = void 0;
  var tslib_1$1 = tslib.exports;
  var Button_1 = tslib_1$1.__importDefault(requireButton());
  Button$1.Button = Button_1.default;
  requireStyle().injectStyle("components/Button/style/index.css", '[data-dui-0-122-1~="dui-button"]{outline:none;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;white-space:nowrap;border-radius:4px;border:1px solid transparent;font-size:14px;padding:0 29px;-webkit-tap-highlight-color:transparent}[data-dui-0-122-1~="dui-button-container"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row nowrap;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-button-type-default"]{background:var(--tsp-fill-medium,rgba(51,77,102,.08));color:var(--text-ultrastrong,rgba(0,0,0,.88))}[data-dui-0-122-1~="dui-button-type-default"]:hover{background:var(--tsp-fill-strong,rgba(61,82,102,.12))}[data-dui-0-122-1~="dui-button-type-default"]:active{background:var(--tsp-fill-ultrastrong,rgba(61,82,102,.16))}[data-dui-0-122-1~="dui-button-type-primary"]{background:var(--accent-default,#1e6fff);color:var(--text-white,#fff)}[data-dui-0-122-1~="dui-button-type-primary"]:hover{background:var(--accent-hover,#175ceb)}[data-dui-0-122-1~="dui-button-type-primary"]:active{background:var(--accent-pressed,#134ae0)}[data-dui-0-122-1~="dui-button-type-warning"]{background:var(--critical-default,#ff4747);color:#fff}[data-dui-0-122-1~="dui-button-type-warning"]:hover{background:var(--critical-hover,#eb3639)}[data-dui-0-122-1~="dui-button-type-warning"]:active{background:var(--critical-pressed,#e02424)}[data-dui-0-122-1~="dui-button-type-plain"]{background:var(--bg-lv1-default,#fff);color:var(--text-link,#175ceb)}[data-dui-0-122-1~="dui-button-type-plain"]:hover{background:var(--bg-lv1-weak,#f9fafb)}[data-dui-0-122-1~="dui-button-type-plain"]:active{background:var(--bg-lv1-medium,#f3f5f7)}[data-dui-0-122-1~="dui-button-type-golden"]{background:-webkit-linear-gradient(335deg,#f6ddb1,#e4bd80);background:linear-gradient(115deg,#f6ddb1,#e4bd80);border:none;color:#865812}[data-dui-0-122-1~="dui-button-type-golden"] [data-dui-0-122-1~="dui-button-container"]{margin:0 1px}[data-dui-0-122-1~="dui-button-type-golden"]:hover{background:-webkit-linear-gradient(335deg,#edce98,#dbaa5e);background:linear-gradient(115deg,#edce98,#dbaa5e)}[data-dui-0-122-1~="dui-button-type-golden"]:active{background:-webkit-linear-gradient(335deg,#daba81,#d49d48);background:linear-gradient(115deg,#daba81,#d49d48)}[data-dui-0-122-1~="dui-button-type-golden-outline"]{border-color:#db8f1c;color:#db8f1c;background:#fff}[data-dui-0-122-1~="dui-button-type-golden-outline"]:hover{background:rgba(219,143,28,.1)}[data-dui-0-122-1~="dui-button-type-golden-outline"]:active{background:rgba(219,143,28,.2)}[data-dui-0-122-1~="dui-button"]:disabled{border-color:transparent;pointer-events:none;cursor:auto}[data-dui-0-122-1~="dui-button"]:disabled,[data-dui-0-122-1~="dui-button"]:disabled:active,[data-dui-0-122-1~="dui-button"]:disabled:hover{color:var(--text-weak,rgba(0,0,0,.24));background:var(--tsp-fill-weak,rgba(51,77,102,.06))}[data-dui-0-122-1~="dui-button-size-large"]{height:36px;min-width:156px;font-size:16px}[data-dui-0-122-1~="dui-button-size-default"]{height:36px}[data-dui-0-122-1~="dui-button-size-small"]{height:28px;padding:0 17px;font-size:12px}[data-dui-0-122-1~="dui-button-size-small"] [data-dui-0-122-1~="dui-button-container"]{line-height:26px}[data-dui-0-122-1~="dui-button-with-icon"]{padding:0 9px}[data-dui-0-122-1~="dui-button-icon"]{display:inline-block;width:18px;height:18px;background-size:contain;background-repeat:no-repeat;background-position:50%;margin-right:4px}');
  var _default$1 = Button$1.default = Button_1.default;
  var Dragger = {};
  var hasRequiredDragger;
  function requireDragger() {
    if (hasRequiredDragger)
      return Dragger;
    hasRequiredDragger = 1;
    Object.defineProperty(Dragger, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var helper_1 = requireHelper();
    var theme_1 = requireTheme();
    var Dragger$1 = function(_super) {
      tslib_12.__extends(Dragger2, _super);
      function Dragger2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = null;
        _this.minLeft = 0;
        _this.minTop = 0;
        _this.setRef = function(ref) {
          _this.ref = ref;
        };
        _this.onMouseDown = function(e) {
          if (!_this.props.draggable || !_this.ref || _this.isFromInnerInput(e)) {
            return;
          }
          _this.mouse = true;
          var _a = _this.ref.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
          var clientX = e.clientX, clientY = e.clientY;
          _this.startLeft = left;
          _this.startTop = top;
          _this.startX = clientX;
          _this.startY = clientY;
          _this.maxLeft = window.innerWidth - width;
          _this.maxTop = window.innerHeight - height;
          _this.ref.style.userSelect = "none";
          _this.ref.parentElement.style.pointerEvents = "auto";
        };
        _this.onMouseMove = function(e) {
          if (!_this.mouse || !_this.ref) {
            return;
          }
          var clientX = e.clientX, clientY = e.clientY;
          var left = _this.startLeft + clientX - _this.startX;
          var top = _this.startTop + clientY - _this.startY;
          left = Math.min(Math.max(_this.minLeft, left), _this.maxLeft);
          top = Math.min(Math.max(_this.minTop, top), _this.maxTop);
          _this.ref.style.position = "absolute";
          _this.ref.style.left = left + "px";
          _this.ref.style.top = top + "px";
        };
        _this.onMouseUp = function(e) {
          if (!_this.ref) {
            return;
          }
          _this.mouse = false;
          _this.ref.style.userSelect = "auto";
          _this.ref.parentElement.style.pointerEvents = "";
          var _a = _this.props, onDragEnd = _a.onDragEnd, draggable = _a.draggable;
          if (draggable === true) {
            onDragEnd(e);
          }
        };
        _this.themedRender = function(classNames2) {
          var _a = _this.props, children = _a.children, className = _a.className, prefixCls = _a.prefixCls, style2 = _a.style;
          _a.onDragEnd;
          _a.draggable;
          var rest = tslib_12.__rest(_a, ["children", "className", "prefixCls", "style", "onDragEnd", "draggable"]);
          var cls = classNames2(prefixCls, className);
          return h("div", tslib_12.__assign({}, rest, { className: cls, style: style2, ref: _this.setRef, onMouseDown: _this.onMouseDown, tabIndex: -1 }), children);
        };
        return _this;
      }
      Dragger2.prototype.componentDidMount = function() {
        document.body.addEventListener("mousemove", this.onMouseMove);
        document.body.addEventListener("mouseup", this.onMouseUp);
      };
      Dragger2.prototype.componentWillUnmount = function() {
        document.body.removeEventListener("mousemove", this.onMouseMove);
        document.body.removeEventListener("mouseup", this.onMouseUp);
      };
      Dragger2.prototype.isFromInnerInput = function(e) {
        var _a;
        var target = e.target;
        return Boolean(/input|textarea/i.test(target.tagName) && ((_a = this.ref) === null || _a === void 0 ? void 0 : _a.contains(target)));
      };
      Dragger2.prototype.render = function() {
        return theme_1.consumeTheme(this.themedRender);
      };
      return Dragger2;
    }(React2.Component);
    Dragger.default = Dragger$1;
    Dragger$1.defaultProps = {
      prefixCls: "dui-dragger",
      onDragEnd: helper_1.emptyFn,
      onClick: helper_1.emptyFn,
      draggable: false
    };
    return Dragger;
  }
  var context = {};
  var hasRequiredContext;
  function requireContext() {
    if (hasRequiredContext)
      return context;
    hasRequiredContext = 1;
    Object.defineProperty(context, "__esModule", { value: true });
    context.ContainerContext = void 0;
    var tslib_12 = tslib.exports;
    var React2 = tslib_12.__importStar(React__default.default);
    context.ContainerContext = React2.createContext(null);
    return context;
  }
  var preventScrollPenetrate = {};
  var hasRequiredPreventScrollPenetrate;
  function requirePreventScrollPenetrate() {
    if (hasRequiredPreventScrollPenetrate)
      return preventScrollPenetrate;
    hasRequiredPreventScrollPenetrate = 1;
    Object.defineProperty(preventScrollPenetrate, "__esModule", { value: true });
    preventScrollPenetrate.toggleGlobalScrollEvents = preventScrollPenetrate.PreventScrollPenetrateContainer = preventScrollPenetrate.preventSelfScrollPenetrate = void 0;
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var React2 = tslib_12.__importStar(React__default.default);
    var STYLUS_TOUCH_MOVE_CLICK_DISTANCE = 10;
    function preventSelfScrollPenetrate(container2, direction, stopPropagationBorder) {
      if (direction === void 0) {
        direction = "y";
      }
      if (stopPropagationBorder === void 0) {
        stopPropagationBorder = null;
      }
      if (!container2 || container2.__preventSelfScrollPenetrate) {
        return;
      }
      var prevX;
      var prevY;
      var reachBorderInScroll = null;
      var handleTouchStart = function(event) {
        reachBorderInScroll = null;
        var touch = event.touches[0];
        prevX = touch.screenX;
        prevY = touch.screenY;
      };
      var handleTouchMove = function(event) {
        var touch = event.touches[0];
        var deltaX = touch.screenX - prevX;
        var deltaY = touch.screenY - prevY;
        var isAtLowerX = direction === "x" && container2.scrollLeft === 0;
        var isAtUpperX = direction === "x" && container2.scrollLeft === container2.scrollWidth - container2.offsetWidth;
        var isAtLowerY = direction === "y" && container2.scrollTop === 0;
        var isAtUpperY = direction === "y" && container2.scrollTop === container2.scrollHeight - container2.offsetHeight;
        var isScrollingBeyondBorder = direction === "x" ? deltaX > 0 && isAtLowerX || deltaX < 0 && isAtUpperX : deltaY > 0 && isAtLowerY || deltaY < 0 && isAtUpperY;
        var currentBorder = isAtLowerX || isAtLowerY ? "lower" : isAtUpperX || isAtUpperY ? "upper" : null;
        if (isScrollingBeyondBorder) {
          event.cancelable && event.preventDefault();
          if (reachBorderInScroll !== currentBorder) {
            container2.dispatchEvent(new TouchEvent("touchstart", event));
            reachBorderInScroll = currentBorder;
          }
          stopPropagationBorder === currentBorder && event.stopPropagation();
        } else {
          event.stopPropagation();
        }
      };
      container2.addEventListener("touchstart", handleTouchStart);
      container2.addEventListener("touchmove", handleTouchMove, { passive: false });
      container2.__preventSelfScrollPenetrate = true;
    }
    preventScrollPenetrate.preventSelfScrollPenetrate = preventSelfScrollPenetrate;
    var PreventScrollPenetrateContainer = function(_super) {
      tslib_12.__extends(PreventScrollPenetrateContainer2, _super);
      function PreventScrollPenetrateContainer2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React2.createRef();
        _this.isInnerScroll = false;
        _this.startScreenX = -1;
        _this.startScreenY = -1;
        _this.handleTouchStart = function(event) {
          var container2 = _this.domRef.current;
          var path = event.composedPath();
          var touch = event.touches[0];
          _this.startScreenX = touch.screenX;
          _this.startScreenY = touch.screenY;
          for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var elem = path_1[_i];
            if (!container2.contains(elem)) {
              _this.isInnerScroll = false;
              return;
            }
            if (elem.scrollHeight > elem.clientHeight) {
              _this.isInnerScroll = true;
              preventSelfScrollPenetrate(elem);
              return;
            }
          }
          _this.isInnerScroll = false;
        };
        _this.handleTouchMove = function(event) {
          if (_this.isInnerScroll) {
            return;
          }
          var touch = event.touches[0];
          if (touch.touchType === "stylus" && calcDistance(_this.startScreenX, _this.startScreenY, touch.screenX, touch.screenY) < STYLUS_TOUCH_MOVE_CLICK_DISTANCE) {
            return;
          }
          event.cancelable && event.preventDefault();
        };
        return _this;
      }
      PreventScrollPenetrateContainer2.prototype.componentDidMount = function() {
        var container2 = this.domRef.current;
        container2.addEventListener("touchstart", this.handleTouchStart);
        container2.addEventListener("touchmove", this.handleTouchMove, { passive: false });
      };
      PreventScrollPenetrateContainer2.prototype.render = function() {
        return h("div", tslib_12.__assign({}, this.props, { ref: this.domRef }), this.props.children);
      };
      return PreventScrollPenetrateContainer2;
    }(React2.Component);
    preventScrollPenetrate.PreventScrollPenetrateContainer = PreventScrollPenetrateContainer;
    function calcDistance(x1, y1, x2, y2) {
      return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    }
    var globalScrollProperty = "";
    function toggleGlobalScrollEvents(disabled2) {
      if (disabled2 && !globalScrollProperty) {
        globalScrollProperty = document.documentElement.style.overflow || "initial";
        document.documentElement.style.overflow = "hidden";
      }
      if (!disabled2 && globalScrollProperty) {
        document.documentElement.style.overflow = globalScrollProperty;
        globalScrollProperty = "";
      }
    }
    preventScrollPenetrate.toggleGlobalScrollEvents = toggleGlobalScrollEvents;
    return preventScrollPenetrate;
  }
  var stylusAdapter = {};
  var hasRequiredStylusAdapter;
  function requireStylusAdapter() {
    if (hasRequiredStylusAdapter)
      return stylusAdapter;
    hasRequiredStylusAdapter = 1;
    Object.defineProperty(stylusAdapter, "__esModule", { value: true });
    stylusAdapter.WithStylusClick = stylusAdapter.StylusAdapter = void 0;
    var tslib_12 = tslib.exports;
    var react_12 = tslib_12.__importDefault(React__default.default);
    var docs_user_agent_1 = tslib_12.__importDefault(requireDist());
    var TouchType;
    (function(TouchType2) {
      TouchType2["direct"] = "direct";
      TouchType2["stylus"] = "stylus";
    })(TouchType || (TouchType = {}));
    var StylusAdapter = function() {
      function StylusAdapter2() {
      }
      StylusAdapter2.supportStylus = function(event, callback) {
        if (!this.isIPadStylusTouch(event)) {
          return;
        }
        if (event.nativeEvent.type === "touchstart") {
          this.startPos = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
          return;
        }
        if (event.nativeEvent.type === "touchend") {
          var endPos = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
          if (this.isEqualPos(this.startPos, endPos) && callback) {
            callback();
          }
          event.preventDefault();
        }
      };
      StylusAdapter2.startPos = [0, 0];
      StylusAdapter2.isIPadStylusTouch = function(event) {
        return docs_user_agent_1.default.isIPad && event.changedTouches[0] && event.changedTouches[0].touchType === TouchType.stylus;
      };
      StylusAdapter2.isEqualPos = function(pos1, pos2) {
        return Math.abs(pos1[0] - pos2[0]) < 10 && Math.abs(pos1[1] - pos2[1]) < 10;
      };
      return StylusAdapter2;
    }();
    stylusAdapter.StylusAdapter = StylusAdapter;
    var WithStylusClick = function(_a) {
      var children = _a.children, clickHandler = _a.clickHandler;
      return react_12.default.cloneElement(children, {
        onClick: clickHandler,
        onTouchStart: function(e) {
          return StylusAdapter.supportStylus(e, clickHandler);
        },
        onTouchEnd: function(e) {
          return StylusAdapter.supportStylus(e, clickHandler);
        }
      });
    };
    stylusAdapter.WithStylusClick = WithStylusClick;
    return stylusAdapter;
  }
  var locale = {};
  var _assignValue;
  var hasRequired_assignValue;
  function require_assignValue() {
    if (hasRequired_assignValue)
      return _assignValue;
    hasRequired_assignValue = 1;
    var baseAssignValue2 = _baseAssignValue, eq2 = eq_1;
    var objectProto2 = Object.prototype;
    var hasOwnProperty2 = objectProto2.hasOwnProperty;
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty2.call(object, key) && eq2(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue2(object, key, value);
      }
    }
    _assignValue = assignValue;
    return _assignValue;
  }
  var _copyObject;
  var hasRequired_copyObject;
  function require_copyObject() {
    if (hasRequired_copyObject)
      return _copyObject;
    hasRequired_copyObject = 1;
    var assignValue = require_assignValue(), baseAssignValue2 = _baseAssignValue;
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue2(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    _copyObject = copyObject;
    return _copyObject;
  }
  var _apply;
  var hasRequired_apply;
  function require_apply() {
    if (hasRequired_apply)
      return _apply;
    hasRequired_apply = 1;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    _apply = apply;
    return _apply;
  }
  var _overRest;
  var hasRequired_overRest;
  function require_overRest() {
    if (hasRequired_overRest)
      return _overRest;
    hasRequired_overRest = 1;
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    _overRest = overRest;
    return _overRest;
  }
  var constant_1;
  var hasRequiredConstant;
  function requireConstant() {
    if (hasRequiredConstant)
      return constant_1;
    hasRequiredConstant = 1;
    function constant(value) {
      return function() {
        return value;
      };
    }
    constant_1 = constant;
    return constant_1;
  }
  var _baseSetToString;
  var hasRequired_baseSetToString;
  function require_baseSetToString() {
    if (hasRequired_baseSetToString)
      return _baseSetToString;
    hasRequired_baseSetToString = 1;
    var constant = requireConstant(), defineProperty2 = _defineProperty, identity2 = identity_1;
    var baseSetToString = !defineProperty2 ? identity2 : function(func, string) {
      return defineProperty2(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    _baseSetToString = baseSetToString;
    return _baseSetToString;
  }
  var _shortOut;
  var hasRequired_shortOut;
  function require_shortOut() {
    if (hasRequired_shortOut)
      return _shortOut;
    hasRequired_shortOut = 1;
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    _shortOut = shortOut;
    return _shortOut;
  }
  var _setToString;
  var hasRequired_setToString;
  function require_setToString() {
    if (hasRequired_setToString)
      return _setToString;
    hasRequired_setToString = 1;
    var baseSetToString = require_baseSetToString(), shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    _setToString = setToString;
    return _setToString;
  }
  var _baseRest;
  var hasRequired_baseRest;
  function require_baseRest() {
    if (hasRequired_baseRest)
      return _baseRest;
    hasRequired_baseRest = 1;
    var identity2 = identity_1, overRest = require_overRest(), setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity2), func + "");
    }
    _baseRest = baseRest;
    return _baseRest;
  }
  var _isIterateeCall;
  var hasRequired_isIterateeCall;
  function require_isIterateeCall() {
    if (hasRequired_isIterateeCall)
      return _isIterateeCall;
    hasRequired_isIterateeCall = 1;
    var eq2 = eq_1, isArrayLike2 = isArrayLike_1, isIndex2 = _isIndex, isObject2 = requireIsObject();
    function isIterateeCall(value, index, object) {
      if (!isObject2(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike2(object) && isIndex2(index, object.length) : type == "string" && index in object) {
        return eq2(object[index], value);
      }
      return false;
    }
    _isIterateeCall = isIterateeCall;
    return _isIterateeCall;
  }
  var _createAssigner;
  var hasRequired_createAssigner;
  function require_createAssigner() {
    if (hasRequired_createAssigner)
      return _createAssigner;
    hasRequired_createAssigner = 1;
    var baseRest = require_baseRest(), isIterateeCall = require_isIterateeCall();
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    _createAssigner = createAssigner;
    return _createAssigner;
  }
  var assignWith_1;
  var hasRequiredAssignWith;
  function requireAssignWith() {
    if (hasRequiredAssignWith)
      return assignWith_1;
    hasRequiredAssignWith = 1;
    var copyObject = require_copyObject(), createAssigner = require_createAssigner(), keys2 = keys_1;
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys2(source), object, customizer);
    });
    assignWith_1 = assignWith;
    return assignWith_1;
  }
  var _baseSet;
  var hasRequired_baseSet;
  function require_baseSet() {
    if (hasRequired_baseSet)
      return _baseSet;
    hasRequired_baseSet = 1;
    var assignValue = require_assignValue(), castPath2 = _castPath, isIndex2 = _isIndex, isObject2 = requireIsObject(), toKey2 = _toKey;
    function baseSet(object, path, value, customizer) {
      if (!isObject2(object)) {
        return object;
      }
      path = castPath2(path, object);
      var index = -1, length = path.length, lastIndex = length - 1, nested = object;
      while (nested != null && ++index < length) {
        var key = toKey2(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") {
          return object;
        }
        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : void 0;
          if (newValue === void 0) {
            newValue = isObject2(objValue) ? objValue : isIndex2(path[index + 1]) ? [] : {};
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }
    _baseSet = baseSet;
    return _baseSet;
  }
  var set_1;
  var hasRequiredSet;
  function requireSet() {
    if (hasRequiredSet)
      return set_1;
    hasRequiredSet = 1;
    var baseSet = require_baseSet();
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }
    set_1 = set;
    return set_1;
  }
  var classCallCheck = { exports: {} };
  var hasRequiredClassCallCheck;
  function requireClassCallCheck() {
    if (hasRequiredClassCallCheck)
      return classCallCheck.exports;
    hasRequiredClassCallCheck = 1;
    (function(module2) {
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      module2.exports = _classCallCheck, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    })(classCallCheck);
    return classCallCheck.exports;
  }
  var createClass = { exports: {} };
  var toPropertyKey = { exports: {} };
  var _typeof = { exports: {} };
  var hasRequired_typeof;
  function require_typeof() {
    if (hasRequired_typeof)
      return _typeof.exports;
    hasRequired_typeof = 1;
    (function(module2) {
      function _typeof2(obj) {
        "@babel/helpers - typeof";
        return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
          return typeof obj2;
        } : function(obj2) {
          return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(obj);
      }
      module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    })(_typeof);
    return _typeof.exports;
  }
  var toPrimitive = { exports: {} };
  var hasRequiredToPrimitive;
  function requireToPrimitive() {
    if (hasRequiredToPrimitive)
      return toPrimitive.exports;
    hasRequiredToPrimitive = 1;
    (function(module2) {
      var _typeof2 = require_typeof()["default"];
      function _toPrimitive(input, hint) {
        if (_typeof2(input) !== "object" || input === null)
          return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== void 0) {
          var res = prim.call(input, hint || "default");
          if (_typeof2(res) !== "object")
            return res;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
      }
      module2.exports = _toPrimitive, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    })(toPrimitive);
    return toPrimitive.exports;
  }
  var hasRequiredToPropertyKey;
  function requireToPropertyKey() {
    if (hasRequiredToPropertyKey)
      return toPropertyKey.exports;
    hasRequiredToPropertyKey = 1;
    (function(module2) {
      var _typeof2 = require_typeof()["default"];
      var toPrimitive2 = requireToPrimitive();
      function _toPropertyKey(arg) {
        var key = toPrimitive2(arg, "string");
        return _typeof2(key) === "symbol" ? key : String(key);
      }
      module2.exports = _toPropertyKey, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    })(toPropertyKey);
    return toPropertyKey.exports;
  }
  var hasRequiredCreateClass;
  function requireCreateClass() {
    if (hasRequiredCreateClass)
      return createClass.exports;
    hasRequiredCreateClass = 1;
    (function(module2) {
      var toPropertyKey2 = requireToPropertyKey();
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor)
            descriptor.writable = true;
          Object.defineProperty(target, toPropertyKey2(descriptor.key), descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps)
          _defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
          _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
          writable: false
        });
        return Constructor;
      }
      module2.exports = _createClass, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    })(createClass);
    return createClass.exports;
  }
  var i18nextBrowserLanguageDetector;
  var hasRequiredI18nextBrowserLanguageDetector;
  function requireI18nextBrowserLanguageDetector() {
    if (hasRequiredI18nextBrowserLanguageDetector)
      return i18nextBrowserLanguageDetector;
    hasRequiredI18nextBrowserLanguageDetector = 1;
    var _classCallCheck = requireClassCallCheck();
    var _createClass = requireCreateClass();
    function _interopDefaultLegacy2(e) {
      return e && typeof e === "object" && "default" in e ? e : { "default": e };
    }
    var _classCallCheck__default = /* @__PURE__ */ _interopDefaultLegacy2(_classCallCheck);
    var _createClass__default = /* @__PURE__ */ _interopDefaultLegacy2(_createClass);
    var arr = [];
    var each = arr.forEach;
    var slice = arr.slice;
    function defaults(obj) {
      each.call(slice.call(arguments, 1), function(source) {
        if (source) {
          for (var prop in source) {
            if (obj[prop] === void 0)
              obj[prop] = source[prop];
          }
        }
      });
      return obj;
    }
    var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    var serializeCookie = function serializeCookie2(name2, val, options) {
      var opt = options || {};
      opt.path = opt.path || "/";
      var value = encodeURIComponent(val);
      var str = "".concat(name2, "=").concat(value);
      if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge))
          throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
      }
      if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) {
          throw new TypeError("option domain is invalid");
        }
        str += "; Domain=".concat(opt.domain);
      }
      if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) {
          throw new TypeError("option path is invalid");
        }
        str += "; Path=".concat(opt.path);
      }
      if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") {
          throw new TypeError("option expires is invalid");
        }
        str += "; Expires=".concat(opt.expires.toUTCString());
      }
      if (opt.httpOnly)
        str += "; HttpOnly";
      if (opt.secure)
        str += "; Secure";
      if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch (sameSite) {
          case true:
            str += "; SameSite=Strict";
            break;
          case "lax":
            str += "; SameSite=Lax";
            break;
          case "strict":
            str += "; SameSite=Strict";
            break;
          case "none":
            str += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return str;
    };
    var cookie = {
      create: function create(name2, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
          path: "/",
          sameSite: "strict"
        };
        if (minutes) {
          cookieOptions.expires = new Date();
          cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1e3);
        }
        if (domain)
          cookieOptions.domain = domain;
        document.cookie = serializeCookie(name2, encodeURIComponent(value), cookieOptions);
      },
      read: function read(name2) {
        var nameEQ = "".concat(name2, "=");
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === " ") {
            c = c.substring(1, c.length);
          }
          if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
        }
        return null;
      },
      remove: function remove(name2) {
        this.create(name2, "", -1);
      }
    };
    var cookie$1 = {
      name: "cookie",
      lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
          var c = cookie.read(options.lookupCookie);
          if (c)
            found = c;
        }
        return found;
      },
      cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") {
          cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
        }
      }
    };
    var querystring = {
      name: "querystring",
      lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
          var search = window.location.search;
          if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) {
            search = window.location.hash.substring(window.location.hash.indexOf("?"));
          }
          var query = search.substring(1);
          var params = query.split("&");
          for (var i = 0; i < params.length; i++) {
            var pos = params[i].indexOf("=");
            if (pos > 0) {
              var key = params[i].substring(0, pos);
              if (key === options.lookupQuerystring) {
                found = params[i].substring(pos + 1);
              }
            }
          }
        }
        return found;
      }
    };
    var hasLocalStorageSupport = null;
    var localStorageAvailable = function localStorageAvailable2() {
      if (hasLocalStorageSupport !== null)
        return hasLocalStorageSupport;
      try {
        hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
      } catch (e) {
        hasLocalStorageSupport = false;
      }
      return hasLocalStorageSupport;
    };
    var localStorage = {
      name: "localStorage",
      lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && localStorageAvailable()) {
          var lng = window.localStorage.getItem(options.lookupLocalStorage);
          if (lng)
            found = lng;
        }
        return found;
      },
      cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && localStorageAvailable()) {
          window.localStorage.setItem(options.lookupLocalStorage, lng);
        }
      }
    };
    var hasSessionStorageSupport = null;
    var sessionStorageAvailable = function sessionStorageAvailable2() {
      if (hasSessionStorageSupport !== null)
        return hasSessionStorageSupport;
      try {
        hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
      } catch (e) {
        hasSessionStorageSupport = false;
      }
      return hasSessionStorageSupport;
    };
    var sessionStorage = {
      name: "sessionStorage",
      lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && sessionStorageAvailable()) {
          var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
          if (lng)
            found = lng;
        }
        return found;
      },
      cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && sessionStorageAvailable()) {
          window.sessionStorage.setItem(options.lookupSessionStorage, lng);
        }
      }
    };
    var navigator$1 = {
      name: "navigator",
      lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
          if (navigator.languages) {
            for (var i = 0; i < navigator.languages.length; i++) {
              found.push(navigator.languages[i]);
            }
          }
          if (navigator.userLanguage) {
            found.push(navigator.userLanguage);
          }
          if (navigator.language) {
            found.push(navigator.language);
          }
        }
        return found.length > 0 ? found : void 0;
      }
    };
    var htmlTag = {
      name: "htmlTag",
      lookup: function lookup(options) {
        var found;
        var htmlTag2 = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag2 && typeof htmlTag2.getAttribute === "function") {
          found = htmlTag2.getAttribute("lang");
        }
        return found;
      }
    };
    var path = {
      name: "path",
      lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
          var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
          if (language instanceof Array) {
            if (typeof options.lookupFromPathIndex === "number") {
              if (typeof language[options.lookupFromPathIndex] !== "string") {
                return void 0;
              }
              found = language[options.lookupFromPathIndex].replace("/", "");
            } else {
              found = language[0].replace("/", "");
            }
          }
        }
        return found;
      }
    };
    var subdomain = {
      name: "subdomain",
      lookup: function lookup(options) {
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        if (!language)
          return void 0;
        return language[lookupFromSubdomainIndex];
      }
    };
    function getDefaults() {
      return {
        order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        caches: ["localStorage"],
        excludeCacheFor: ["cimode"]
      };
    }
    var Browser = /* @__PURE__ */ function() {
      function Browser2(services) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck__default["default"](this, Browser2);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
      }
      _createClass__default["default"](Browser2, [{
        key: "init",
        value: function init(services) {
          var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var i18nOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          this.services = services;
          this.options = defaults(options, this.options || {}, getDefaults());
          if (this.options.lookupFromUrlIndex)
            this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
          this.i18nOptions = i18nOptions;
          this.addDetector(cookie$1);
          this.addDetector(querystring);
          this.addDetector(localStorage);
          this.addDetector(sessionStorage);
          this.addDetector(navigator$1);
          this.addDetector(htmlTag);
          this.addDetector(path);
          this.addDetector(subdomain);
        }
      }, {
        key: "addDetector",
        value: function addDetector(detector) {
          this.detectors[detector.name] = detector;
        }
      }, {
        key: "detect",
        value: function detect(detectionOrder) {
          var _this = this;
          if (!detectionOrder)
            detectionOrder = this.options.order;
          var detected = [];
          detectionOrder.forEach(function(detectorName) {
            if (_this.detectors[detectorName]) {
              var lookup = _this.detectors[detectorName].lookup(_this.options);
              if (lookup && typeof lookup === "string")
                lookup = [lookup];
              if (lookup)
                detected = detected.concat(lookup);
            }
          });
          if (this.services.languageUtils.getBestMatchFromCodes)
            return detected;
          return detected.length > 0 ? detected[0] : null;
        }
      }, {
        key: "cacheUserLanguage",
        value: function cacheUserLanguage(lng, caches) {
          var _this2 = this;
          if (!caches)
            caches = this.options.caches;
          if (!caches)
            return;
          if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1)
            return;
          caches.forEach(function(cacheName) {
            if (_this2.detectors[cacheName])
              _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
          });
        }
      }]);
      return Browser2;
    }();
    Browser.type = "languageDetector";
    i18nextBrowserLanguageDetector = Browser;
    return i18nextBrowserLanguageDetector;
  }
  var hasRequiredLocale;
  function requireLocale() {
    if (hasRequiredLocale)
      return locale;
    hasRequiredLocale = 1;
    Object.defineProperty(locale, "__esModule", { value: true });
    locale.i18n = void 0;
    var tslib_12 = tslib.exports;
    var assignWith_12 = tslib_12.__importDefault(requireAssignWith());
    var set_12 = tslib_12.__importDefault(requireSet());
    var i18next_1 = tslib_12.__importDefault(i18next__default.default);
    var i18next_browser_languagedetector_1 = tslib_12.__importDefault(requireI18nextBrowserLanguageDetector());
    var languages = ["en", "zh-CN"];
    var detector = new i18next_browser_languagedetector_1.default();
    var isServerSide = typeof window === "undefined";
    if (!isServerSide) {
      detector.addDetector({
        name: "userAgent",
        lookup: function() {
          var match = navigator.userAgent.match(/language\/([a-zA-Z'-_]+)/i);
          if (match) {
            return match[1].replace("_", "-");
          }
          return void 0;
        }
      });
    }
    var translationMap = {
      avatar: ["Avatar", "\u5934\u50CF"],
      ok: ["OK", "\u786E\u5B9A"],
      cancel: ["Cancel", "\u53D6\u6D88"],
      select: ["Select", "\u8BF7\u9009\u62E9"],
      search: ["Search", "\u641C\u7D22\u9009\u9879"],
      hour: ["H", "\u65F6"],
      minute: ["M", "\u5206"],
      second: ["S", "\u79D2"],
      now: ["Now", "\u6B64\u523B"],
      inputHour: ["Input Hour", "\u8F93\u5165\u5C0F\u65F6"],
      inputMinute: ["Input Minute", "\u8F93\u5165\u5206"],
      inputSecond: ["Input Second", "\u8F93\u5165\u79D2"],
      close: ["Close", "\u5173\u95ED"],
      loadingFailed: ["Loading Failed", "\u52A0\u8F7D\u5931\u8D25"],
      noOptions: ["No Options", "\u6682\u65E0\u9009\u9879"],
      copySuccessed: ["Copy Succeeded", "\u590D\u5236\u6210\u529F"],
      copyFailed: ["Copy Failed", "\u590D\u5236\u5931\u8D25"],
      eyedropper: ["Eyedropper", "\u53D6\u8272\u5668"],
      eyedropperFailedSafari: [
        "Eyedropper is not supported by this browser. Please open it in Chrome",
        "\u53D6\u8272\u5668\u6682\u4E0D\u652F\u6301\u672C\u6D4F\u89C8\u5668, \u8BF7\u5728 Chrome \u4E2D\u4F7F\u7528"
      ],
      eyedropperFailedEdge: [
        "Eyedropper is not supported by this browser. Please open it in Chrome",
        "\u53D6\u8272\u5668\u6682\u4E0D\u652F\u6301\u672C\u6D4F\u89C8\u5668, \u8BF7\u5728 Chrome \u4E2D\u4F7F\u7528"
      ]
    };
    var resources = {};
    languages.forEach(function(lang, index) {
      var translation = assignWith_12.default({}, translationMap, function(objectValue, sourceValue) {
        return sourceValue[index];
      });
      set_12.default(resources, [lang, "translation"], translation);
    });
    var i18nInstance = i18next_1.default.createInstance();
    i18nInstance.use(detector).init({
      resources,
      fallbackLng: {
        "zh-TW": ["zh-HK", "zh-CN"],
        default: ["zh-CN"]
      },
      detection: {
        order: ["querystring", "userAgent", "cookie"],
        lookupCookie: "language",
        caches: []
      }
    });
    function i18n(key) {
      return i18nInstance.t(key);
    }
    locale.i18n = i18n;
    return locale;
  }
  var hasRequiredModal;
  function requireModal() {
    if (hasRequiredModal)
      return Modal;
    hasRequiredModal = 1;
    (function(exports2) {
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.MODAL_TRANSITION_OUT_DURATION = void 0;
      var tslib_12 = tslib.exports;
      var h = requireCreateElement().h;
      var React2 = tslib_12.__importStar(React__default.default);
      var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
      var helper_1 = requireHelper();
      var index_1 = tslib_12.__importDefault(Button$1);
      var Dragger_1 = tslib_12.__importDefault(requireDragger());
      var keepDom_1 = requireKeepDom();
      var context_1 = requireContext();
      var theme_1 = requireTheme();
      var preventScrollPenetrate_1 = requirePreventScrollPenetrate();
      var stylusAdapter_1 = requireStylusAdapter();
      var focus_1 = requireFocus();
      var locale_1 = requireLocale();
      exports2.MODAL_TRANSITION_OUT_DURATION = 240;
      var MODAL_TRANSITION_IN_DURATION = 300;
      var Modal2 = function(_super) {
        tslib_12.__extends(Modal3, _super);
        function Modal3() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.draggerRef = React2.createRef();
          _this.footerRef = React2.createRef();
          _this.isComposing = false;
          _this.handleClose = function(e) {
            var _a = _this.props, onClose = _a.onClose, onCancel = _a.onCancel, visible = _a.visible;
            if (!visible) {
              return;
            }
            var handler = onClose || onCancel;
            handler(e);
          };
          _this.handleMaskClick = function(e) {
            var _a = _this.props, maskClosable = _a.maskClosable, onClickMask = _a.onClickMask;
            if (maskClosable === true) {
              _this.handleClose(e);
            }
            onClickMask(e);
          };
          _this.handleDraggerClick = function(e) {
            e.stopPropagation();
          };
          _this.handleCompositionStart = function() {
            _this.isComposing = true;
          };
          _this.handleCompositionEnd = function() {
            _this.isComposing = false;
          };
          _this.handleKeyDown = function(e) {
            var _a;
            var _b = _this.props, visible = _b.visible, footer = _b.footer, okDisabled = _b.okDisabled;
            if (!visible || _this.isComposing) {
              return;
            }
            if (e.key === "Tab") {
              _this.traverseFocus(e);
              return;
            }
            if (footer || footer === null) {
              return;
            }
            if (!okDisabled && e.key === "Enter" && !((_a = _this.footerRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) {
              _this.handleClickOk();
            } else if (e.key === "Escape") {
              _this.handleClickCancel();
            }
          };
          _this.handleClickOk = function(e) {
            var _a = _this.props, visible = _a.visible, onOk = _a.onOk, okDisabled = _a.okDisabled;
            if (!visible || okDisabled) {
              return;
            }
            onOk(e);
          };
          _this.handleClickCancel = function(e) {
            var _a = _this.props, visible = _a.visible, onCancel = _a.onCancel;
            if (!visible) {
              return;
            }
            onCancel(e);
          };
          _this.handleClickAction = function(e) {
            var _a = _this.props, visible = _a.visible, onClickAction = _a.onClickAction;
            if (!visible) {
              return;
            }
            onClickAction(e);
          };
          _this.themedRender = function(classNames2) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style2 = _c.style, title2 = _c.title, visible = _c.visible, maskStyle = _c.maskStyle, maskClassName = _c.maskClassName, mask = _c.mask, draggable = _c.draggable, onDragEnd = _c.onDragEnd, destroyOnClose = _c.destroyOnClose, zIndex = _c.zIndex, containerDom = _c.containerDom, header = _c.header, testId = _c.testId;
            var cls = classNames2(prefixCls, className, prefixCls + "-" + (visible ? "visible" : "hidden"), (_a = {}, _a[prefixCls + "-basic"] = _this.isBasic, _a));
            var maskCls = classNames2(prefixCls + "-mask", maskClassName, prefixCls + "-mask-" + (visible ? "visible" : "hidden"), (_b = {}, _b[prefixCls + "-mask-display"] = mask, _b[prefixCls + "-mask-in-container"] = containerDom !== document.body, _b));
            if (!containerDom || destroyOnClose && !keepDom_1.decideKeepDom.call(_this, exports2.MODAL_TRANSITION_OUT_DURATION, visible)) {
              return null;
            }
            return react_dom_1.default.createPortal(h(
              context_1.ContainerContext.Provider,
              { value: _this.draggerDom },
              h(
                preventScrollPenetrate_1.PreventScrollPenetrateContainer,
                { className: maskCls, style: tslib_12.__assign({ zIndex }, maskStyle), onClick: _this.handleMaskClick, "aria-hidden": !visible },
                h(
                  Dragger_1.default,
                  { className: cls, style: style2, draggable, onDragEnd, onClick: _this.handleDraggerClick, ref: _this.draggerRef, onKeyDown: _this.handleKeyDown, onCompositionStart: _this.handleCompositionStart, onCompositionEnd: _this.handleCompositionEnd, "data-testid": testId },
                  _this.renderClose(classNames2),
                  header ? h("div", { className: classNames2(prefixCls + "-header") }, header) : null,
                  title2 !== null ? h("div", { className: classNames2(prefixCls + "-title") }, title2) : null,
                  _this.renderContent(classNames2),
                  _this.renderFooter(classNames2)
                )
              )
            ), containerDom);
          };
          return _this;
        }
        Object.defineProperty(Modal3.prototype, "draggerDom", {
          get: function() {
            var _a;
            return (_a = this.draggerRef.current) === null || _a === void 0 ? void 0 : _a.ref;
          },
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(Modal3.prototype, "isBasic", {
          get: function() {
            return this.props.type === "basic";
          },
          enumerable: false,
          configurable: true
        });
        Modal3.prototype.isFocusInside = function() {
          var _a;
          return (_a = this.draggerDom) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
        };
        Modal3.prototype.focusSelf = function() {
          var _this = this;
          if (this.props.visible && !this.isFocusInside()) {
            focus_1.saveFocus();
            setTimeout(function() {
              var _a;
              !_this.isFocusInside() && ((_a = _this.draggerDom) === null || _a === void 0 ? void 0 : _a.focus());
            }, MODAL_TRANSITION_IN_DURATION);
          }
        };
        Modal3.prototype.restorePreviousFocus = function() {
          if (!this.props.visible) {
            focus_1.restoreFocus();
          }
        };
        Modal3.prototype.traverseFocus = function(e) {
          var container2 = this.draggerDom;
          if (!container2) {
            return;
          }
          focus_1.traverseFocusIn(container2, e);
        };
        Modal3.prototype.componentDidMount = function() {
          this.forceUpdate();
          this.focusSelf();
          var _a = this.props, visible = _a.visible, mask = _a.mask;
          preventScrollPenetrate_1.toggleGlobalScrollEvents(Boolean(visible && mask));
        };
        Modal3.prototype.componentDidUpdate = function(prevProps) {
          if (!prevProps.visible) {
            this.focusSelf();
          } else {
            this.restorePreviousFocus();
          }
          var _a = this.props, visible = _a.visible, mask = _a.mask;
          preventScrollPenetrate_1.toggleGlobalScrollEvents(Boolean(visible && mask));
        };
        Modal3.prototype.componentWillUnmount = function() {
          preventScrollPenetrate_1.toggleGlobalScrollEvents(false);
        };
        Modal3.prototype.renderAction = function(classNames2) {
          var _a = this.props, prefixCls = _a.prefixCls, action = _a.action;
          if (!action) {
            return null;
          }
          var actionMainNode;
          var icon;
          if (action !== null && typeof action === "object") {
            if (React2.isValidElement(action)) {
              actionMainNode = action;
            } else {
              if ("text" in action) {
                actionMainNode = action.text;
              }
              if ("icon" in action) {
                icon = action.icon;
              }
            }
          } else {
            actionMainNode = action;
          }
          return h(stylusAdapter_1.WithStylusClick, { clickHandler: this.handleClickAction }, this.isBasic ? h(index_1.default, { icon }, actionMainNode) : h(
            "button",
            { className: classNames2(prefixCls + "-footer-action") },
            icon ? typeof icon === "string" ? h("div", { className: classNames2(prefixCls + "-footer-action-icon"), style: { backgroundImage: 'url("' + icon + '")' } }) : icon : null,
            actionMainNode ? typeof actionMainNode === "string" ? h("div", { className: classNames2(prefixCls + "-footer-action-text") }, actionMainNode) : actionMainNode : null
          ));
        };
        Modal3.prototype.renderFooter = function(classNames2) {
          var _a;
          var _b = this.props, prefixCls = _b.prefixCls, footer = _b.footer, okText = _b.okText, cancelText = _b.cancelText, okDisabled = _b.okDisabled, okButtonType = _b.okButtonType;
          if (footer === null) {
            return null;
          } else if (footer) {
            return footer;
          }
          var cancelElement = cancelText ? h(
            stylusAdapter_1.WithStylusClick,
            { clickHandler: this.handleClickCancel },
            h(index_1.default, null, cancelText)
          ) : null;
          var okElement = h(
            stylusAdapter_1.WithStylusClick,
            { clickHandler: this.handleClickOk },
            h(index_1.default, { className: classNames2(prefixCls + "-footer-ok"), type: okButtonType, disabled: okDisabled }, okText)
          );
          var actionElement = this.renderAction(classNames2);
          var footerCls = classNames2(prefixCls + "-footer", (_a = {}, _a[prefixCls + "-footer-column"] = actionElement && this.isBasic, _a));
          return h(
            "div",
            { className: footerCls, ref: this.footerRef },
            cancelElement,
            actionElement,
            okElement
          );
        };
        Modal3.prototype.renderContent = function(classNames2) {
          var _a;
          var _b = this.props, prefixCls = _b.prefixCls, title2 = _b.title, content = _b.content, children = _b.children;
          var contentCls = classNames2(prefixCls + "-content", (_a = {}, _a[prefixCls + "-content-empty-title"] = title2 === "", _a));
          var passedContent = content || children;
          var renderedContent = passedContent;
          if (helper_1.isIE() && typeof passedContent === "string") {
            renderedContent = h("span", { style: { maxWidth: "100%" } }, passedContent);
          }
          return helper_1.isIE() ? h(
            "div",
            { style: { display: "flex", flexDirection: "column" } },
            h("div", { className: contentCls }, renderedContent)
          ) : h("div", { className: contentCls }, renderedContent);
        };
        Modal3.prototype.renderClose = function(classNames2) {
          var _a = this.props, prefixCls = _a.prefixCls, closable = _a.closable, close = _a.close;
          if (!closable) {
            return null;
          }
          return h(stylusAdapter_1.WithStylusClick, { clickHandler: this.handleClose }, close ? h("div", { className: classNames2(prefixCls + "-close-container") }, close) : h("div", { className: classNames2(prefixCls + "-close") }));
        };
        Modal3.prototype.render = function() {
          return theme_1.consumeTheme(this.themedRender);
        };
        return Modal3;
      }(React2.Component);
      exports2.default = Modal2;
      Modal2.defaultProps = {
        prefixCls: "dui-modal",
        title: "",
        content: "",
        footer: "",
        onCancel: helper_1.emptyFn,
        onOk: helper_1.emptyFn,
        cancelText: locale_1.i18n("cancel"),
        okText: locale_1.i18n("ok"),
        mask: true,
        maskClosable: false,
        closable: true,
        onDragEnd: helper_1.emptyFn,
        destroyOnClose: false,
        onClickMask: helper_1.emptyFn,
        action: "",
        onClickAction: helper_1.emptyFn,
        containerDom: typeof document !== "undefined" ? document.body : void 0,
        okDisabled: false,
        type: "editable",
        okButtonType: "primary"
      };
    })(Modal);
    return Modal;
  }
  var confirm = {};
  var show = {};
  var hasRequiredShow;
  function requireShow() {
    if (hasRequiredShow)
      return show;
    hasRequiredShow = 1;
    Object.defineProperty(show, "__esModule", { value: true });
    show.showWithTransition = void 0;
    var tslib_12 = tslib.exports;
    var h = requireCreateElement().h;
    var react_dom_1 = tslib_12.__importDefault(require$$3__default.default);
    var helper_1 = requireHelper();
    function showWithTransition(_a) {
      var Component = _a.Component, transitionDuration = _a.transitionDuration, autoClose = _a.autoClose, props = _a.props, forcedProps = _a.forcedProps, _b = _a.injectClosePropNames, injectClosePropNames = _b === void 0 ? [] : _b, _c = _a.deepInjectClose, deepInjectClose = _c === void 0 ? [] : _c, contexts = _a.contexts;
      var div = document.createElement("div");
      document.body.appendChild(div);
      var timer;
      var closed = false;
      injectClosePropNames.forEach(function(key) {
        overrideSingle(props, key);
      });
      deepInjectClose.forEach(function(_a2) {
        var reference = _a2[0], key = _a2[1];
        if (Array.isArray(reference)) {
          reference.forEach(function(obj) {
            return overrideSingle(obj, key);
          });
          return;
        }
        overrideSingle(reference, key);
      });
      var currentProps = tslib_12.__assign(tslib_12.__assign(tslib_12.__assign({}, props), forcedProps), { visible: true });
      function overrideSingle(obj, key) {
        var originalValue = obj[key] || helper_1.emptyFn;
        obj[key] = helper_1.inject(originalValue, close);
      }
      function update(newProps) {
        if (closed) {
          return;
        }
        currentProps = tslib_12.__assign(tslib_12.__assign(tslib_12.__assign(tslib_12.__assign({}, currentProps), newProps), forcedProps), { visible: true });
        render(currentProps);
      }
      function close() {
        if (closed) {
          return;
        }
        closed = true;
        clearTimeout(timer);
        currentProps = tslib_12.__assign(tslib_12.__assign({}, currentProps), { visible: false });
        render(currentProps);
        setTimeout(function() {
          react_dom_1.default.unmountComponentAtNode(div);
          div.remove();
        }, transitionDuration + 20);
      }
      function render(props2) {
        var element = (contexts === null || contexts === void 0 ? void 0 : contexts.length) ? composeContexts(contexts, h(Component, tslib_12.__assign({}, props2))) : h(Component, tslib_12.__assign({}, props2));
        react_dom_1.default.render(element, div);
      }
      render(currentProps);
      if (autoClose) {
        timer = setTimeout(close, props.duration || 2e3);
      }
      return { update, close };
    }
    show.showWithTransition = showWithTransition;
    function composeContexts(contexts, children) {
      return contexts.reduce(function(child, _a) {
        var Provider = _a.provider, value = _a.value;
        return h(Provider, { value }, child);
      }, children);
    }
    return show;
  }
  var hasRequiredConfirm;
  function requireConfirm() {
    if (hasRequiredConfirm)
      return confirm;
    hasRequiredConfirm = 1;
    Object.defineProperty(confirm, "__esModule", { value: true });
    var tslib_12 = tslib.exports;
    var Modal_12 = tslib_12.__importStar(requireModal());
    var show_1 = requireShow();
    var helper_1 = requireHelper();
    confirm.default = helper_1.wrapWithConfigDefaults(function(config) {
      config.onClose = config.onClose || config.onCancel;
      return show_1.showWithTransition({
        Component: Modal_12.default,
        transitionDuration: Modal_12.MODAL_TRANSITION_OUT_DURATION,
        autoClose: false,
        props: config,
        forcedProps: { destroyOnClose: true },
        injectClosePropNames: ["onOk", "onCancel", "onClickAction", "onClose"],
        contexts: config.contexts
      });
    });
    return confirm;
  }
  Object.defineProperty(Modal$1, "__esModule", { value: true });
  Modal$1.Modal = void 0;
  var tslib_1 = tslib.exports;
  var Modal_1 = tslib_1.__importDefault(requireModal());
  Modal$1.Modal = Modal_1.default;
  var confirm_1 = tslib_1.__importDefault(requireConfirm());
  requireStyle().injectStyle("components/Modal/style/index.css", `@-webkit-keyframes dui-modal-fade-in{0%{opacity:0}to{opacity:1}}@keyframes dui-modal-fade-in{0%{opacity:0}to{opacity:1}}@-webkit-keyframes dui-modal-pop-up{0%{opacity:0;-webkit-transform:scale3d(.9,.9,1);transform:scale3d(.9,.9,1)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes dui-modal-pop-up{0%{opacity:0;-webkit-transform:scale3d(.9,.9,1);transform:scale3d(.9,.9,1)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}[data-dui-0-122-1~="dui-modal"]{position:relative;width:400px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:24px;border-radius:8px;pointer-events:auto;-webkit-animation:dui-modal-pop-up .3s cubic-bezier(.4,0,.2,1);animation:dui-modal-pop-up .3s cubic-bezier(.4,0,.2,1);-webkit-tap-highlight-color:transparent;-webkit-box-shadow:0 6px 32px 2px rgba(68,73,77,.16),0 0 0 1px rgba(0,0,0,.04),0 4px 6px 2px rgba(0,0,0,.04);box-shadow:0 6px 32px 2px rgba(68,73,77,.16),0 0 0 1px rgba(0,0,0,.04),0 4px 6px 2px rgba(0,0,0,.04);background-color:var(--bg-lv4-default,#fff)}[data-dui-0-122-1~="dui-modal-hidden"],[data-dui-0-122-1~="dui-modal-visible"]{-webkit-transition-timing-function:cubic-bezier(.4,0,.2,1);transition-timing-function:cubic-bezier(.4,0,.2,1);-webkit-transition-property:opacity,visibility,-webkit-transform;transition-property:opacity,visibility,-webkit-transform;transition-property:opacity,transform,visibility;transition-property:opacity,transform,visibility,-webkit-transform}[data-dui-0-122-1~="dui-modal-visible"]{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transition-duration:.3s;transition-duration:.3s}[data-dui-0-122-1~="dui-modal-hidden"]{opacity:0;-webkit-transform:scale3d(.9,.9,1);transform:scale3d(.9,.9,1);-webkit-transition-duration:.24s;transition-duration:.24s}[data-dui-0-122-1~="dui-modal-mask"]{position:fixed;z-index:9998;top:0;left:0;right:0;bottom:0;opacity:1;pointer-events:none;-webkit-animation:dui-modal-fade-in .3s cubic-bezier(.4,0,.2,1);animation:dui-modal-fade-in .3s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-modal-mask-in-container"]{position:absolute}[data-dui-0-122-1~="dui-modal-mask-display"]{pointer-events:auto;background-color:hsla(0,0%,100%,.65)}[data-dui-0-122-1~="dui-modal-mask-visible"]{opacity:1;visibility:visible;-webkit-transition:all .3s cubic-bezier(.4,0,.2,1);transition:all .3s cubic-bezier(.4,0,.2,1)}[data-dui-0-122-1~="dui-modal-mask-hidden"]{opacity:0;visibility:hidden;-webkit-transition:all .24s cubic-bezier(.4,0,.2,1);transition:all .24s cubic-bezier(.4,0,.2,1)}[data-dui-0-122-1~="dui-modal-close"]{background-size:contain;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath fill='%23464d5a' d='M17 7.714L12.714 12 17 16.286l-.714.714L12 12.714 7.714 17 7 16.286 11.286 12 7 7.714 7.714 7 12 11.286 16.286 7z'/%3E%3C/svg%3E");background-position:50%;background-repeat:no-repeat;border-radius:2px;cursor:pointer}[data-dui-0-122-1~="dui-modal-close"]:hover{background-color:rgba(0,0,0,.04)}[data-dui-0-122-1~="dui-modal-close"]:active{background-color:rgba(0,0,0,.08)}[data-dui-0-122-1~="dui-modal-close"],[data-dui-0-122-1~="dui-modal-close-container"]{position:absolute;z-index:1;width:24px;height:24px;top:25px;right:24px}[data-dui-0-122-1~="dui-modal-header"]{margin-bottom:16px}[data-dui-0-122-1~="dui-modal-title"]{font-weight:500;font-size:18px;margin-bottom:20px;line-height:26px}[data-dui-0-122-1~="dui-modal-content"],[data-dui-0-122-1~="dui-modal-title"]{color:var(--text-ultrastrong,rgba(0,0,0,.88))}[data-dui-0-122-1~="dui-modal-content"]{font-size:14px;height:-webkit-max-content;height:-moz-max-content;height:max-content;min-height:88px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;word-break:break-word}[data-dui-0-122-1~="dui-modal-content-empty-title"]{margin-top:28px;min-height:60px}[data-dui-0-122-1~="dui-modal-footer"]{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;margin-top:24px;position:relative}[data-dui-0-122-1~="dui-modal-footer"],[data-dui-0-122-1~="dui-modal-footer-action"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}[data-dui-0-122-1~="dui-modal-footer-action"]{border:none;margin:0;padding:0;background:transparent;-webkit-tap-highlight-color:transparent;position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;font-size:12px;color:var(--text-strong,rgba(0,0,0,.64));-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row nowrap;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-modal-footer-action-icon"]{display:inline-block;width:16px;height:16px;margin-right:6px;background-size:contain;background-position:50%;background-repeat:no-repeat}[data-dui-0-122-1~="dui-modal-footer-action-text"]{border-top:1px solid transparent;border-bottom:1px solid transparent}[data-dui-0-122-1~="dui-modal-footer-action"]:hover [data-dui-0-122-1~="dui-modal-footer-action-text"]{border-bottom-color:var(--text-strong,rgba(0,0,0,.64))}[data-dui-0-122-1~="dui-modal-footer-ok"]{margin-left:16px}[data-dui-0-122-1~="dui-modal-basic"]{width:340px;padding-top:40px}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-title"]{text-align:center;font-weight:600;margin-bottom:16px}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-content"]{font-size:16px;min-height:auto;line-height:24px;text-align:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer"]{margin-top:44px}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer"]>[data-dui-0-122-1~="dui-button"]{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer-column"]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer-column"] [data-dui-0-122-1~="dui-modal-footer-ok"]{margin-left:0}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer-column"]>[data-dui-0-122-1~="dui-button"]{-webkit-box-flex:0;-webkit-flex:none;-ms-flex:none;flex:none;height:40px}[data-dui-0-122-1~="dui-modal-basic"] [data-dui-0-122-1~="dui-modal-footer-column"]>[data-dui-0-122-1~="dui-button"]:not(:last-child){margin-top:12px}`);
  Modal_1.default.confirm = confirm_1.default;
  var _default = Modal$1.default = Modal_1.default;
  const styles = {
    "link-wrapper-invite": "_link-wrapper-invite_5urtx_1",
    "input-wrapper-invite": "_input-wrapper-invite_5urtx_11",
    "input-link-invite": "_input-link-invite_5urtx_20",
    "copy-text-invite": "_copy-text-invite_5urtx_32"
  };
  function LinkBar(props) {
    const inputEl = React.useRef(null);
    return /* @__PURE__ */ React__default.default.createElement("div", { className: styles["link-wrapper-invite"] }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles["input-wrapper-invite"] }, /* @__PURE__ */ React__default.default.createElement("input", { id: "bar", ref: inputEl, className: styles["input-link-invite"], type: "text", value: props.url })), /* @__PURE__ */ React__default.default.createElement(
      "button",
      {
        className: styles["copy-text-invite"],
        "data-clipboard-target": "#bar",
        onClick: () => {
          var _a;
          return ((_a = inputEl.current) == null ? void 0 : _a.value) && props.onCopy(inputEl.current.value);
        }
      },
      "\u590D\u5236\u94FE\u63A5"
    ));
  }
  function LiveDialog(props) {
    const [qrcodeUrl, setQrcodeUrl] = React.useState("");
    React.useEffect(() => {
      QRCode__default.default.make(props.shareUrl, {
        iconURL: props.qrCodeIconUrl
      }).then(setQrcodeUrl);
    }, []);
    return /* @__PURE__ */ React__default.default.createElement(
      _default,
      {
        visible: true,
        maskClosable: true,
        style: {
          width: 320,
          background: "#1d1d1d"
        },
        maskStyle: { backgroundColor: "unset" },
        footer: null,
        onClose: props.onClose
      },
      /* @__PURE__ */ React__default.default.createElement("div", { style: { textAlign: "center", color: "white", width: "100%" } }, /* @__PURE__ */ React__default.default.createElement("h1", { style: { margin: 0, fontSize: 18, textAlign: "center" } }, "\u9080\u8BF7\u597D\u53CB\u52A0\u5165"), /* @__PURE__ */ React__default.default.createElement("img", { src: qrcodeUrl, style: { width: 200, height: 200, marginTop: 20, marginBottom: 0 } }), /* @__PURE__ */ React__default.default.createElement(LinkBar, { onCopy: props.onCopy, url: props.shareUrl }), props.onStartLive && /* @__PURE__ */ React__default.default.createElement(
        _default$1,
        {
          type: "primary",
          style: { marginTop: 14, marginBottom: 16, width: 240 },
          onClick: () => {
            var _a;
            props.onClose();
            (_a = props.onStartLive) == null ? void 0 : _a.call(props);
          }
        },
        "\u5F00\u59CB\u8FDC\u7A0B\u6F14\u793A"
      ))
    );
  }
  const users = "_users_elhel_1";
  const open = "_open_elhel_37";
  const more = "_more_elhel_24";
  const style = {
    users,
    "users-line": "_users-line_elhel_6",
    "user-face-container": "_user-face-container_elhel_9",
    "user-face": "_user-face_elhel_9",
    "more-wrapper": "_more-wrapper_elhel_24",
    open,
    more,
    "more-table-wrapper": "_more-table-wrapper_elhel_128",
    "more-table-title-wrapper": "_more-table-title-wrapper_elhel_142",
    "more-table": "_more-table_elhel_128",
    "user-image": "_user-image_elhel_185",
    "user-name": "_user-name_elhel_199",
    "keyframes-logo": "_keyframes-logo_elhel_1"
  };
  const ANONYMOUS = "-1";
  const anonymous = {
    uid: ANONYMOUS,
    name: ANONYMOUS,
    userPic: audience
  };
  function filterUsers(users2) {
    const map = {};
    return users2.filter((user) => {
      if (map[user.uid])
        return false;
      map[user.uid] = true;
      return true;
    });
  }
  function MemberAvator(props) {
    const [visible, setVisible] = React.useState(false);
    const [inviteModalVisiable, setInviteModalVisiable] = React.useState(false);
    const memberList2 = filterUsers(props.memberList);
    const list = memberList2.length ? memberList2.slice(0, 3) : [anonymous];
    const dropContent = /* @__PURE__ */ React__default.default.createElement(
      LiveMemberDialog,
      __spreadProps(__spreadValues({}, props), {
        onClose: () => setVisible(false),
        onInviteUser: () => setInviteModalVisiable(true),
        memberList: memberList2
      })
    );
    return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(
      _default$4,
      {
        visible,
        onVisibleChange: setVisible,
        dropContent,
        alignment: "auto",
        containerStyle: { padding: "15px 0" }
      },
      /* @__PURE__ */ React__default.default.createElement("div", { className: style.users }, /* @__PURE__ */ React__default.default.createElement("div", { className: style["users-line"] }, list.map((item) => /* @__PURE__ */ React__default.default.createElement("div", { className: style["user-face-container"], key: item.uid, id: item.uid }, /* @__PURE__ */ React__default.default.createElement(TooltipPackage, { title: item.name, overlayStyle: { whiteSpace: "normal", maxWidth: "300px" } }, /* @__PURE__ */ React__default.default.createElement("img", { className: style["user-face"], src: item.userPic }))))), /* @__PURE__ */ React__default.default.createElement("div", { className: style["more-wrapper"] }, /* @__PURE__ */ React__default.default.createElement("div", { className: style.more })))
    ), inviteModalVisiable && /* @__PURE__ */ React__default.default.createElement(
      LiveDialog,
      {
        shareUrl: props.shareUrl,
        qrCodeIconUrl: props.qrCodeIconUrl,
        onClose: () => setInviteModalVisiable(false),
        onCopy: props.onCopy
      }
    ));
  }
  function LiveBtn(props) {
    const [dropDownVisible, setDropDownVisible] = React.useState(false);
    const [modalVisible, setModalVisible] = React.useState(false);
    const createShow = () => {
      props.liveManager.createShow((result) => {
        if (result.error) {
          _default.confirm({
            content: "\u4FE1\u606F\u672A\u6210\u529F\u62C9\u53D6\uFF0C\u8BF7\u5237\u65B0\u540E\u91CD\u65B0\u53D1\u8D77\u8FDC\u7A0B\u6F14\u793A\u3002",
            onOk: () => {
              window.location.reload();
            },
            okText: "\u7ACB\u5373\u5237\u65B0",
            cancelText: null
          });
          return;
        }
        props.liveManager.masterEnter();
        props.liveManager.event.on(ClientReady, () => {
          setModalVisible(true);
        });
      });
    };
    const dropContent = /* @__PURE__ */ React__default.default.createElement(Panel, { onClose: () => setDropDownVisible(false), containerStyle: { width: 320, textAlign: "center" } }, /* @__PURE__ */ React__default.default.createElement("h1", { style: { marginTop: 36, marginBottom: 0, fontSize: 18, textAlign: "center" } }, "\u6B22\u8FCE\u4F7F\u7528\u8FDC\u7A0B\u6F14\u793A"), /* @__PURE__ */ React__default.default.createElement("p", { style: { marginTop: 8, marginBottom: 0, fontSize: 12, textAlign: "center" } }, "\u624B\u673A\u7535\u8111\u540C\u6B65\u89C2\u770B\uFF0C\u8BED\u97F3\u8BA8\u8BBA\u66F4\u52A0\u9AD8\u6548"), /* @__PURE__ */ React__default.default.createElement(_default$1, { type: "primary", style: { marginTop: 30, marginBottom: 16, width: 240 }, onClick: createShow }, "\u9080\u8BF7\u597D\u53CB"));
    const handleBtnClick = () => {
      if (props.hasRoom) {
        setModalVisible(true);
        return;
      }
      setDropDownVisible(true);
    };
    return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, modalVisible && /* @__PURE__ */ React__default.default.createElement(
      LiveDialog,
      {
        shareUrl: props.liveManager.shareUrl,
        qrCodeIconUrl: props.qrCodeIconUrl,
        onClose: () => setModalVisible(false),
        onCopy: props.onCopy,
        onStartLive: props.onStartLive
      }
    ), /* @__PURE__ */ React__default.default.createElement(
      _default$4,
      {
        visible: !props.hasRoom && dropDownVisible,
        onVisibleChange: setDropDownVisible,
        dropContent,
        alignment: "center",
        containerStyle: { padding: "15px 0" }
      },
      /* @__PURE__ */ React__default.default.createElement("div", { className: styles$2.btnWrap, onClick: handleBtnClick, "aria-label": "\u8FDC\u7A0B\u6F14\u793A" }, /* @__PURE__ */ React__default.default.createElement(TooltipPackage, { title: "\u8FDC\u7A0B\u6F14\u793A" }, props.hasRoom ? /* @__PURE__ */ React__default.default.createElement(SvgRemotepresentationLight24, { style: { color: "#0188FB" } }) : /* @__PURE__ */ React__default.default.createElement(SvgRemotepresentationLight24, null)))
    ));
  }
  const isTencentMeeting = steamerBrowserutils.getCookie("open_theme_id") === "tencent_meeting";
  class PresentationToolbar extends React.Component {
    constructor() {
      super(...arguments);
      this.state = {
        memberList: [],
        memberCount: 0,
        isLive: false,
        hasRoom: false
      };
      this.updateMember = () => {
        const liveManager = this.props.liveDelegate;
        this.setState({
          memberCount: liveManager.memberCount,
          memberList: liveManager.memberList
        });
      };
      this.updateLiveUI = () => {
        const liveManager = this.props.liveDelegate;
        const { state } = liveManager.liveInfo;
        this.setState({
          isLive: state === LiveState.OnAir,
          hasRoom: state === LiveState.OnAir || state === LiveState.Pause
        });
      };
      this.onAllowFlipChanged = () => {
        this.setState({});
      };
      this.tencentMeetingEndPlayListener = () => {
        this.handleEndPlay();
      };
      this.handleEndPlay = () => {
        if (!isTencentMeeting) {
          this.props.eventCallBack(IPlayerEvent.Exit, true);
          return;
        }
        const { docType, padId, liveDelegate } = this.props;
        handleEndPlayTencentMeeting(docType, padId, liveDelegate.docID);
      };
      this.handleLastPage = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Prev, true);
      };
      this.handleNextPage = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Next, true);
      };
      this.handleFullscreen = (event) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.FullScreen, true);
      };
      this.syncWithMaster = () => {
        this.props.eventCallBack(IPlayerEvent.SyncWithMaster, true);
      };
      this.handleZoomIn = () => {
        this.props.eventCallBack(IPlayerEvent.ZoomIn, true);
      };
      this.handleZoomOut = () => {
        this.props.eventCallBack(IPlayerEvent.ZoomOut, true);
      };
      this.showQuitBtn = () => {
        if (!isTencentMeeting)
          return true;
        return canEnterEditPage();
      };
      this.onFlipChanged = (isAllowFlip) => {
        if (!this.props.liveDelegate)
          return;
        this.props.liveDelegate.setAllowFlip(isAllowFlip);
        this.props.eventCallBack(IPlayerEvent.AudienceFlip, isAllowFlip);
        this.forceUpdate();
      };
    }
    initEvent() {
      const liveManager = this.props.liveDelegate;
      if (!liveManager)
        return;
      liveManager.event.on(MemberChanged, this.updateMember);
      liveManager.event.on(LiveStateChanged, this.updateLiveUI);
      liveManager.event.on(AllowFlipChanged, this.onAllowFlipChanged);
    }
    offEvent() {
      const liveManager = this.props.liveDelegate;
      if (!liveManager)
        return;
      liveManager.event.off(MemberChanged, this.updateMember);
      liveManager.event.off(LiveStateChanged, this.updateLiveUI);
      liveManager.event.off(AllowFlipChanged, this.onAllowFlipChanged);
      window.removeEventListener("live-components:tencent-meeting-end-play", this.tencentMeetingEndPlayListener);
    }
    componentDidMount() {
      this.initEvent();
      this.updateMember();
      this.updateLiveUI();
      window.addEventListener("live-components:tencent-meeting-end-play", this.tencentMeetingEndPlayListener);
    }
    componentWillUnmount() {
      this.offEvent();
    }
    liveBarConfig() {
      const { config } = this.props;
      const result = {
        showClock: lodash.get(config, "showClock", false),
        pageTurnerBtn: lodash.get(config, "pageTurnerBtn", true),
        userListBtn: lodash.get(config, "userListBtn", true),
        remoteShowBtn: lodash.get(config, "remoteShowBtn", true),
        laserBtn: lodash.get(config, "laserBtn", true),
        annotationBtn: lodash.get(config, "annotationBtn", false),
        zoom: lodash.get(config, "zoomIn", false) || lodash.get(config, "zoomOut", false),
        toggleViewBtn: lodash.get(config, "toggleViewBtn", false),
        openPresentViewWinBtn: lodash.get(config, "openPresentViewWinBtn", false),
        fullScreenBtn: lodash.get(config, "fullScreenBtn", true),
        quitBtn: lodash.get(config, "quitBtn", true)
      };
      return result;
    }
    get isRoleMaster() {
      return this.props.role === LiveRoleType.Master;
    }
    renderConfig() {
      const cfg = [
        [
          {
            key: "showClock",
            fixed: "left",
            render: () => /* @__PURE__ */ React__default.default.createElement(Clock, null)
          }
        ],
        [
          {
            key: "pageTurnerBtn",
            fixed: "left",
            render: () => {
              const { currentPage = 0, pageCount = 1, liveDelegate } = this.props;
              const pageText = `${Math.min(currentPage + 1, pageCount)} / ${pageCount}`;
              const allowFlip = this.isRoleMaster || liveDelegate.allowFlip();
              return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, allowFlip && /* @__PURE__ */ React__default.default.createElement(IconButton, { title: $t("\u4E0A\u4E00\u9875"), icon: /* @__PURE__ */ React__default.default.createElement(SvgArrowLeftLight24, null), onClick: this.handleLastPage }), /* @__PURE__ */ React__default.default.createElement("div", { "aria-label": "\u9875\u6570", className: styles$2.pageInfo }, pageText), allowFlip && /* @__PURE__ */ React__default.default.createElement(IconButton, { title: $t("\u4E0B\u4E00\u9875"), icon: /* @__PURE__ */ React__default.default.createElement(SvgArrowRightLight24, null), onClick: this.handleNextPage }));
            }
          }
        ],
        [
          {
            key: "remoteShowBtn",
            fixed: "left",
            condition: !this.state.isLive,
            render: () => {
              var _a;
              return /* @__PURE__ */ React__default.default.createElement(
                LiveBtn,
                {
                  hasRoom: this.state.hasRoom,
                  liveManager: this.props.liveDelegate,
                  qrCodeIconUrl: (_a = this.props.config) == null ? void 0 : _a.qrCodeIconUrl,
                  onCopy: (url) => this.props.eventCallBack(IPlayerEvent.CopyLink, true, url),
                  onStartLive: () => this.props.liveDelegate.liveWillBegin()
                }
              );
            }
          },
          {
            key: "userListBtn",
            fixed: "left",
            condition: this.state.isLive,
            render: () => {
              var _a;
              return /* @__PURE__ */ React__default.default.createElement(
                MemberAvator,
                {
                  hideAllowFlip: !this.isRoleMaster,
                  allowFlip: this.props.liveDelegate.allowFlip(),
                  onFlipChanged: this.onFlipChanged,
                  memberList: this.state.memberList,
                  memberCount: this.state.memberCount,
                  speakerName: this.props.liveDelegate.masterName,
                  shareUrl: this.props.liveDelegate.shareUrl,
                  qrCodeIconUrl: (_a = this.props.config) == null ? void 0 : _a.qrCodeIconUrl,
                  onCopy: (url) => this.props.eventCallBack(IPlayerEvent.CopyLink, true, url)
                }
              );
            }
          }
        ],
        [
          {
            key: "zoom",
            fixed: "left",
            render: () => /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(IconButton, { title: "\u9875\u9762\u653E\u5927", icon: /* @__PURE__ */ React__default.default.createElement(SvgZoominLight24, null), onClick: this.handleZoomIn }), /* @__PURE__ */ React__default.default.createElement(IconButton, { title: "\u9875\u9762\u7F29\u5C0F", icon: /* @__PURE__ */ React__default.default.createElement(SvgZoomoutLight24, null), onClick: this.handleZoomOut }))
          }
        ],
        [
          {
            key: "laserBtn",
            condition: this.isRoleMaster,
            title: this.props.laserTurnOn ? $t("\u5173\u95ED\u6FC0\u5149\u7B14") : $t("\u6253\u5F00\u6FC0\u5149\u7B14"),
            icon: this.props.laserTurnOn ? /* @__PURE__ */ React__default.default.createElement(SvgLaserpointerOffLight24, null) : /* @__PURE__ */ React__default.default.createElement(SvgLaserpointerOnLight24, null),
            onClick: () => this.props.eventCallBack(IPlayerEvent.Laser, !this.props.laserTurnOn)
          },
          {
            key: "annotationBtn",
            condition: this.isRoleMaster,
            title: this.props.enableAnnotation ? $t("\u5173\u95ED\u6279\u6CE8") : $t("\u6253\u5F00\u6279\u6CE8"),
            icon: this.props.enableAnnotation ? /* @__PURE__ */ React__default.default.createElement(SvgMarkSwitchLight24, { style: { color: "#0188FB" } }) : /* @__PURE__ */ React__default.default.createElement(SvgMarkSwitchLight24, null),
            onClick: () => this.props.eventCallBack("Annotation", !this.props.enableAnnotation)
          }
        ],
        [
          {
            key: "toggleViewBtn",
            condition: this.isRoleMaster,
            title: this.props.isPresenterView ? $t("\u5207\u6362\u89C2\u4F17\u89C6\u56FE") : $t("\u5207\u6362\u5907\u6CE8\u89C6\u56FE"),
            icon: /* @__PURE__ */ React__default.default.createElement(SvgViewswitchLight24, null),
            onClick: () => this.props.eventCallBack(IPlayerEvent.ToggleView, !this.props.isPresenterView)
          },
          {
            key: "openPresentViewWinBtn",
            condition: this.isRoleMaster,
            title: $t("\u5907\u6CE8\u89C6\u56FE"),
            icon: /* @__PURE__ */ React__default.default.createElement(SvgNotesviewLight24, null),
            onClick: () => this.props.eventCallBack(IPlayerEvent.OpenPresenterViewWindow)
          },
          {
            key: "fullScreenBtn",
            title: this.props.isFullScreen ? $t("\u9000\u51FA\u5168\u5C4F") : $t("\u8FDB\u5165\u5168\u5C4F"),
            icon: this.props.isFullScreen ? /* @__PURE__ */ React__default.default.createElement(SvgBottombarOutFill, null) : /* @__PURE__ */ React__default.default.createElement(SvgBottombarFill, null),
            onClick: () => this.props.eventCallBack(IPlayerEvent.FullScreen, !this.props.isFullScreen)
          }
        ],
        [
          {
            key: "quitBtn",
            fixed: "right",
            condition: this.isRoleMaster && this.showQuitBtn(),
            title: $t("\u9000\u51FA\u6F14\u793A"),
            icon: /* @__PURE__ */ React__default.default.createElement(SvgTurnoffLight24, null),
            onClick: this.handleEndPlay
          }
        ]
      ];
      return cfg;
    }
    render() {
      const liveBarCfg = this.liveBarConfig();
      const renderConfig2 = filter(this.renderConfig(), (item) => liveBarCfg[item.key]);
      return /* @__PURE__ */ React__default.default.createElement(
        Toolbar,
        {
          config: renderConfig2,
          placement: this.props.placement,
          className: this.props.className,
          style: this.props.style,
          autoTranslucent: this.props.autoTranslucent,
          fold: this.props.fold
        }
      );
    }
  }
  initLocales();
  return PresentationToolbar;
});
//# sourceMappingURL=presentation-toolbar.js.map
